// App.js
import React, { useState, useEffect , useRef , useCallback  , matchPath } from 'react';

import Webcam from "react-webcam";


import { removeBackground } from "@imgly/background-removal";

import { match } from 'path-to-regexp'; 
import Slider from "react-slick";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams ,
  useNavigate,
  Navigate ,
  useLocation
} from 'react-router-dom';
import './App.css';
import './navbar.css';
import './home.css';
import './orders.css';
import './services.css';
import './mtnsyriatel.css';
import './servpage.css';
import './tran.css';
import './sguinup.css';
import './notifications.css';
import './SignupSuccess.css';
import './star.css';
import './agent-style.css';
import './passc.css';

import './ProductDetails.css';
import './cart.css';


import './ChangePasswordForm.css';


import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const STATUS_COLORS = {
    'مكتمل': '#28a745', // أخضر
    'ملغي': '#dc3545',   // أحمر
    'قيد المعالجة': '#ffc107', // أصفر/برتقالي
};



function LoadingSpinner({ text = "جاري تحميل البيانات..." }) {
  return (
    <div className="text-center text-primary mt-5">
      <i className="fas fa-spinner fa-spin fa-2x"></i>
      <p className="mt-2">{text}</p>
    </div>
  );
}




function MessageDisplay({ message, type, onClose }) {
  useEffect(() => {
    if (!message) return; // ✅ الشرط هنا بدل قبل الـ hook

    const timer = setTimeout(() => {
      onClose();
    }, 1000);

    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null; // ✅ الشرط صار بعد الـ hook

  const typeClass = type === "success" ? "message-success" : "message-error";
  const iconClass =
    type === "success" ? "fas fa-check-circle" : "fas fa-times-circle";

  return (
    <div className={`message-display ${typeClass}`}>
      <div className="message-content">
        <i className={`${iconClass} message-icon`}></i>
        <p className="message-text">{message}</p>
        <button className="message-close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
}

const useOneSignalAuto = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(function (OneSignal) {
        OneSignal.init({
          appId: "e132ef57-77dd-46eb-8250-9d3c056a4d67",
          safari_web_id: "web.onesignal.auto.4345f3b9-0648-4376-838e-008c1d802430",
          notifyButton: {
            enable: true,
          },
          autoRegister: true, // ⚡ هنا يطلب الإذن تلقائيًا
        });
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);
};




function ImageWithSkeleton({ src, alt }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="skeleton-wrapper">
      {!loaded && <div className="skeleton skeleton-img"></div>}
      <img
      loading="lazy"
        src={src}
        alt={alt}
        className={`service-image ${loaded ? "visible" : "hidden"}`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}



function NewsTicker({ text }) {
  return (
    <div style={{
      backgroundColor: 'rgb(26 65 135)',
      color: 'rgb(255 255 255)',
      fontWeight: 'bold',
      padding: '10px 0',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      
    }}>
      <marquee direction="right" scrollamount="5">{text}</marquee>
    </div>
  );
}





function Navbar() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [accountNumber, setAccountNumber] = React.useState('');
  const [accountname, setAccountname] = React.useState('');
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [cartCount, setCartCount] = React.useState(0); // عدد المنتجات
const isGuest = localStorage.getItem("isGuest") === "true" ||!localStorage.getItem("authToken");
 

 const handleConfirmCityChange = () => {
    if (!selectedCityModal) {
      alert("❌ يجب اختيار مدينة");
      return;
    }

    // حفظ المدينة في localStorage
    localStorage.setItem("city", selectedCityModal);

  const token = localStorage.getItem("authToken");
  // إرسال إلى PHP
  fetch(`https://syriacash.app/new/api.php?save_city&token=${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cityId: selectedCityModal }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) console.log("تم تحديث الكوكيز");
      })
      .catch(console.log);

    // تحديث اسم المدينة المعروض
    const cityObj = cities.find(c => c.id === Number(selectedCityModal));
    setCityName(cityObj ? cityObj.name : "غير محددة");

    // إغلاق المودال
    setShowChangeCityModal(false);
  };






const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    },
    modal: {
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      width: '90%',
      maxWidth: '400px',
      textAlign: 'center',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      position: 'relative',
    },
    title: { fontSize: '20px', fontWeight: '700', marginBottom: '10px' },
    subtitle: { fontSize: '14px', color: '#555', marginBottom: '20px' },
    select: {
      width: '100%',
      padding: '10px',
      fontSize: '16px',
      borderRadius: '6px',
      border: '1px solid #ccc',
      marginBottom: '20px',
    },
    button: {
      backgroundColor: '#28a745',
      color: '#fff',
      padding: '10px 20px',
      borderRadius: '6px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '600',
    },
  };

const [cityName, setCityName] = React.useState(""); // اسم المدينة المعروضة
const [cities, setCities] = React.useState([]);     // قائمة المدن من API
const [showChangeCityModal, setShowChangeCityModal] = React.useState(false); // للتحكم في ظهور المودال
const [selectedCityModal, setSelectedCityModal] = React.useState(""); // المدينة المختارة داخل المودال

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };


React.useEffect(() => {
  fetch("https://syriacash.app/new/api.php?cities") // رابط API الخاص بالمدن
    .then(res => res.json())
    .then(data => {
      if (data.success && Array.isArray(data.cities)) {
        setCities(data.cities); // تخزين المدن في state
      } else {
        console.error("خطأ في جلب المدن:", data.message);
      }
    })
    .catch(err => console.error("خطأ في fetch المدن:", err));
}, []);




React.useEffect(() => {
  const cityId = localStorage.getItem("city");

  if (cityId) {
    fetch(`https://syriacash.app/new/api.php?cityInfo&id=${cityId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.city) {
          setCityName(data.city.name);
          setSelectedCityModal(data.city.id);
        }
      })
      .catch(() => setCityName("غير محددة"));
  }
}, []);

  
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('accountNumber');
    localStorage.removeItem('accountname');
    localStorage.removeItem("isGuest");
       localStorage.setItem("out", "1");
    navigate('/', { replace: true });
  };

  React.useEffect(() => {
    setAccountNumber(localStorage.getItem('accountNumber') || 'غير متوفر');
    setAccountname(localStorage.getItem('accountname') || 'غير متوفر');
  const loggedIn = localStorage.getItem("loggedIn");
    const token = localStorage.getItem('authToken');

 

  
 

    if (!token || !loggedIn) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname + window.location.search);
      navigate('/', { replace: true });

      return;
    }

    // جلب الإشعارات
    const fetchNotifications = () => {
      fetch(`https://syriacash.app/new/api.php?notifications&token=${token}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
        .then(res => res.json())
        .then(data => {
          if (!data.success && data.message === 'التوكين غير موجود بقواعد البيانات') {
            localStorage.removeItem('authToken');
            localStorage.removeItem('accountNumber');
            localStorage.removeItem('accountname');
            
            navigate('/', { replace: true });
            return;
          }
          if (data.success && data.unreadCount !== undefined) {
            setUnreadCount(data.unreadCount);
            
          }
        })
        .catch(() => setUnreadCount(0));
    };

    // جلب عدد المنتجات من API
    const fetchCartCount = () => {
      fetch(`https://syriacash.app/new/api.php?cartCount&token=${token}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
        .then(res => {
          if (!res.ok) throw new Error('فشل جلب عدد المنتجات');
          return res.json();
        })
        .then(data => {
          if (data.success && typeof data.count === 'number') {
            setCartCount(data.count);
          } else {
            setCartCount(0);
          }
        })
        .catch(() => setCartCount(0));
    };

    fetchNotifications();
    fetchCartCount();

    const intervalId = setInterval(() => {
      fetchNotifications();
      fetchCartCount();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [navigate]);

  const goToNotifications = () => {
    navigate('/notifications');
  };

  return (
    <>
      <nav className="navbar-custom">
        <div className="account-info">
          <img 
            src={localStorage.getItem('userAvatar') || '/images/user.png'} 
            alt="الصورة الشخصية"
            className="account-image"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />


        <div className="account-details">
  {isGuest ? (
    <div
      className="account-text-label"
      style={{ cursor: "pointer", color: "#ffffffff" }}
      onClick={handleLogout}
    >
 <i className="fas fa-lock"></i> دخول

    </div>
  ) : (
    <>
      <div className="account-text-label">{accountname}</div>
      <div className="account-number">{accountNumber}</div>
    </>
  )}
</div>


        </div>
<div
  style={{
    flex: 1,              // لتوسيط الاسم
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '11px',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',           // المسافة بين الأيقونة والاسم
  }}
  onClick={() => setShowChangeCityModal(true)}
  title="اضغط لتغيير المدينة"
>
  {/* أيقونة الموقع */}
  <i className="fas fa-map-marker-alt" style={{ color: '#ffd700' }}></i>
  
  {/* اسم المدينة */}
  <span>{cityName || "تحميل المدينة..."}</span>
</div>

        <div className="nav-icons" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div
            className="cart-icon-container"
            style={{ cursor: 'pointer', position: 'relative' }}
            onClick={() => navigate('/cart')}
            title="المنتجات"
          >
            <i className="fas fa-shopping-cart"></i>
            {cartCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-5px',
                right: '-10px',
                backgroundColor: 'green',
                color: 'white',
                borderRadius: '50%',
                padding: '2px 6px',
                fontSize: '12px',
                fontWeight: 'bold',
                minWidth: '18px',
                textAlign: 'center',
                lineHeight: '14px',
                boxSizing: 'border-box'
              }}>
                {cartCount}
              </span>
            )}
          </div>

          <div
            className="bell-icon-container"
            style={{ position: 'relative', cursor: 'pointer' }}
            onClick={goToNotifications}
          >
            <i className="fas fa-bell"></i>
            {unreadCount > 0 && (
              <span
                className="notification-badge"
                style={{
                  position: 'absolute',
                  top: '-5px',
                 
                  backgroundColor: 'red',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '2px 6px',
                  fontSize: '12px'
                }}
              >
                {unreadCount}
              </span>
            )}
          </div>

          <i className="fas fa-bars" onClick={toggleSidebar} style={{ cursor: 'pointer' }}></i>
        </div>
      </nav>

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <h3>سوريا كاش</h3>
        <ul>
          <li><a href="/home"><i className="fas fa-home"></i> الرئيسية</a></li>

      <li><a href="/referra"><i className="fas fa-user-friends"></i> الربح من الاحالات</a></li>

          <li><a href="/passc"><i className="fas fa-user"></i> الملف الشخصي</a></li>
          <li><a href="/spuort"><i className="fas fa-headset"></i>الدعم الفني</a></li>
       

<li>
  {isGuest ? (
    <a onClick={handleLogout}>
      <i className="fas fa-sign-in-alt"></i> تسجيل الدخول
    </a>
  ) : (
    <a onClick={handleLogout}>
      <i className="fas fa-sign-out-alt"></i> تسجيل خروج
    </a>
  )}
</li>



        </ul>
      </div>

      {sidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}


{showChangeCityModal && (
  <div style={styles.overlay}>
    <div style={styles.modal}>
      {/* زر الإغلاق */}
      <button
        onClick={() => setShowChangeCityModal(false)}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          fontSize: '24px',
          cursor: 'pointer',
        }}
        aria-label="إغلاق"
      >
        &times;
      </button>

      <h2 style={styles.title}>تغيير المدينة</h2>
      <p style={styles.subtitle}>اختر المدينة الجديدة</p>

      <select
        value={selectedCityModal}
        onChange={(e) => setSelectedCityModal(e.target.value)}
        style={styles.select}
      >
        <option value="">-- اختر مدينة --</option>
        {cities.map(city => (
          <option key={city.id} value={city.id}>{city.name}</option>
        ))}
      </select>

      <button
        style={styles.button}
        onClick={handleConfirmCityChange}
      >
        تأكيد
      </button>
    </div>
  </div>
)}

      
    </>
  );
}





function BottomNavbar() {
  const location = useLocation();

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <nav className="navbar bottom-navbar">
        <div className="container-fluid d-flex justify-content-around align-items-center">
          {/* رابط طلباتي - **هنا تم التصحيح** */}
          <Link
            className={`nav-link ${isActiveLink('/oreder') ? 'active' : ''}`} // <--- هذه الخاصية يجب أن تكون داخل وسم <Link>
            to="/oreder"
            data-nav-item="orders"
          >
            <i className="fas fa-file-alt"></i> <span>طلباتي</span>
          </Link>

          {/* رابط الرصيد - **هنا تم التصحيح** */}
          <Link
            className={`nav-link ${isActiveLink('/tranmony') ? 'active' : ''}`}
            to="/tranmony"
            data-nav-item="balance"
          >
            <i className="fas fa-wallet"></i> <span>الرصيد</span>
          </Link>

          {/* رابط التحويل - **هنا تم التصحيح** */}
          <Link
            className={`nav-link ${isActiveLink('/shop') ? 'active' : ''}`}
            to="/shop"
            data-nav-item="transfer"
          >
            <i className="fas fa-box-open"></i> <span>الماركيت</span>
          </Link>

          {/* رابط الخدمات - **هنا تم التصحيح** */}
     <Link
  className={`nav-link ${isActiveLink('/ofers') ? 'active' : ''}`}
  to="/ofers"
  data-nav-item="services"
>
  <i className="fas fa-tags" style={{ color: 'red' }}></i> 
  <span>العروض</span>
</Link>

          {/* رابط الرئيسية (الهوم) - **هنا تم التصحيح** */}
          <Link
            className={`nav-link ${isActiveLink('/home') ? 'active' : ''}`}
            to="/home"
            data-nav-item="home"
          >
            <i className="fas fa-home"></i> <span>الرئيسية</span>
          </Link>
        </div>
      </nav>
    </>
  );
}

function NotificationCard({ notification, onMarkAsRead }) {
    return (
        <div className={`notification-card ${!notification.isRead ? 'unread' : ''}`}>
            <div className="notification-content">
                <div className="notification-icon-wrapper">
                    {/* أيقونة الإشعار: يمكن تغييرها بناءً على نوع الإشعار */}
                    {notification.type === 'success' && <i className="fas fa-check-circle notification-icon success-icon"></i>}
                    {notification.type === 'info' && <i className="fas fa-info-circle notification-icon info-icon"></i>}
                    {notification.type === 'warning' && <i className="fas fa-exclamation-triangle notification-icon warning-icon"></i>}
                    {notification.type === 'error' && <i className="fas fa-times-circle notification-icon error-icon"></i>}
                    {!notification.type && <i className="fas fa-bell notification-icon default-icon"></i>} {/* أيقونة افتراضية */}
                </div>
                <div className="notification-details">
                    <h6 className="notification-title">{notification.title}</h6>
                    <p className="notification-message">{notification.message}</p>
                    <span className="notification-date">{notification.date}</span>
                </div>
            </div>
            {!notification.isRead && (
                <button className="mark-read-btn" onClick={() => onMarkAsRead(notification.id)}>
                    <i className="fas fa-eye-slash"></i>
                </button>
            )}
        </div>
    );
}



function NotificationsPage() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchNotifications = async () => {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('authToken');
            if (!token) {
                setError('لم يتم العثور على التوكين، يرجى تسجيل الدخول مجدداً.');
                setLoading(false);
                return;
            }

            // التوكين في رابط الـ GET (مع ترميز مناسب)
            const API_ENDPOINT_NOTIFICATIONS = `https://syriacash.app/new/api.php?get_notifications&token=${encodeURIComponent(token)}`;

            try {
                const response = await fetch(API_ENDPOINT_NOTIFICATIONS, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                const rawNotifications = data.notifications || data;

                const formattedNotifications = rawNotifications.map(notif => ({
                    id: notif.id || notif.notification_id,
                    title: notif.title || notif.notification_title,
                    message: notif.message || notif.notification_message,
                    date: notif.date || notif.created_at,
                    isRead: notif.is_read === 1 || notif.is_read === true,
                    type: notif.type || 'info',
                }));

                setNotifications(formattedNotifications);

            } catch (err) {
                setError(err.message || "فشل في جلب الإشعارات.");
            } finally {
                setLoading(false);
            }
        };

        fetchNotifications();
    }, []);

    const handleMarkAsRead = async (id) => {
        setNotifications(prev =>
            prev.map(notif => (notif.id === id ? { ...notif, isRead: true } : notif))
        );

        const token = localStorage.getItem('authToken');
        if (!token) {
            console.error('No token found for marking notification as read.');
            return;
        }

        const API_ENDPOINT_MARK_READ = `https://syriacash.app/new/api.php?mark_notification_read&token=${encodeURIComponent(token)}`;

        try {
            const response = await fetch(API_ENDPOINT_MARK_READ, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ notification_id: id, status: 'read' })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `Failed to mark notification as read: ${response.status}`);
            }

            console.log(`Notification ${id} marked as read successfully on server.`);

        } catch (err) {
            console.error("Error marking notification as read:", err);
            setNotifications(prev =>
                prev.map(notif => (notif.id === id ? { ...notif, isRead: false } : notif))
            );
            setError("فشل في تحديث حالة الإشعار.");
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <h4 className="page-header-title">الإشعارات</h4>

            {loading ? (
                <div className="text-center text-primary mt-5">
                    <i className="fas fa-spinner fa-spin fa-2x"></i>
                    <p className="mt-2">جاري تحميل الإشعارات...</p>
                </div>
            ) : error ? (
                <div className="text-center text-danger mt-5">
                    <i className="fas fa-exclamation-circle fa-2x"></i>
                    <p className="mt-2">{error}</p>
                </div>
            ) : notifications.length === 0 ? (
                <div className="text-center text-muted mt-5">
                    <i className="fas fa-bell-slash fa-2x"></i>
                    <p className="mt-2">لا توجد إشعارات حالياً.</p>
                </div>
            ) : (
                <div className="notifications-list">
                    {notifications.map(notification => (
                        <NotificationCard
                            key={notification.id}
                            notification={notification}
                            onMarkAsRead={handleMarkAsRead}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}




function AddRestaurantForm({ onClose, onAdded }) {
  const [form, setForm] = useState({
    name: '', address: '', managerName: '', phone: '', description: '',
  });
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.address || !form.managerName || !form.phone) {
      setMsg('يرجى تعبئة جميع الحقول المطلوبة'); return;
    }
    setLoading(true);
    setMsg('');
    const token = localStorage.getItem('authToken');
    const accountNumber = localStorage.getItem('accountNumber'); // ✅ رقم الحساب لتحديد المالك لاحقاً

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    fd.append('ownerAccount', accountNumber); // ✅ يُخزَّن مع المطعم للمطابقة لاحقاً
    if (logo) fd.append('logo', logo);

    try {
      const res = await fetch(`https://syriacash.app/new/api.php?add_restaurant_request&token=${token}`, {
        method: 'POST', body: fd,
      });
      const data = await res.json();
      if (data.success) {
        setSuccessMsg('✅ تم إرسال طلبك بنجاح! سيتم التواصل معك بعد المراجعة.');
        setTimeout(() => { onAdded && onAdded(); onClose(); }, 2500);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch { setMsg('خطأ في الاتصال بالخادم'); }
    finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', outline: 'none',
    background: '#fafafa', marginBottom: '10px', fontFamily: 'inherit',
    boxSizing: 'border-box',
  };
  const labelStyle = { fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '4px', display: 'block' };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: '100%', maxWidth: '480px',
        borderRadius: '20px 20px 0 0', padding: '20px',
        maxHeight: '90vh', overflowY: 'auto', direction: 'rtl',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>🍽 أضف مطعمك</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        {successMsg && (
          <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px', padding: '12px 14px', marginBottom: '14px', color: '#2e7d32', fontWeight: '700', fontSize: '14px' }}>
            {successMsg}
          </div>
        )}

        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', color: '#795548' }}>
          ⏳ سيتم مراجعة الطلب من الإدارة، وبعد الموافقة سيتم ربط حسابك بالمطعم تلقائياً حسب رقم حسابك الحالي، وستتمكن من إدارة الوجبات بنفسك.
        </div>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>اسم المطعم *</label>
          <input style={inputStyle} placeholder="مثال: مطعم الشام" value={form.name} onChange={e => set('name', e.target.value)} required />

          <label style={labelStyle}>عنوان المطعم *</label>
          <input style={inputStyle} placeholder="الحي، الشارع..." value={form.address} onChange={e => set('address', e.target.value)} required />

          <label style={labelStyle}>اسم المدير *</label>
          <input style={inputStyle} placeholder="اسم صاحب/مدير المطعم" value={form.managerName} onChange={e => set('managerName', e.target.value)} required />

          <label style={labelStyle}>رقم التواصل *</label>
          <input style={inputStyle} placeholder="09xxxxxxxx" value={form.phone} onChange={e => set('phone', e.target.value)} required />

          <label style={labelStyle}>وصف عام / الوجبات التي يقدمها المطعم</label>
          <textarea style={{ ...inputStyle, minHeight: '90px', resize: 'vertical' }}
            placeholder="مثال: مشاوي، بيتزا، شاورما..." 
            value={form.description} onChange={e => set('description', e.target.value)} />

          <label style={labelStyle}>📷 شعار المطعم (اختياري)</label>
          <input type="file" accept="image/*" style={{ ...inputStyle, padding: '8px' }}
            onChange={e => setLogo(e.target.files[0] || null)} />

          {msg && <p style={{ color: '#e63946', fontSize: '13px', marginBottom: '10px', fontWeight: '700' }}>⚠️ {msg}</p>}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#aaa' : 'linear-gradient(135deg,#1a4187,#2563eb)',
            color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px',
            fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? '⏳ جاري الإرسال...' : '🚀 إرسال طلب إضافة المطعم'}
          </button>
        </form>
      </div>
    </div>
  );
}




function AddOfferForm({ myPlaces, offer, onClose, onSaved }) {
  const isEditing = !!offer?.id;

  const [selectedPlace, setSelectedPlace] = useState(
    isEditing ? (offer.source_id || '') : (myPlaces.length === 1 ? myPlaces[0].id : '')
  );
  const [name, setName] = useState(offer?.name || '');
  const [price, setPrice] = useState(offer?.price || '');
  const [oldPrice, setOldPrice] = useState(offer?.old_price || '');
  const [description, setDescription] = useState(offer?.description || '');
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const token = localStorage.getItem('authToken');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isEditing && (!selectedPlace || !name || !price)) {
      setMsg('يرجى اختيار المتجر/المطعم وتعبئة اسم المنتج والسعر');
      return;
    }
    if (isEditing && (!name || !price)) {
      setMsg('يرجى تعبئة اسم المنتج والسعر');
      return;
    }

    setLoading(true);
    setMsg('');

    const fd = new FormData();
    fd.append('name', name);
    fd.append('price', price);
    fd.append('oldPrice', oldPrice);
    fd.append('description', description);
    if (imageFile) fd.append('image', imageFile);

    try {
      let res;
      if (isEditing) {
        fd.append('offerId', offer.id);
        res = await fetch(`https://syriacash.app/new/api.php?update_offer&token=${token}`, {
          method: 'POST', body: fd,
        });
      } else {
        const place = myPlaces.find(p => String(p.id) === String(selectedPlace));
        fd.append('sourceId', place.id);
        fd.append('sourceType', place.type); // 'store' أو 'restaurant'
        res = await fetch(`https://syriacash.app/new/api.php?add_offer&token=${token}`, {
          method: 'POST', body: fd,
        });
      }

      const data = await res.json();

      if (data.success) {
        onSaved(data.offer); // ✅ نفس اسم الـ prop المستخدم بـ OfersShop
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch (err) {
      console.error('AddOfferForm error:', err);
      setMsg('خطأ في الاتصال بالخادم');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box',
  };
  const labelStyle = { fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '4px', display: 'block' };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: '100%', maxWidth: '460px',
        borderRadius: '20px 20px 0 0', padding: '20px',
        maxHeight: '90vh', overflowY: 'auto', direction: 'rtl',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>
            {isEditing ? '✏️ تعديل العرض' : '🏷 أضف عرضك'}
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* اختيار المتجر/المطعم فقط عند الإضافة (مش عند التعديل) */}
          {!isEditing && (
            <>
              <label style={labelStyle}>اختر المتجر / المطعم *</label>
              <select
                style={inputStyle}
                value={selectedPlace}
                onChange={(e) => setSelectedPlace(e.target.value)}
                required
              >
                <option value="">-- اختر --</option>
                {myPlaces.map(p => (
                  <option key={`${p.type}-${p.id}`} value={p.id}>
                    {p.type === 'restaurant' ? '🍽 ' : '🏪 '}{p.name}
                  </option>
                ))}
              </select>
            </>
          )}

          <label style={labelStyle}>اسم المنتج / العرض *</label>
          <input style={inputStyle} placeholder="مثال: بيتزا عائلية" value={name} onChange={e => setName(e.target.value)} required />

          <label style={labelStyle}>السعر بعد الخصم *</label>
          <input style={inputStyle} type="number" placeholder="السعر الحالي" value={price} onChange={e => setPrice(e.target.value)} required />

          <label style={labelStyle}>السعر قبل الخصم (اختياري)</label>
          <input style={inputStyle} type="number" placeholder="لإظهار نسبة الخصم" value={oldPrice} onChange={e => setOldPrice(e.target.value)} />

          <label style={labelStyle}>الوصف</label>
          <textarea style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
            placeholder="تفاصيل العرض..." value={description} onChange={e => setDescription(e.target.value)} />

          <label style={labelStyle}>📷 صورة المنتج {isEditing && '(اتركها فارغة للإبقاء على الصورة الحالية)'}</label>
          <input type="file" accept="image/*" style={{ ...inputStyle, padding: '8px' }}
            onChange={e => setImageFile(e.target.files[0] || null)} />

          {msg && <p style={{ color: '#e63946', fontSize: '13px', marginBottom: '10px', fontWeight: '700' }}>⚠️ {msg}</p>}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#aaa' : 'linear-gradient(135deg,#1a4187,#2563eb)',
            color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px',
            fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? '⏳ جاري الإرسال...' : (isEditing ? '💾 حفظ التعديلات' : '🚀 نشر العرض')}
          </button>
        </form>
      </div>
    </div>
  );
}




function MyRestaurantPanel() {
  const [restaurant, setRestaurant] = useState(null);
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showMealForm, setShowMealForm] = useState(false);
  const [editingMeal, setEditingMeal] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });

  const token = localStorage.getItem('authToken');
  const accountNumber = localStorage.getItem('accountNumber');

  const fetchMyRestaurant = () => {
    setLoading(true);
    // ✅ الباك اند يطابق ownerAccount المخزّن مع accountNumber ليتأكد أنه صاحب المطعم
    fetch(`https://syriacash.app/new/api.php?my_restaurant&token=${token}&account=${accountNumber}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.restaurant) {
          setRestaurant(data.restaurant);
          setMeals(data.meals || []);
        } else {
          setError(data.message || 'لا تملك مطعماً مرتبطاً بحسابك بعد');
        }
      })
      .catch(() => setError('فشل الاتصال بالخادم'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchMyRestaurant(); }, []);

  const handleDeleteMeal = (mealId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذه الوجبة؟')) return;
    fetch(`https://syriacash.app/new/api.php?delete_meal&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mealId, account: accountNumber }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMeals(prev => prev.filter(m => m.id !== mealId));
          setMessage({ text: '🗑️ تم حذف الوجبة', type: 'success' });
        } else {
          setMessage({ text: data.message || 'فشل الحذف', type: 'error' });
        }
      });
  };

  if (loading) return <LoadingSpinner text="جاري التحقق من بيانات المطعم..." />;

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px', direction: 'rtl' }}>
        <div style={{ fontSize: '40px', marginBottom: '10px' }}>🔒</div>
        <p style={{ color: '#888', fontWeight: '700' }}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '14px', marginTop: '70px', direction: 'rtl', maxWidth: '700px', margin: '70px auto 0' }}>
      <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '800' }}>🍽 {restaurant.name}</h2>
          <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#888' }}>{meals.length} وجبة مضافة</p>
        </div>
        <button onClick={() => { setEditingMeal(null); setShowMealForm(true); }} style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '12px', padding: '10px 16px',
          fontSize: '13px', fontWeight: '700', cursor: 'pointer',
        }}>＋ أضف وجبة</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: '14px' }}>
        {meals.map(meal => (
          <div key={meal.id} style={{ background: '#fff', borderRadius: '14px', padding: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <img src={meal.image ? `https://syriacash.app/images/${meal.image}` : 'https://via.placeholder.com/200x120?text=وجبة'}
              alt={meal.name} style={{ width: '100%', height: '110px', objectFit: 'cover', borderRadius: '10px' }} />
            <p style={{ fontWeight: '700', margin: '8px 0 2px' }}>{meal.name}</p>
            <p style={{ fontSize: '13px', color: '#1a4187', fontWeight: '700' }}>{meal.price} ₺</p>
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <button onClick={() => { setEditingMeal(meal); setShowMealForm(true); }}
                style={{ flex: 1, padding: '6px', background: '#f0f4ff', color: '#1a4187', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                ✏️ تعديل
              </button>
              <button onClick={() => handleDeleteMeal(meal.id)}
                style={{ flex: 1, padding: '6px', background: '#ffecec', color: '#c0392b', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                🗑️ حذف
              </button>
            </div>
          </div>
        ))}
      </div>

      {showMealForm && (
        <MealForm
          meal={editingMeal}
          onClose={() => setShowMealForm(false)}
          onSaved={(saved) => {
            setMeals(prev => editingMeal
              ? prev.map(m => m.id === saved.id ? saved : m)
              : [...prev, saved]);
            setShowMealForm(false);
          }}
        />
      )}
    </div>
  );
}

function MealForm({ meal, onClose, onSaved }) {
  const [name, setName] = useState(meal?.name || '');
  const [price, setPrice] = useState(meal?.price || '');
  const [description, setDescription] = useState(meal?.description || '');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const token = localStorage.getItem('authToken');
  const accountNumber = localStorage.getItem('accountNumber');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !price) { setMsg('يرجى تعبئة اسم الوجبة والسعر'); return; }
    setLoading(true);

    const fd = new FormData();
    fd.append('name', name);
    fd.append('price', price);
    fd.append('description', description);
    fd.append('account', accountNumber); // ✅ للتحقق من الصلاحية بالباك اند
    if (meal?.id) fd.append('mealId', meal.id);
    if (image) fd.append('image', image);

    try {
      const endpoint = meal?.id ? 'update_meal' : 'add_meal';
      const res = await fetch(`https://syriacash.app/new/api.php?${endpoint}&token=${token}`, {
        method: 'POST', body: fd,
      });
      const data = await res.json();
      if (data.success) {
        onSaved(data.meal);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch { setMsg('خطأ في الاتصال بالخادم'); }
    finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box',
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10001, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', width: '100%', maxWidth: '440px', borderRadius: '20px 20px 0 0', padding: '20px', direction: 'rtl', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '14px' }}>
          <h3 style={{ margin: 0 }}>{meal ? '✏️ تعديل وجبة' : '➕ إضافة وجبة'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <input style={inputStyle} placeholder="اسم الوجبة" value={name} onChange={e => setName(e.target.value)} />
          <input style={inputStyle} type="number" placeholder="السعر" value={price} onChange={e => setPrice(e.target.value)} />
          <textarea style={{ ...inputStyle, minHeight: '70px' }} placeholder="وصف الوجبة" value={description} onChange={e => setDescription(e.target.value)} />
          <input style={{ ...inputStyle, padding: '8px' }} type="file" accept="image/*" onChange={e => setImage(e.target.files[0])} />
          {msg && <p style={{ color: 'red', fontSize: '13px' }}>{msg}</p>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#1a4187', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: '700', cursor: 'pointer' }}>
            {loading ? 'جاري الحفظ...' : '💾 حفظ'}
          </button>
        </form>
      </div>
    </div>
  );
}








function BankServices() {
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const tabs = ["الكل", "الاتصالات", "الانترنت", "الفواتير"];
  const location = useLocation();

  // استخراج التصنيف من رابط URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");

    if (categoryParam && tabs.includes(categoryParam)) {
      setActiveTab(categoryParam);
    }
  }, [location.search]);

  // تحميل البيانات
  useEffect(() => {
    const token = localStorage.getItem("authToken");

    fetch("https://syriacash.app/new/api.php?services", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("فشل تحميل الخدمات");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setServices(data);
        } else {
          setError("خطأ في تنسيق البيانات");
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const filteredServices =
    activeTab === "الكل"
      ? services
      : services.filter((service) => service.category === activeTab);

  return (
    <div className="services-container">
      {/* التبويبات */}
      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* تحميل أو خطأ */}
      {loading ? (
        <div>جاري تحميل الخدمات...</div>
      ) : error ? (
        <div style={{ color: "red" }}>{error}</div>
      ) : (
        <div className="cards-grid">
          {filteredServices.map((service, i) => (
            <a
              href={service.link}
              key={i}
              className="service-card-link"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="service-card">
                <div className="card-icon">
                  {/* ✅ تحميل تدريجي للصورة */}
             <ImageWithSkeleton
  key={service.id + '-' + service.icon} 
  src={`https://syriacash.app/images/${service.icon}`}
  alt={service.title}
/>

                </div>
                <div className="card-title">{service.title}</div>
                <div className="card-desc">{service.description}</div>
                <div className="card-heart">
                  <i
                    className={`fas fa-heart ${
                      service.favorite ? "red" : ""
                    }`}
                  ></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}




function BankShop() {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [productLoading, setProductLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [quantity, setQuantity] = useState(1);
  const observer = useRef();
  const location = useLocation();


useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "shop" }),
  }).catch(() => {});
}, []);




  
  // ✅ تحميل التصنيفات
  useEffect(() => {
    fetch("https://syriacash.app/new/api.php?categories")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setCategories([{ id: "all", name: "الكل" }, ...data]);
        } else {
          setError("خطأ في جلب التصنيفات");
        }
      })
      .catch(() => setError("فشل الاتصال بالخادم"))
      .finally(() => setLoading(false));
  }, []);

  // ✅ تحديث التصنيف من رابط الصفحة
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");
    if (categoryParam) setActiveTab(categoryParam);
  }, [location.search]);

  // ✅ تحميل المنتجات (يدعم التمرير التدريجي)
  const loadProducts = useCallback(
    async (reset = false) => {
      setProductLoading(true);
      try {
        const currentPage = reset ? 1 : page;
        const categoryParam = activeTab === "الكل" ? "all" : activeTab;

        const res = await fetch(
          `https://syriacash.app/new/api.php?shops&id=${categoryParam}&page=${currentPage}&limit=20`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          const newProducts = result.data;
          setServices((prev) =>
            reset || currentPage === 1 ? newProducts : [...prev, ...newProducts]
          );
          setHasMore(currentPage < (result.total_pages || 1));
        } else {
          setHasMore(false);
          // إعادة تعيين المنتجات إذا لم تكن هناك نتائج
          if (reset || currentPage === 1) {
            setServices([]);
          }
        }
      } catch {
        setError("فشل تحميل المنتجات");
        // إعادة تعيين المنتجات في حالة الخطأ
        if (reset || page === 1) {
          setServices([]);
        }
      } finally {
        setProductLoading(false);
      }
    },
    [activeTab, page]
  );

  // ✅ إعادة التحميل عند تغيير التصنيف
  useEffect(() => {
    // إعادة تعيين الحالة عند تغيير التبويب
    setPage(1);
    setServices([]); // ✅ مهم: إفراغ المنتجات قبل التحميل الجديد
    setHasMore(true);
    loadProducts(true);
  }, [activeTab]);

  // ✅ المراقب لتحميل المزيد عند التمرير للأسفل
  const lastProductRef = useCallback(
    (node) => {
      if (productLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !productLoading) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [productLoading, hasMore]
  );

  // ✅ تحميل المنتجات عند تغيير الصفحة
  useEffect(() => {
    if (page > 1 && hasMore && !productLoading) {
      loadProducts(false);
    }
  }, [page]);

  // ✅ فلترة البحث (مع جلب من السيرفر)
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchTerm.trim() === "") {
        // 🔹 إذا البحث فارغ → عرض المنتجات حسب التصنيف الحالي
        setPage(1);
        setServices([]); // ✅ إعادة تعيين قبل التحميل الجديد
        loadProducts(true);
        return;
      }

      // 🔹 بحث مباشر من السيرفر
      setProductLoading(true);
      try {
        const res = await fetch(
          `https://syriacash.app/new/api.php?search=${encodeURIComponent(searchTerm)}`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          setServices(result.data);
          setHasMore(false); // لا داعي للتحميل التدريجي في البحث
        } else {
          setServices([]);
        }
      } catch {
        setError("فشل الاتصال أثناء البحث");
        setServices([]);
      } finally {
        setProductLoading(false);
      }
    }, 500); // ⏳ تأخير نصف ثانية بعد التوقف عن الكتابة

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // ✅ فتح تفاصيل المنتج
  const openProductModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const handleAddToCart = async () => {
    if (!selectedProduct?.id) return;
    setCartLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?addToCart&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: selectedProduct.id,
            quantity,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setMessage({ text: "✅ تمت إضافة المنتج إلى السلة!", type: "success" });
        setQuantity(1);
        setModalOpen(false);
      } else {
        setMessage({ text: data.message || "فشل الإضافة", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setCartLoading(false);
    }
  };

  // ✅ فلترة البحث (للحالات المحلية)
  const filteredServices = services.filter((service) =>
    (service.name || service.title || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // ✅ معالجة تغيير التبويب
  const handleTabChange = (tabId) => {
    // إعادة تعيين كل شيء قبل التغيير
    setActiveTab(tabId);
    setSearchTerm(""); // ✅ مسح البحث عند الضغط على أي تبويب
    setPage(1);
    setServices([]);
    setHasMore(true);
  };

  return (
    <>
      {/* ✅ عرض الرسالة في الأعلى */}
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      <div className="services-container">
        {/* 🔍 البحث */}
        <div className="search-box">
          <input
            type="text"
            placeholder="ابحث عن منتج..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </div>

        <p style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
          ⚠️ الخدمة متاحة حالياً في مدينة إدلب
        </p>




        {/* 🔹 عرض التصنيفات */}
        {loading ? (
          <div>⏳ تحميل التصنيفات...</div>
        ) : (
          <div className="tabs">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`tab-btn ${activeTab === cat.id ? "active" : ""}`}
                onClick={() => handleTabChange(cat.id)}
              >
                {cat.name}
              </button>
            ))}
          </div>
        )}

        {/* 🔹 عرض المنتجات */}
        {productLoading && services.length === 0 ? (
          <p>⏳ جاري تحميل المنتجات...</p>
        ) : filteredServices.length === 0 ? (
          <p style={{ textAlign: "center" }}>لا توجد منتجات</p>
        ) : (
          <div className="cards-grid">
            {filteredServices.map((service, i) => {
              const isLast = i === filteredServices.length - 1;
              return (
                <div
                  ref={isLast ? lastProductRef : null}
                  key={`${service.id}-${activeTab}`} // ✅ إضافة activeTab للمفتاح لمنع التكرار
                  className="service-card"
                  onClick={() => openProductModal(service)}
                >
                  <ImageWithSkeleton
                    src={`https://syriacash.app/images/${service.image}`}
                    alt={service.name}
                  />
                  <div className="card-info">
                    <div className="card-title">{service.name}</div>
                    <div className="card-price">{service.price} ₺</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {productLoading && services.length > 0 && (
          <p style={{ textAlign: "center" }}>⏳ تحميل المزيد...</p>
        )}

        {/* ✅ المودال */}
        {modalOpen && selectedProduct && (
          <div className="modal-overlay" onClick={() => setModalOpen(false)}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="modal-close"
                onClick={() => setModalOpen(false)}
              >
                ✖
              </button>

              <div className="modal-body">
                <h2>{selectedProduct.name}</h2>

                {/* ✅ صورة كبيرة */}
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                  <img
                    src={`https://syriacash.app/images/${selectedProduct.image}`}
                    alt={selectedProduct.name}
                    style={{
                      width: "100%",
                      maxWidth: "110px",
                      borderRadius: "15px",
                      boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>

                <p>
                  <strong>السعر:</strong> {selectedProduct.price} ₺
                </p>

                <div className="quantity-control">
                  <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                  <span>{quantity}</span>
                  <button
                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  >
                    −
                  </button>
                </div>

                <button
                  className="add-to-cart-btn"
                  onClick={handleAddToCart}
                  disabled={cartLoading}
                >
                  {cartLoading ? "⏳ جاري الإضافة..." : "🛒 أضف إلى السلة"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}





function OfersShop() {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [productLoading, setProductLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [quantity, setQuantity] = useState(1);
  const observer = useRef();
  const location = useLocation();

  // ✅ أماكن المستخدم (متاجر + مطاعم يملكها) وفورم إضافة/تعديل العرض
  const [myPlaces, setMyPlaces] = useState([]);
  const [showAddOffer, setShowAddOffer] = useState(false);
  const [editingOffer, setEditingOffer] = useState(null);
  const [deletingOfferId, setDeletingOfferId] = useState(null);


useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "offers" }), // غيّر الاسم حسب القسم: store, fastfood, university...
  }).catch(() => {});
}, []);





  // ✅ جلب أماكن المستخدم (متاجر + مطاعم) التي يملكها
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    fetch(`https://syriacash.app/new/api.php?my_places&token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.places)) {
          setMyPlaces(data.places);
        }
      })
      .catch(() => {});
  }, []);

  // ✅ تحميل التصنيفات
  useEffect(() => {
    fetch("https://syriacash.app/new/api.php?categoriesofers")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setCategories([{ id: "all", name: "الكل" }, ...data]);
        } else {
          setError("خطأ في جلب التصنيفات");
        }
      })
      .catch(() => setError("فشل الاتصال بالخادم"))
      .finally(() => setLoading(false));
  }, []);

  // ✅ تحديث التصنيف من رابط الصفحة
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");
    if (categoryParam) setActiveTab(categoryParam);
  }, [location.search]);

  // ✅ تحميل المنتجات (يدعم التمرير التدريجي)
  const loadProducts = useCallback(
    async (reset = false) => {
      setProductLoading(true);
      try {
        const currentPage = reset ? 1 : page;
        const categoryParam = activeTab === "الكل" ? "all" : activeTab;

        const res = await fetch(
          `https://syriacash.app/new/api.php?shopsofer&id=${categoryParam}&page=${currentPage}&limit=20`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          const newProducts = result.data;
          setServices((prev) =>
            reset || currentPage === 1 ? newProducts : [...prev, ...newProducts]
          );
          setHasMore(currentPage < (result.total_pages || 1));
        } else {
          setHasMore(false);
          // إعادة تعيين المنتجات إذا لم تكن هناك نتائج
          if (reset || currentPage === 1) {
            setServices([]);
          }
        }
      } catch {
        setError("فشل تحميل المنتجات");
        // إعادة تعيين المنتجات في حالة الخطأ
        if (reset || page === 1) {
          setServices([]);
        }
      } finally {
        setProductLoading(false);
      }
    },
    [activeTab, page]
  );

  // ✅ إعادة التحميل عند تغيير التصنيف
  useEffect(() => {
    // إعادة تعيين الحالة عند تغيير التبويب
    setPage(1);
    setServices([]); // ✅ مهم: إفراغ المنتجات قبل التحميل الجديد
    setHasMore(true);
    loadProducts(true);
  }, [activeTab]);

  // ✅ المراقب لتحميل المزيد عند التمرير للأسفل
  const lastProductRef = useCallback(
    (node) => {
      if (productLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !productLoading) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [productLoading, hasMore]
  );

  // ✅ تحميل المنتجات عند تغيير الصفحة
  useEffect(() => {
    if (page > 1 && hasMore && !productLoading) {
      loadProducts(false);
    }
  }, [page]);

  // ✅ فلترة البحث (مع جلب من السيرفر)
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchTerm.trim() === "") {
        // 🔹 إذا البحث فارغ → عرض المنتجات حسب التصنيف الحالي
        setPage(1);
        setServices([]); // ✅ إعادة تعيين قبل التحميل الجديد
        loadProducts(true);
        return;
      }

      // 🔹 بحث مباشر من السيرفر
      setProductLoading(true);
      try {
        const res = await fetch(
          `https://syriacash.app/new/api.php?search=${encodeURIComponent(searchTerm)}`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          setServices(result.data);
          setHasMore(false); // لا داعي للتحميل التدريجي في البحث
        } else {
          setServices([]);
        }
      } catch {
        setError("فشل الاتصال أثناء البحث");
        setServices([]);
      } finally {
        setProductLoading(false);
      }
    }, 500); // ⏳ تأخير نصف ثانية بعد التوقف عن الكتابة

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // ✅ فتح تفاصيل المنتج
  const openProductModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const handleAddToCart = async () => {
    if (!selectedProduct?.id) return;
    setCartLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?addToCartofer&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: selectedProduct.id,
            quantity,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setMessage({ text: "✅ تمت إضافة المنتج إلى السلة!", type: "success" });
        setQuantity(1);
        setModalOpen(false);
      } else {
        setMessage({ text: data.message || "فشل الإضافة", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setCartLoading(false);
    }
  };

  // ✅ حذف عرض
  const handleDeleteOffer = async (offerId) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا العرض؟")) return;
    setDeletingOfferId(offerId);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(`https://syriacash.app/new/api.php?delete_offer&token=${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ offerId }),
      });
      const data = await res.json();
      if (data.success) {
        setServices((prev) => prev.filter((s) => s.id !== offerId));
        setMessage({ text: "🗑️ تم حذف العرض بنجاح", type: "success" });
      } else {
        setMessage({ text: data.message || "فشل حذف العرض", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setDeletingOfferId(null);
    }
  };

  // ✅ فلترة البحث (للحالات المحلية)
  const filteredServices = services.filter((service) =>
    (service.name || service.title || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // ✅ معالجة تغيير التبويب
  const handleTabChange = (tabId) => {
    // إعادة تعيين كل شيء قبل التغيير
    setActiveTab(tabId);
    setSearchTerm(""); // ✅ مسح البحث عند الضغط على أي تبويب
    setPage(1);
    setServices([]);
    setHasMore(true);
  };

  return (
    <>
      {/* ✅ عرض الرسالة في الأعلى */}
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      <div className="services-container">
        {/* ✅ زر إضافة عرض - يظهر فقط لمن يملك متجراً أو مطعماً */}
        {myPlaces.length > 0 && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <button
              onClick={() => { setEditingOffer(null); setShowAddOffer(true); }}
              style={{
                background: "linear-gradient(135deg,#1a4187,#2563eb)",
                color: "#fff",
                border: "none",
                borderRadius: "20px",
                padding: "9px 16px",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              🏷 ＋ أضف عرضك
            </button>
          </div>
        )}

        {showAddOffer && (
          <AddOfferForm
            myPlaces={myPlaces}
            offer={editingOffer}
            onClose={() => setShowAddOffer(false)}
            onSaved={(saved) => {
              setServices((prev) => {
                const exists = prev.some((s) => s.id === saved.id);
                return exists
                  ? prev.map((s) => (s.id === saved.id ? { ...s, ...saved } : s))
                  : [saved, ...prev];
              });
              setShowAddOffer(false);
              setMessage({ text: "✅ تم حفظ العرض بنجاح", type: "success" });
            }}
          />
        )}

        {/* 🔍 البحث */}
        <div className="search-box">
          <input
            type="text"
            placeholder="ابحث عن منتج..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </div>

        <p style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
          هذا القسم خاص بالعروض  
        </p>

        {/* 🔹 عرض التصنيفات */}
        {loading ? (
          <div>⏳ تحميل التصنيفات...</div>
        ) : (
          <div className="tabs">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`tab-btn ${activeTab === cat.id ? "active" : ""}`}
                onClick={() => handleTabChange(cat.id)}
              >
                {cat.name}
              </button>
            ))}
          </div>
        )}

        {/* 🔹 عرض المنتجات */}
        {productLoading && services.length === 0 ? (
          <p>⏳ جاري تحميل المنتجات...</p>
        ) : filteredServices.length === 0 ? (
          <p style={{ textAlign: "center" }}>لا توجد منتجات</p>
        ) : (
          <div className="cards-grid">
            {filteredServices.map((service, i) => {
              const isLast = i === filteredServices.length - 1;
              const isMyOffer =
                myPlaces.length > 0 &&
                myPlaces.some(
                  (p) =>
                    String(p.id) === String(service.source_id) &&
                    p.type === service.source_type
                );

              return (
                <div
                  ref={isLast ? lastProductRef : null}
                  key={`${service.id}-${activeTab}`} // ✅ إضافة activeTab للمفتاح لمنع التكرار
                  className="service-card"
                  style={{ position: "relative" }}
                  onClick={() => openProductModal(service)}
                >
                  {/* ✅ أزرار تعديل/حذف - تظهر فقط لصاحب العرض */}
                  {isMyOffer && (
                    <div
                      style={{
                        position: "absolute", top: "8px", left: "8px", zIndex: 2,
                        display: "flex", gap: "6px",
                      }}
                    >
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setEditingOffer(service);
                          setShowAddOffer(true);
                        }}
                        style={{
                          background: "#1a4187", color: "#fff", border: "none",
                          borderRadius: "8px", padding: "4px 10px", fontSize: "11px",
                          fontWeight: "700", cursor: "pointer",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                        }}
                      >
                        ✏️
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleDeleteOffer(service.id);
                        }}
                        disabled={deletingOfferId === service.id}
                        style={{
                          background: deletingOfferId === service.id ? "#888" : "#c0392b",
                          color: "#fff", border: "none",
                          borderRadius: "8px", padding: "4px 10px", fontSize: "11px",
                          fontWeight: "700",
                          cursor: deletingOfferId === service.id ? "wait" : "pointer",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                        }}
                      >
                        {deletingOfferId === service.id ? "⏳" : "🗑️"}
                      </button>
                    </div>
                  )}

                  <ImageWithSkeleton
                    src={`https://syriacash.app/images/${service.image}`}
                    alt={service.name}
                  />
                  <div className="card-info">
                    <div className="card-title">{service.name}</div>

                    {/* ✅ اسم الشركة */}
                    {service.nameco && (
                      <div className="supplier-name">{service.nameco}</div>
                    )}

                    <div className="card-price-wrapper">
                      {service.old_price && (
                        <span className="old-price">{service.old_price} ₺</span>
                      )}
                      <span className="new-price">{service.price} ₺</span>

                      {service.old_price && (
                        <span className="discount-badge">
                          %{Math.round(
                            ((service.old_price - service.price) / service.old_price) * 100
                          )} -
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {productLoading && services.length > 0 && (
          <p style={{ textAlign: "center" }}>⏳ تحميل المزيد...</p>
        )}

        {/* ✅ المودال */}
        {modalOpen && selectedProduct && (
          <div className="modal-overlay" onClick={() => setModalOpen(false)}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="modal-close"
                onClick={() => setModalOpen(false)}
              >
                ✖
              </button>

              <div className="modal-body">
                <h2>{selectedProduct.name}</h2>

                {/* ✅ صورة كبيرة */}
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                  <img
                    src={`https://syriacash.app/images/${selectedProduct.image}`}
                    alt={selectedProduct.name}
                    style={{
                      width: "100%",
                      maxWidth: "110px",
                      borderRadius: "15px",
                      boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>

          <p>
  <strong>السعر:</strong>{" "}
  {selectedProduct.old_price && (
    <span className="old-price" style={{ marginLeft: "8px" }}>
      {selectedProduct.old_price} ₺
    </span>
  )}
  <span className="new-price">{selectedProduct.price} ₺</span>
</p>

{selectedProduct.old_price && (
  <p style={{ color: "red", fontWeight: "bold" }}>
    خصم{" "}
    {Math.round(
      ((selectedProduct.old_price - selectedProduct.price) /
        selectedProduct.old_price) *
        100
    )}
    %
  </p>
)}
                <div className="quantity-control">
                  <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                  <span>{quantity}</span>
                  <button
                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  >
                    −
                  </button>
                </div>

                <button
                  className="add-to-cart-btn"
                  onClick={handleAddToCart}
                  disabled={cartLoading}
                >
                  {cartLoading ? "⏳ جاري الإضافة..." : "🛒 أضف إلى السلة"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}




function AddServiceRequestForm({ onClose, onAdded }) {
  const [form, setForm] = useState({
    name: '', category: '', address: '', managerName: '', phone: '', description: '',
  });
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.category || !form.phone) {
      setMsg('يرجى تعبئة اسم الخدمة والتصنيف ورقم الهاتف'); return;
    }
    setLoading(true);
    setMsg('');
    const token = localStorage.getItem('authToken');

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (logo) fd.append('logo', logo);

    try {
      const res = await fetch(`https://syriacash.app/new/api.php?add_service_request&token=${token}`, {
        method: 'POST', body: fd,
      });
      const data = await res.json();
      if (data.success) {
        setSuccessMsg('✅ تم إرسال طلبك بنجاح! سيتم مراجعته من الإدارة.');
        setTimeout(() => { onAdded && onAdded(); onClose(); }, 2500);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch { setMsg('خطأ في الاتصال بالخادم'); }
    finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', marginBottom: '10px',
    boxSizing: 'border-box', fontFamily: 'inherit', background: '#fafafa',
  };
  const labelStyle = { fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '4px', display: 'block' };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: '100%', maxWidth: '480px',
        borderRadius: '20px 20px 0 0', padding: '20px',
        maxHeight: '90vh', overflowY: 'auto', direction: 'rtl',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>🛠 أضف خدمتك</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        {successMsg && (
          <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px', padding: '12px 14px', marginBottom: '14px', color: '#2e7d32', fontWeight: '700', fontSize: '14px' }}>
            {successMsg}
          </div>
        )}

        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', color: '#795548' }}>
          ⏳ سيتم مراجعة الطلب من الإدارة، وبعد الموافقة ستتمكن من إدارة خدماتك وأسعارك بنفسك.
        </div>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>اسم الخدمة / صاحب الخدمة *</label>
          <input style={inputStyle} placeholder="مثال: خدمة غسيل السيارات - أبو محمد" value={form.name} onChange={e => set('name', e.target.value)} required />

          <label style={labelStyle}>نوع الخدمة *</label>
          <input style={inputStyle} placeholder="مثال: غسيل سيارات، سباكة، كهرباء، تنظيف..." value={form.category} onChange={e => set('category', e.target.value)} required />

          <label style={labelStyle}>العنوان / منطقة العمل</label>
          <input style={inputStyle} placeholder="الحي، المنطقة" value={form.address} onChange={e => set('address', e.target.value)} />

          <label style={labelStyle}>اسم المسؤول</label>
          <input style={inputStyle} placeholder="اسمك" value={form.managerName} onChange={e => set('managerName', e.target.value)} />

          <label style={labelStyle}>رقم التواصل *</label>
          <input style={inputStyle} placeholder="09xxxxxxxx" value={form.phone} onChange={e => set('phone', e.target.value)} required />

          <label style={labelStyle}>وصف الخدمة</label>
          <textarea style={{ ...inputStyle, minHeight: '90px', resize: 'vertical' }}
            placeholder="اشرح خدماتك بشكل عام..." value={form.description} onChange={e => set('description', e.target.value)} />

          <label style={labelStyle}>📷 صورة/شعار (اختياري)</label>
          <input type="file" accept="image/*" style={{ ...inputStyle, padding: '8px' }}
            onChange={e => setLogo(e.target.files[0] || null)} />

          {msg && <p style={{ color: '#e63946', fontSize: '13px', marginBottom: '10px', fontWeight: '700' }}>⚠️ {msg}</p>}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#aaa' : 'linear-gradient(135deg,#1a4187,#2563eb)',
            color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px',
            fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? '⏳ جاري الإرسال...' : '🚀 إرسال طلب إضافة الخدمة'}
          </button>
        </form>
      </div>
    </div>
  );
}



function ServicesPage() {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const myAccount = localStorage.getItem("accountNumber");

  const fetchProviders = () => {
    setLoading(true);
    fetch("https://syriacash.app/new/api.php?services_custom")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setProviders(data);
        else setError("خطأ في تنسيق البيانات");
      })
      .catch(() => setError("فشل الاتصال بالخادم"))
      .finally(() => setLoading(false));
  };


useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "service" }),
  }).catch(() => {});
}, []);




  useEffect(() => { fetchProviders(); }, []);

  return (
    <div className="services-container">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <button onClick={() => setShowAddForm(true)} style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '20px', padding: '9px 16px',
          fontSize: '13px', fontWeight: '700', cursor: 'pointer',
        }}>
          🛠 ＋ أضف خدمتك
        </button>
      </div>

      {showAddForm && (
        <AddServiceRequestForm onClose={() => setShowAddForm(false)} onAdded={() => {}} />
      )}

      <p style={{ textAlign: 'center', color: '#666', fontWeight: 'bold' }}>
        🛠 خدمات متنوعة مقدمة من أفراد ومختصين محليين
      </p>

      {loading ? (
        <div>جاري تحميل الخدمات...</div>
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : providers.length === 0 ? (
        <p style={{ textAlign: 'center' }}>لا توجد خدمات حالياً</p>
      ) : (
        <div className="cards-grid">
          {providers.map(p => {
            const isOwner = myAccount && p.owner_account && String(p.owner_account) === String(myAccount);
            return (
              <div key={p.id} style={{ position: 'relative' }}>
                {isOwner && (
                  <>
                    <span style={{
                      position: 'absolute', top: '10px', left: '10px', zIndex: 2,
                      background: '#1a4187', color: '#fff', fontSize: '11px', fontWeight: '700',
                      padding: '4px 10px', borderRadius: '20px', boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    }}>
                      👑 خدمتك
                    </span>
                    <button
                      onClick={(e) => { e.preventDefault(); window.location.href = '/myservice'; }}
                      style={{
                        position: 'absolute', bottom: '10px', left: '10px', zIndex: 2,
                        background: '#28a745', color: '#fff', border: 'none',
                        borderRadius: '10px', padding: '6px 12px', fontSize: '12px',
                        fontWeight: '700', cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                      }}
                    >
                      ✏️ إدارة الخدمة
                    </button>
                  </>
                )}

                <Link to={`/serviceprovider/${p.id}`} className="service-card-link" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div className="service-card">
                    <div className="card-icon">
                      <ImageWithSkeleton src={p.image} alt={p.title} />
                    </div>
                    <div className="card-title">{p.title}</div>
                    <div className="card-desc">{p.category}</div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}





function ServiceProviderPage() {
  const { id } = useParams();
  const [provider, setProvider] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`https://syriacash.app/new/api.php?service_provider_info&id=${id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setProvider(data.provider);
          setItems(data.items || []);
        } else {
          setError(data.message || 'خطأ');
        }
      })
      .catch(() => setError('فشل الاتصال بالخادم'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <LoadingSpinner text="جاري تحميل التفاصيل..." />;
  if (error) return <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>;

  const whatsappLink = provider?.phone
    ? `/whatsapp/${provider.phone.replace(/\D/g, '')}/مرحبا، أود الاستفسار عن خدمة ${encodeURIComponent(provider.name)}`
    : null;

  return (
    <div className="services-container">
      <h2 style={{ textAlign: 'center' }}>{provider.name}</h2>
      {provider.address && <p style={{ textAlign: 'center', color: '#888' }}>📍 {provider.address}</p>}
      {provider.description && <p style={{ textAlign: 'center', color: '#555' }}>{provider.description}</p>}

      {whatsappLink && (
        <div style={{ textAlign: 'center', margin: '14px 0' }}>
          <a href={whatsappLink} style={{
            display: 'inline-block', padding: '10px 20px', background: '#25D366', color: '#fff',
            borderRadius: '10px', textDecoration: 'none', fontWeight: '700',
          }}>
            💬 تواصل واتساب
          </a>
        </div>
      )}

      <div className="cards-grid">
        {items.map(item => (
          <div key={item.id} className="service-card">
            {item.image && (
              <ImageWithSkeleton src={`https://syriacash.app/images/${item.image}`} alt={item.name} />
            )}
            <div className="card-info">
              <div className="card-title">{item.name}</div>
              <div className="card-desc">{item.description}</div>
              <div className="card-price">{item.price} ₺</div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p style={{ textAlign: 'center' }}>لا توجد خدمات مضافة بعد</p>}
      </div>
    </div>
  );
}




function MyServicePanel() {
  const [service, setService] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showItemForm, setShowItemForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });

  const token = localStorage.getItem('authToken');

  const fetchMyService = () => {
    setLoading(true);
    fetch(`https://syriacash.app/new/api.php?my_service&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.service) {
          setService(data.service);
          setItems(data.items || []);
        } else {
          setError(data.message || 'لا تملك خدمة مرتبطة بحسابك بعد');
        }
      })
      .catch(() => setError('فشل الاتصال بالخادم'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchMyService(); }, []);

  const handleDeleteItem = (itemId) => {
    if (!window.confirm('حذف هذا العنصر؟')) return;
    fetch(`https://syriacash.app/new/api.php?delete_service_item&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ itemId }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setItems(prev => prev.filter(i => i.id !== itemId));
          setMessage({ text: '🗑️ تم الحذف', type: 'success' });
        } else {
          setMessage({ text: data.message || 'فشل الحذف', type: 'error' });
        }
      });
  };

  if (loading) return <LoadingSpinner text="جاري التحقق من بيانات خدمتك..." />;

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px', direction: 'rtl' }}>
        <div style={{ fontSize: '40px', marginBottom: '10px' }}>🔒</div>
        <p style={{ color: '#888', fontWeight: '700' }}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '14px', marginTop: '70px', direction: 'rtl', maxWidth: '700px', margin: '70px auto 0' }}>
      <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '800' }}>🛠 {service.name}</h2>
          <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#888' }}>{items.length} خدمة مضافة</p>
        </div>
        <button onClick={() => { setEditingItem(null); setShowItemForm(true); }} style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '12px', padding: '10px 16px',
          fontSize: '13px', fontWeight: '700', cursor: 'pointer',
        }}>＋ أضف خدمة</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: '14px' }}>
        {items.map(item => (
          <div key={item.id} style={{ background: '#fff', borderRadius: '14px', padding: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <img src={item.image ? `https://syriacash.app/images/${item.image}` : 'https://via.placeholder.com/200x120?text=خدمة'}
              alt={item.name} style={{ width: '100%', height: '110px', objectFit: 'cover', borderRadius: '10px' }} />
            <p style={{ fontWeight: '700', margin: '8px 0 2px' }}>{item.name}</p>
            <p style={{ fontSize: '13px', color: '#1a4187', fontWeight: '700' }}>{item.price} ₺</p>
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <button onClick={() => { setEditingItem(item); setShowItemForm(true); }}
                style={{ flex: 1, padding: '6px', background: '#f0f4ff', color: '#1a4187', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                ✏️ تعديل
              </button>
              <button onClick={() => handleDeleteItem(item.id)}
                style={{ flex: 1, padding: '6px', background: '#ffecec', color: '#c0392b', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                🗑️ حذف
              </button>
            </div>
          </div>
        ))}
      </div>

      {showItemForm && (
        <ServiceItemForm
          item={editingItem}
          serviceId={service.id}
          onClose={() => setShowItemForm(false)}
          onSaved={(saved) => {
            setItems(prev => {
              const exists = prev.some(i => i.id === saved.id);
              return exists ? prev.map(i => i.id === saved.id ? saved : i) : [...prev, saved];
            });
            setShowItemForm(false);
            setMessage({ text: '✅ تم الحفظ بنجاح', type: 'success' });
          }}
        />
      )}
    </div>
  );
}

function ServiceItemForm({ item, serviceId, onClose, onSaved }) {
  const isEditing = !!item?.id;
  const [name, setName] = useState(item?.name || '');
  const [price, setPrice] = useState(item?.price || '');
  const [description, setDescription] = useState(item?.description || '');
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const token = localStorage.getItem('authToken');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !price) { setMsg('يرجى تعبئة الاسم والسعر'); return; }
    setLoading(true);

    const fd = new FormData();
    fd.append('name', name);
    fd.append('price', price);
    fd.append('description', description);
    if (imageFile) fd.append('image', imageFile);

    try {
      let res;
      if (isEditing) {
        fd.append('itemId', item.id);
        res = await fetch(`https://syriacash.app/new/api.php?update_service_item&token=${token}`, { method: 'POST', body: fd });
      } else {
        fd.append('serviceId', serviceId);
        res = await fetch(`https://syriacash.app/new/api.php?add_service_item&token=${token}`, { method: 'POST', body: fd });
      }
      const data = await res.json();
      if (data.success) {
        onSaved(data.item);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch (err) {
      console.error(err);
      setMsg('خطأ في الاتصال بالخادم');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box',
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10001, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', width: '100%', maxWidth: '440px', borderRadius: '20px 20px 0 0', padding: '20px', direction: 'rtl', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '14px' }}>
          <h3 style={{ margin: 0 }}>{isEditing ? '✏️ تعديل خدمة' : '➕ إضافة خدمة'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <input style={inputStyle} placeholder="اسم الخدمة" value={name} onChange={e => setName(e.target.value)} />
          <input style={inputStyle} type="number" placeholder="السعر" value={price} onChange={e => setPrice(e.target.value)} />
          <textarea style={{ ...inputStyle, minHeight: '70px' }} placeholder="الوصف" value={description} onChange={e => setDescription(e.target.value)} />
          <input style={{ ...inputStyle, padding: '8px' }} type="file" accept="image/*" onChange={e => setImageFile(e.target.files[0])} />
          {msg && <p style={{ color: 'red', fontSize: '13px' }}>{msg}</p>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#1a4187', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: '700', cursor: 'pointer' }}>
            {loading ? 'جاري الحفظ...' : '💾 حفظ'}
          </button>
        </form>
      </div>
    </div>
  );
}







function ListStorer() {
  const [allProducts, setAllProducts] = useState([]); // جميع المنتجات الأصلية
  const [filteredProducts, setFilteredProducts] = useState([]); // المنتجات بعد التصفية
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [quantity, setQuantity] = useState(1);
  const [restaurantName, setRestaurantName] = useState("");
  const [restaurant, setRestaurant] = useState(null); // ✅ كامل بيانات المطعم (فيها owner_account)
  const { id } = useParams(); // جلب الـ id من الرابط /liststorer/:id

  // ✅ التحقق من الملكية
  const myAccount = localStorage.getItem("accountNumber");
  const isOwner = restaurant?.owner_account && String(restaurant.owner_account) === String(myAccount);
  const [showMealForm, setShowMealForm] = useState(false);
  const [editingMeal, setEditingMeal] = useState(null);

  // ✅ حالة لوحة المشروبات الجانبية
  const [showDrinksPanel, setShowDrinksPanel] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ section: "restaurant" }),
    }).catch(() => {});
  }, []);

  // ----------------- تحميل بيانات المطعم ومنتجاته -------------------
  useEffect(() => {
    if (!id) {
      setError("معرف المطعم غير موجود");
      setLoading(false);
      return;
    }

    const numId = parseInt(id);
    
    // جلب اسم المطعم وبياناته كاملة
    fetch(`https://syriacash.app/new/api.php?restaurantf&id=${numId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.restaurant) {
          setRestaurantName(data.restaurant.name);
          setRestaurant(data.restaurant); // ✅ تخزين الكائن الكامل (لازم يحتوي owner_account من الباك اند)
        } else {
          setRestaurantName("مطعم غير معروف");
        }
      })
      .catch(() => {
        setRestaurantName("مطعم غير معروف");
      });

    // جلب جميع منتجات المطعم مرة واحدة
    fetch(`https://syriacash.app/new/api.php?shopsf&id=${numId}&is_restaurant=1&limit=100`)
      .then((res) => res.json())
      .then((result) => {
        if (result.success && Array.isArray(result.data)) {
          setAllProducts(result.data);
          setFilteredProducts(result.data); // في البداية، تعرض جميع المنتجات
        } else {
          setAllProducts([]);
          setFilteredProducts([]);
        }
      })
      .catch(() => {
        setError("فشل تحميل منتجات المطعم");
        setAllProducts([]);
        setFilteredProducts([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  // ----------------- البحث المحلي داخل المنتجات -------------------
  useEffect(() => {
    if (searchTerm.trim() === "") {
      // إذا كان البحث فارغاً، عرض جميع المنتجات
      setFilteredProducts(allProducts);
      return;
    }

    // البحث المحلي في اسم المنتج ووصفه
    const searchLower = searchTerm.toLowerCase().trim();
    const filtered = allProducts.filter(product => {
      const nameMatch = product.name?.toLowerCase().includes(searchLower);
      const descMatch = product.description?.toLowerCase().includes(searchLower);
      return nameMatch || descMatch;
    });

    setFilteredProducts(filtered);
  }, [searchTerm, allProducts]);

  // ----------------- فتح المودال -------------------
  const openProductModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  // ----------------- إضافة للسلة -------------------
  const handleAddToCart = async () => {
    if (!selectedProduct?.id) return;
    setCartLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?addToCartf&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: selectedProduct.id,
            quantity,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setMessage({ text: "✅ تمت إضافة المنتج إلى السلة!", type: "success" });
        setQuantity(1);
        setModalOpen(false);
      } else {
        setMessage({ text: data.message || "فشل الإضافة", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setCartLoading(false);
    }
  };

  return (
    <>
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      <div className="services-container">
        {/* ✅ زر عائم لفتح قائمة المشروبات */}
        <button
          onClick={() => setShowDrinksPanel(true)}
          style={{
            position: 'fixed', left: '14px', bottom: '90px', zIndex: 500,
            background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
            border: 'none', borderRadius: '50%', width: '56px', height: '56px',
            fontSize: '26px', boxShadow: '0 4px 14px rgba(0,0,0,0.25)', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
          title="مشروبات من الماركيت"
        >
          🥤
        </button>

        {/* عرض اسم المطعم بدون زر العودة */}
        {restaurantName && (
          <div className="restaurant-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
            <h2 style={{ margin: 0, textAlign: "center" }}>
              {restaurantName}
            </h2>

            {/* ✅ زر إضافة وجبة يظهر فقط لصاحب المطعم */}
            {isOwner && (
              <button
                onClick={() => { setEditingMeal(null); setShowMealForm(true); }}
                style={{
                  background: 'linear-gradient(135deg,#1a4187,#2563eb)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '20px',
                  padding: '8px 14px',
                  fontSize: '13px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
              >
                ＋ أضف وجبة
              </button>
            )}
          </div>
        )}

        {/* شارة "هذا مطعمك" */}
        {isOwner && (
          <div style={{
            background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px',
            padding: '8px 14px', marginBottom: '14px', textAlign: 'center',
            color: '#2e7d32', fontWeight: '700', fontSize: '13px'
          }}>
            👑 أنت مالك هذا المطعم — يمكنك إضافة وتعديل الوجبات
          </div>
        )}

        {/* البحث المحلي */}
        <div className="search-box">
          <input
            type="text"
            placeholder={`ابحث في ${restaurantName || "المطعم"}...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </div>

        <p style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
          ⚠️ الخدمة متاحة حالياً في مدينة إدلب
        </p>

        {/* حالة التحميل */}
        {loading && (
          <p style={{ textAlign: "center" }}>⏳ جاري تحميل المنتجات...</p>
        )}

        {/* حالة الخطأ */}
        {error && !loading && (
          <p style={{ textAlign: "center", color: "red" }}>{error}</p>
        )}

        {/* حالة عدم وجود منتجات */}
        {!loading && !error && filteredProducts.length === 0 && searchTerm === "" && (
          <p style={{ textAlign: "center" }}>لا توجد منتجات في هذا المطعم</p>
        )}

        {!loading && !error && filteredProducts.length === 0 && searchTerm !== "" && (
          <p style={{ textAlign: "center" }}>لم يتم العثور على نتائج للبحث</p>
        )}

        {/* عرض عدد النتائج عند البحث */}
        {!loading && !error && searchTerm !== "" && filteredProducts.length > 0 && (
          <p style={{ textAlign: "center", color: "#666", fontSize: "14px" }}>
            تم العثور على {filteredProducts.length} منتج
          </p>
        )}

        {/* المنتجات */}
        {filteredProducts.length > 0 && (
          <div className="cards-grid">
            {filteredProducts.map((service) => (
              <div
                key={service.id}
                className="service-card"
                style={{ position: 'relative' }}
                onClick={() => openProductModal(service)}
              >
                {/* ✅ زر تعديل يظهر فقط لصاحب المطعم */}
                {isOwner && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditingMeal(service);
                      setShowMealForm(true);
                    }}
                    style={{
                      position: 'absolute', top: '8px', left: '8px', zIndex: 2,
                      background: '#1a4187', color: '#fff', border: 'none',
                      borderRadius: '8px', padding: '4px 10px', fontSize: '11px',
                      fontWeight: '700', cursor: 'pointer',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                    }}
                  >
                    ✏️ تعديل
                  </button>
                )}

                <ImageWithSkeleton
                  src={`https://syriacash.app/images/${service.image}`}
                  alt={service.name}
                />
                <div className="card-info">
                  <div className="card-title">{service.name}</div>

                  {/* 🔥 وصف مختصر */}
                  <div className="card-desc">
                    {service.description?.slice(0, 40) || ""}
                  </div>

                  <div className="card-price">{service.price} ₺</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* مودال المنتج */}
      {modalOpen && selectedProduct && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalOpen(false)}>
              ✖
            </button>

            <div className="modal-body">
              <h2>{selectedProduct.name}</h2>

              {/* صورة */}
              <div style={{ textAlign: "center", margin: "20px 0" }}>
                <img
                  src={`https://syriacash.app/images/${selectedProduct.image}`}
                  alt={selectedProduct.name}
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    borderRadius: "15px",
                  }}
                />
              </div>

              {/* 🔥 اسم المطعم */}
              <p>
                <strong>المطعم:</strong> {restaurantName || selectedProduct.restaurant_name}
              </p>

              {/* 🔥 الوصف */}
              <p style={{ opacity: 0.7 }}>{selectedProduct.description}</p>

              <p>
                <strong>السعر:</strong> {selectedProduct.price} ₺
              </p>

              {/* كمية */}
              <div className="quantity-control">
                <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                <span>{quantity}</span>
                <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>
                  −
                </button>
              </div>

              <button
                className="add-to-cart-btn"
                onClick={handleAddToCart}
                disabled={cartLoading}
              >
                {cartLoading ? "⏳ جاري الإضافة..." : "🛒 أضف إلى السلة"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ فورم إضافة/تعديل وجبة - يظهر فقط لصاحب المطعم */}
      {showMealForm && (
        <MealForm
          meal={editingMeal}
          restaurantId={id}
          onClose={() => setShowMealForm(false)}
          onSaved={(saved) => {
            setAllProducts(prev => {
              const exists = prev.some(m => m.id === saved.id);
              return exists
                ? prev.map(m => m.id === saved.id ? saved : m)
                : [...prev, saved];
            });
            setFilteredProducts(prev => {
              const exists = prev.some(m => m.id === saved.id);
              return exists
                ? prev.map(m => m.id === saved.id ? saved : m)
                : [...prev, saved];
            });
            setShowMealForm(false);
            setMessage({ text: "✅ تم حفظ الوجبة بنجاح", type: "success" });
          }}
        />
      )}

      {/* ✅ لوحة المشروبات الجانبية */}
      <DrinksSidePanel isOpen={showDrinksPanel} onClose={() => setShowDrinksPanel(false)} />
    </>
  );
}











function AddStoreForm({ onClose, onAdded }) {
  const [form, setForm] = useState({
    name: '', address: '', managerName: '', phone: '', description: '', category: '',
  });
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.address || !form.managerName || !form.phone) {
      setMsg('يرجى تعبئة جميع الحقول المطلوبة'); return;
    }
    setLoading(true);
    setMsg('');
    const token = localStorage.getItem('authToken');

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (logo) fd.append('logo', logo);

    try {
      const res = await fetch(`https://syriacash.app/new/api.php?add_store_request&token=${token}`, {
        method: 'POST', body: fd,
      });
      const data = await res.json();
      if (data.success) {
        setSuccessMsg('✅ تم إرسال طلبك بنجاح! سيتم مراجعته من الإدارة.');
        setTimeout(() => { onAdded && onAdded(); onClose(); }, 2500);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch { setMsg('خطأ في الاتصال بالخادم'); }
    finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', outline: 'none',
    background: '#fafafa', marginBottom: '10px', fontFamily: 'inherit',
    boxSizing: 'border-box',
  };
  const labelStyle = { fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '4px', display: 'block' };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: '100%', maxWidth: '480px',
        borderRadius: '20px 20px 0 0', padding: '20px',
        maxHeight: '90vh', overflowY: 'auto', direction: 'rtl',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>🏪 أضف متجرك</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        {successMsg && (
          <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px', padding: '12px 14px', marginBottom: '14px', color: '#2e7d32', fontWeight: '700', fontSize: '14px' }}>
            {successMsg}
          </div>
        )}

        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', color: '#795548' }}>
          ⏳ سيتم مراجعة الطلب من الإدارة، وبعد الموافقة سيتم ربط حسابك بالمتجر تلقائياً وستتمكن من إدارة المنتجات بنفسك.
        </div>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>اسم المتجر *</label>
          <input style={inputStyle} placeholder="مثال: متجر الأناقة" value={form.name} onChange={e => set('name', e.target.value)} required />

          <label style={labelStyle}>عنوان المتجر *</label>
          <input style={inputStyle} placeholder="الحي، الشارع..." value={form.address} onChange={e => set('address', e.target.value)} required />

          <label style={labelStyle}>اسم المدير *</label>
          <input style={inputStyle} placeholder="اسم صاحب/مدير المتجر" value={form.managerName} onChange={e => set('managerName', e.target.value)} required />

          <label style={labelStyle}>رقم التواصل *</label>
          <input style={inputStyle} placeholder="09xxxxxxxx" value={form.phone} onChange={e => set('phone', e.target.value)} required />

          <label style={labelStyle}>نوع المنتجات / التصنيف</label>
          <input style={inputStyle} placeholder="مثال: مكتبات، عطورات، إكسسوارات" value={form.category} onChange={e => set('category', e.target.value)} />

          <label style={labelStyle}>وصف عام عن المتجر</label>
          <textarea style={{ ...inputStyle, minHeight: '90px', resize: 'vertical' }}
            placeholder="نبذة عن المتجر ومنتجاته..." 
            value={form.description} onChange={e => set('description', e.target.value)} />

          <label style={labelStyle}>📷 شعار المتجر (اختياري)</label>
          <input type="file" accept="image/*" style={{ ...inputStyle, padding: '8px' }}
            onChange={e => setLogo(e.target.files[0] || null)} />

          {msg && <p style={{ color: '#e63946', fontSize: '13px', marginBottom: '10px', fontWeight: '700' }}>⚠️ {msg}</p>}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#aaa' : 'linear-gradient(135deg,#1a4187,#2563eb)',
            color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px',
            fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? '⏳ جاري الإرسال...' : '🚀 إرسال طلب إضافة المتجر'}
          </button>
        </form>
      </div>
    </div>
  );
}


function ProductImagePicker({ image, onImageChange }) {
  const [preview, setPreview] = useState(image || null);
  const [processing, setProcessing] = useState(false);
  const [rawFile, setRawFile] = useState(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setRawFile(file);
    setPreview(URL.createObjectURL(file));
    onImageChange(file); // في البداية نرسل الصورة الأصلية
  };

  const handleRemoveBackground = async () => {
    if (!rawFile) return;
    setProcessing(true);
    try {
      const blob = await removeBackground(rawFile); // ✅ من @imgly/background-removal
      const processedFile = new File([blob], 'product_nobg.png', { type: 'image/png' });
      setPreview(URL.createObjectURL(blob));
      setRawFile(processedFile);
      onImageChange(processedFile); // ✅ نرسل الصورة بعد إزالة الخلفية
    } catch (err) {
      console.error('فشل حذف الخلفية:', err);
      alert('حدث خطأ أثناء معالجة الصورة، حاول مجدداً');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div style={{ marginBottom: '12px' }}>
      <input type="file" accept="image/*" onChange={handleFileSelect}
        style={{ width: '100%', padding: '8px', borderRadius: '10px', border: '1px solid #e0e0e0', boxSizing: 'border-box' }} />

      {preview && (
        <div style={{
          marginTop: '10px', textAlign: 'center', background: '#f5f5f5',
          borderRadius: '10px', padding: '10px', position: 'relative',
        }}>
          <img src={preview} alt="معاينة" style={{ maxWidth: '150px', maxHeight: '150px', borderRadius: '10px', objectFit: 'contain' }} />

          <div style={{ marginTop: '8px' }}>
            <button
              type="button"
              onClick={handleRemoveBackground}
              disabled={processing}
              style={{
                background: processing ? '#aaa' : '#6f42c1',
                color: '#fff', border: 'none', borderRadius: '8px',
                padding: '8px 14px', fontSize: '13px', fontWeight: '700',
                cursor: processing ? 'not-allowed' : 'pointer',
              }}
            >
              {processing ? '⏳ جاري إزالة الخلفية...' : '✨ حذف خلفية الصورة'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function StoreProductForm({ product, storeId, onClose, onSaved }) {
  const [name, setName] = useState(product?.name || '');
  const [price, setPrice] = useState(product?.price || '');
  const [description, setDescription] = useState(product?.description || '');
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const token = localStorage.getItem('authToken');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !price) { setMsg('يرجى تعبئة اسم المنتج والسعر'); return; }
    setLoading(true);

    const fd = new FormData();
    fd.append('name', name);
    fd.append('price', price);
    fd.append('description', description);
    fd.append('storeId', storeId);
    if (product?.id) fd.append('productId', product.id);
    if (imageFile) fd.append('image', imageFile);

    try {
      const endpoint = product?.id ? 'update_store_product' : 'add_store_product';
      const res = await fetch(`https://syriacash.app/new/api.php?${endpoint}&token=${token}`, {
        method: 'POST', body: fd,
      });
      const data = await res.json();
      if (data.success) {
        onSaved(data.product);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch { setMsg('خطأ في الاتصال بالخادم'); }
    finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box',
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10001, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', width: '100%', maxWidth: '440px', borderRadius: '20px 20px 0 0', padding: '20px', direction: 'rtl', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '14px' }}>
          <h3 style={{ margin: 0 }}>{product ? '✏️ تعديل منتج' : '➕ إضافة منتج'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <input style={inputStyle} placeholder="اسم المنتج" value={name} onChange={e => setName(e.target.value)} />
          <input style={inputStyle} type="number" placeholder="السعر" value={price} onChange={e => setPrice(e.target.value)} />
          <textarea style={{ ...inputStyle, minHeight: '70px' }} placeholder="وصف المنتج" value={description} onChange={e => setDescription(e.target.value)} />

          {/* ✅ منتقي الصورة مع خاصية حذف الخلفية */}
          <label style={{ fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '4px', display: 'block' }}>
            📷 صورة المنتج {product?.image && !imageFile && '(الصورة الحالية محفوظة، اختر صورة جديدة لتغييرها)'}
          </label>
          <ProductImagePicker
            image={product?.image ? `https://syriacash.app/images/${product.image}` : null}
            onImageChange={(file) => setImageFile(file)}
          />

          {msg && <p style={{ color: 'red', fontSize: '13px' }}>{msg}</p>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#1a4187', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: '700', cursor: 'pointer' }}>
            {loading ? 'جاري الحفظ...' : '💾 حفظ'}
          </button>
        </form>
      </div>
    </div>
  );
}


function MyStorePanel() {
  const [store, setStore] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showProductForm, setShowProductForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });

  const token = localStorage.getItem('authToken');

  const fetchMyStore = () => {
    setLoading(true);
    fetch(`https://syriacash.app/new/api.php?my_store&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.store) {
          setStore(data.store);
          setProducts(data.products || []);
        } else {
          setError(data.message || 'لا تملك متجراً مرتبطاً بحسابك بعد');
        }
      })
      .catch(() => setError('فشل الاتصال بالخادم'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchMyStore(); }, []);

  const handleDeleteProduct = (productId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا المنتج؟')) return;
    fetch(`https://syriacash.app/new/api.php?delete_store_product&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setProducts(prev => prev.filter(p => p.id !== productId));
          setMessage({ text: '🗑️ تم حذف المنتج', type: 'success' });
        } else {
          setMessage({ text: data.message || 'فشل الحذف', type: 'error' });
        }
      });
  };

  if (loading) return <LoadingSpinner text="جاري التحقق من بيانات متجرك..." />;

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px', direction: 'rtl' }}>
        <div style={{ fontSize: '40px', marginBottom: '10px' }}>🔒</div>
        <p style={{ color: '#888', fontWeight: '700' }}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '14px', marginTop: '70px', direction: 'rtl', maxWidth: '700px', margin: '70px auto 0' }}>
      <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '800' }}>🏪 {store.name}</h2>
          <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#888' }}>{products.length} منتج مضاف</p>
        </div>
        <button onClick={() => { setEditingProduct(null); setShowProductForm(true); }} style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '12px', padding: '10px 16px',
          fontSize: '13px', fontWeight: '700', cursor: 'pointer',
        }}>＋ أضف منتج</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: '14px' }}>
        {products.map(product => (
          <div key={product.id} style={{ background: '#fff', borderRadius: '14px', padding: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <img src={product.image ? `https://syriacash.app/images/${product.image}` : 'https://via.placeholder.com/200x120?text=منتج'}
              alt={product.name} style={{ width: '100%', height: '110px', objectFit: 'contain', background: '#f5f5f5', borderRadius: '10px' }} />
            <p style={{ fontWeight: '700', margin: '8px 0 2px' }}>{product.name}</p>
            <p style={{ fontSize: '13px', color: '#1a4187', fontWeight: '700' }}>{product.price} ₺</p>
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <button onClick={() => { setEditingProduct(product); setShowProductForm(true); }}
                style={{ flex: 1, padding: '6px', background: '#f0f4ff', color: '#1a4187', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                ✏️ تعديل
              </button>
              <button onClick={() => handleDeleteProduct(product.id)}
                style={{ flex: 1, padding: '6px', background: '#ffecec', color: '#c0392b', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
                🗑️ حذف
              </button>
            </div>
          </div>
        ))}
      </div>

      {showProductForm && (
        <StoreProductForm
          product={editingProduct}
          storeId={store.id}
          onClose={() => setShowProductForm(false)}
          onSaved={(saved) => {
            setProducts(prev => {
              const exists = prev.some(p => p.id === saved.id);
              return exists ? prev.map(p => p.id === saved.id ? saved : p) : [...prev, saved];
            });
            setShowProductForm(false);
            setMessage({ text: '✅ تم حفظ المنتج بنجاح', type: 'success' });
          }}
        />
      )}
    </div>
  );
}








function BankShopc() {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [productLoading, setProductLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [quantity, setQuantity] = useState(1);
  const observer = useRef();
  const location = useLocation();

  // ----------------- تحميل التصنيفات -------------------
  useEffect(() => {
    fetch("https://syriacash.app/new/api.php?categoriesc")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setCategories([{ id: "all", name: "الكل" }, ...data]);
        } else {
          setError("خطأ في جلب التصنيفات");
        }
      })
      .catch(() => setError("فشل الاتصال بالخادم"))
      .finally(() => setLoading(false));
  }, []);

  // ----------------- تحديث التبويب من الرابط -------------------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");
    if (categoryParam) setActiveTab(categoryParam);
  }, [location.search]);

  // ----------------- تحميل المنتجات -------------------
  const loadProducts = useCallback(
    async (reset = false) => {
      setProductLoading(true);
      try {
        const currentPage = reset ? 1 : page;
        const categoryParam = activeTab === "الكل" ? "all" : activeTab;

        const res = await fetch(
          `https://syriacash.app/new/api.php?shopsc&id=${categoryParam}&page=${currentPage}&limit=20`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          const newProducts = result.data;
          setServices((prev) => (reset ? newProducts : [...prev, ...newProducts]));
          setHasMore(currentPage < (result.total_pages || 1));
        } else {
          setHasMore(false);
        }
      } catch {
        setError("فشل تحميل المنتجات");
      } finally {
        setProductLoading(false);
      }
    },
    [activeTab, page]
  );

  useEffect(() => {
    setPage(1);
    loadProducts(true);
  }, [activeTab]);

  // ----------------- تحميل المزيد عند التمرير -------------------
  const lastProductRef = useCallback(
    (node) => {
      if (productLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [productLoading, hasMore]
  );

  useEffect(() => {
    if (page > 1) loadProducts();
  }, [page]);

  // ----------------- البحث -------------------
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchTerm.trim() === "") {
        setPage(1);
        loadProducts(true);
        return;
      }

      setProductLoading(true);
      try {
        const res = await fetch(
          `https://syriacash.app/new/api.php?searchc=${encodeURIComponent(searchTerm)}`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          setServices(result.data);
          setHasMore(false);
        } else {
          setServices([]);
        }
      } catch {
        setError("فشل الاتصال أثناء البحث");
      } finally {
        setProductLoading(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // ----------------- فتح المودال -------------------
  const openProductModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  // ----------------- إضافة للسلة -------------------
  const handleAddToCart = async () => {
    if (!selectedProduct?.id) return;
    setCartLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?addToCartc&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: selectedProduct.id,
            quantity,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setMessage({ text: "✅ تمت إضافة المنتج إلى السلة!", type: "success" });
        setQuantity(1);
        setModalOpen(false);
      } else {
        setMessage({ text: data.message || "فشل الإضافة", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setCartLoading(false);
    }
  };

  return (
    <>
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      <div className="services-container">
        {/* البحث */}
        <div className="search-box">
          <input
            type="text"
            placeholder="ابحث عن منتج..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </div>

        <p style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
          ⚠️ الخدمة متاحة حالياً في مدينة إدلب
        </p>

        {/* التصنيفات */}
        {!loading && (
          <div className="tabs">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`tab-btn ${activeTab === cat.id ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(cat.id);
                  setSearchTerm("");
                }}
              >
                {cat.name}
              </button>
            ))}
          </div>
        )}

        {/* المنتجات */}
        <div className="cards-grid">
          {services.map((service, i) => {
            const isLast = i === services.length - 1;
            return (
              <div
                ref={isLast ? lastProductRef : null}
                key={service.id}
                className="service-card"
                onClick={() => openProductModal(service)}
              >
                <ImageWithSkeleton
                  src={`https://syriacash.app/images/${service.image}`}
                  alt={service.name}
                />
                <div className="card-info">
                  <div className="card-title">{service.name}</div>

                  {/* 🔥 اسم المطعم */}
                  <div className="card-restaurant">
                    🍽 {service.restaurant_name || "مطعم غير معروف"}
                  </div>

                  {/* 🔥 وصف مختصر */}
                  <div className="card-desc">
                    {service.description?.slice(0, 40) || ""}
                  </div>

                  <div className="card-price">{service.price} ₺</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* مودال المنتج */}
        {modalOpen && selectedProduct && (
          <div className="modal-overlay" onClick={() => setModalOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setModalOpen(false)}>
                ✖
              </button>

              <div className="modal-body">
                <h2>{selectedProduct.name}</h2>

                {/* صورة */}
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                  <img
                    src={`https://syriacash.app/images/${selectedProduct.image}`}
                    alt={selectedProduct.name}
                    style={{
                      width: "100%",
                      maxWidth: "150px",
                      borderRadius: "15px",
                    }}
                  />
                </div>

                {/* 🔥 اسم المطعم */}
                <p>
                  <strong>المطعم:</strong> {selectedProduct.restaurant_name}
                </p>

                {/* 🔥 الوصف */}
                <p style={{ opacity: 0.7 }}>{selectedProduct.description}</p>

                <p>
                  <strong>السعر:</strong> {selectedProduct.price} ₺
                </p>

                {/* كمية */}
                <div className="quantity-control">
                  <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                  <span>{quantity}</span>
                  <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>
                    −
                  </button>
                </div>

                <button
                  className="add-to-cart-btn"
                  onClick={handleAddToCart}
                  disabled={cartLoading}
                >
                  {cartLoading ? "⏳ جاري الإضافة..." : "🛒 شراء مباشر  "}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}





function AddBuildingForm({ onClose, onAdded }) {
  const [form, setForm] = useState({
    title: '', type: 'شقة', status: 'بيع', rooms: '', floor: '',
    address: '', price: '', description: '', company: '',
    lat: '', lng: '', phone: '',
  });
  const [images, setImages] = useState([]);
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const mapRef = useRef(null);
  const leafletMapRef = useRef(null);
  const markerRef = useRef(null);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // إحداثيات إدلب كنقطة بداية
  const DEFAULT_LAT = 35.9306;
  const DEFAULT_LNG = 36.6342;

  // تهيئة خريطة Leaflet
  useEffect(() => {
    if (!mapRef.current || leafletMapRef.current) return;

    // تحميل Leaflet CSS
    if (!document.getElementById('leaflet-css')) {
      const link = document.createElement('link');
      link.id = 'leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
      document.head.appendChild(link);
    }

    const initMap = () => {
      if (!window.L || !mapRef.current || leafletMapRef.current) return;

      const map = window.L.map(mapRef.current, { zoomControl: true }).setView([DEFAULT_LAT, DEFAULT_LNG], 13);
      leafletMapRef.current = map;

      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(map);

      // أيقونة دبوس مخصصة
      const pinIcon = window.L.divIcon({
        html: '<div style="font-size:32px;margin-top:-32px;margin-left:-12px;filter:drop-shadow(0 2px 4px rgba(0,0,0,0.4))">📍</div>',
        iconSize: [24, 32],
        className: '',
      });

      // النقر على الخريطة لوضع الدبوس
      map.on('click', (e) => {
        const { lat, lng } = e.latlng;
        const latFixed = lat.toFixed(6);
        const lngFixed = lng.toFixed(6);

        // تحريك الدبوس أو إنشاؤه
        if (markerRef.current) {
          markerRef.current.setLatLng([lat, lng]);
        } else {
          markerRef.current = window.L.marker([lat, lng], { icon: pinIcon, draggable: true }).addTo(map);

          // سحب الدبوس
          markerRef.current.on('dragend', (ev) => {
            const pos = ev.target.getLatLng();
            setForm(f => ({ ...f, lat: pos.lat.toFixed(6), lng: pos.lng.toFixed(6) }));
          });
        }

        setForm(f => ({ ...f, lat: latFixed, lng: lngFixed }));
      });

      // إذا كان هناك إحداثيات مسبقة
      if (form.lat && form.lng) {
        markerRef.current = window.L.marker([form.lat, form.lng], { icon: pinIcon, draggable: true }).addTo(map);
        map.setView([form.lat, form.lng], 15);
      }
    };

    if (window.L) {
      initMap();
    } else {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
      script.onload = initMap;
      document.head.appendChild(script);
    }

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
        markerRef.current = null;
      }
    };
  }, []);

  // تحديث موقع الدبوس عند تغيير الإحداثيات يدوياً
  const updateMarkerFromInput = (lat, lng) => {
    if (!leafletMapRef.current || !window.L) return;
    if (!lat || !lng) return;
    const pinIcon = window.L.divIcon({
      html: '<div style="font-size:32px;margin-top:-32px;margin-left:-12px;filter:drop-shadow(0 2px 4px rgba(0,0,0,0.4))">📍</div>',
      iconSize: [24, 32], className: '',
    });
    if (markerRef.current) {
      markerRef.current.setLatLng([lat, lng]);
    } else {
      markerRef.current = window.L.marker([lat, lng], { icon: pinIcon, draggable: true }).addTo(leafletMapRef.current);
      markerRef.current.on('dragend', (ev) => {
        const pos = ev.target.getLatLng();
        setForm(f => ({ ...f, lat: pos.lat.toFixed(6), lng: pos.lng.toFixed(6) }));
      });
    }
    leafletMapRef.current.setView([lat, lng], 15);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.price || !form.address) {
      setMsg('يرجى تعبئة العنوان والسعر والموقع'); return;
    }
    setLoading(true);
    setMsg('');
    const token = localStorage.getItem('authToken');
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    images.forEach((img, i) => fd.append(`images[${i}]`, img));
    if (video) fd.append('video', video);

    try {
      const res = await fetch(`https://syriacash.app/new/api.php?add_building&token=${token}`, {
        method: 'POST', body: fd,
      });
      const data = await res.json();
      if (data.success) {
        setSuccessMsg('✅ تم إرسال العقار بنجاح! سيظهر بعد مراجعة الإدارة.');
        setTimeout(() => { onAdded(); onClose(); }, 2500);
      } else {
        setMsg(data.message || 'حدث خطأ');
      }
    } catch { setMsg('خطأ في الاتصال'); }
    finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: '10px',
    border: '1px solid #e0e0e0', fontSize: '14px', outline: 'none',
    background: '#fafafa', marginBottom: '10px', fontFamily: 'inherit',
    boxSizing: 'border-box',
  };
  const labelStyle = { fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '4px', display: 'block' };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: '100%', maxWidth: '560px',
        borderRadius: '20px 20px 0 0', padding: '20px',
        maxHeight: '92vh', overflowY: 'auto', direction: 'rtl',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>🏠 إضافة عقار جديد</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        {/* رسالة نجاح */}
        {successMsg && (
          <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px', padding: '12px 14px', marginBottom: '14px', color: '#2e7d32', fontWeight: '700', fontSize: '14px' }}>
            {successMsg}
          </div>
        )}

        {/* تنبيه المراجعة */}
        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px', padding: '10px 14px', marginBottom: '14px', fontSize: '13px', color: '#795548' }}>
          ⏳ سيتم مراجعة العقار من الإدارة قبل نشره للعموم
        </div>

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>عنوان العقار *</label>
          <input style={inputStyle} placeholder="مثال: شقة للبيع في حي الجامعة" value={form.title} onChange={e => set('title', e.target.value)} required />

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={labelStyle}>نوع العقار</label>
              <select style={inputStyle} value={form.type} onChange={e => set('type', e.target.value)}>
                {['شقة','منزل','محل','أرض','مكتب','فيلا','مستودع'].map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>نوع العرض</label>
              <select style={inputStyle} value={form.status} onChange={e => set('status', e.target.value)}>
                <option>بيع</option><option>إيجار</option>
              </select>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={labelStyle}>عدد الغرف</label>
              <input style={inputStyle} type="number" placeholder="3" value={form.rooms} onChange={e => set('rooms', e.target.value)} />
            </div>
            <div>
              <label style={labelStyle}>الطابق</label>
              <input style={inputStyle} type="number" placeholder="2" value={form.floor} onChange={e => set('floor', e.target.value)} />
            </div>
          </div>

          <label style={labelStyle}>الموقع / العنوان *</label>
          <input style={inputStyle} placeholder="الحي، الشارع..." value={form.address} onChange={e => set('address', e.target.value)} required />

          {/* ─── خريطة Leaflet التفاعلية ─── */}
          <label style={labelStyle}>📍 حدد موقع العقار على الخريطة</label>

          <div style={{
            borderRadius: '14px', overflow: 'hidden',
            border: form.lat && form.lng ? '2px solid #28a745' : '2px solid #e0e8ff',
            marginBottom: '10px', position: 'relative',
          }}>
            {/* شريط التعليمات */}
            <div style={{ background: '#1a4187', padding: '8px 12px', color: '#fff', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>👆</span>
              <span>انقر على الخريطة لوضع الدبوس — يمكنك سحبه لتعديل الموقع</span>
            </div>
            {/* الخريطة */}
            <div ref={mapRef} style={{ width: '100%', height: '250px' }} />
          </div>

          {/* حالة التحديد */}
          {form.lat && form.lng ? (
            <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px', padding: '8px 12px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '13px', color: '#2e7d32', fontWeight: '700' }}>
                ✅ الموقع محدد: {parseFloat(form.lat).toFixed(4)}, {parseFloat(form.lng).toFixed(4)}
              </span>
              <button type="button" onClick={() => {
                setForm(f => ({ ...f, lat: '', lng: '' }));
                if (markerRef.current && leafletMapRef.current) {
                  leafletMapRef.current.removeLayer(markerRef.current);
                  markerRef.current = null;
                }
              }} style={{ background: 'none', border: 'none', color: '#e63946', cursor: 'pointer', fontSize: '13px', fontWeight: '700' }}>
                ✕ إلغاء
              </button>
            </div>
          ) : (
            <p style={{ fontSize: '12px', color: '#888', marginBottom: '10px', textAlign: 'center' }}>
              لم يتم تحديد الموقع بعد — انقر على الخريطة لوضع الدبوس
            </p>
          )}

          {/* إدخال يدوي للإحداثيات */}
          <details style={{ marginBottom: '10px' }}>
            <summary style={{ fontSize: '12px', color: '#1a4187', cursor: 'pointer', fontWeight: '700' }}>
              ✏️ أو أدخل الإحداثيات يدوياً
            </summary>
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <input
                style={{ ...inputStyle, marginBottom: 0, flex: 1 }}
                type="number" step="any" placeholder="خط العرض 35.9306"
                value={form.lat}
                onChange={e => { set('lat', e.target.value); updateMarkerFromInput(e.target.value, form.lng); }}
              />
              <input
                style={{ ...inputStyle, marginBottom: 0, flex: 1 }}
                type="number" step="any" placeholder="خط الطول 36.6342"
                value={form.lng}
                onChange={e => { set('lng', e.target.value); updateMarkerFromInput(form.lat, e.target.value); }}
              />
            </div>
          </details>

          <label style={labelStyle}>السعر ($) *</label>
          <input style={inputStyle} type="number" placeholder="25000" value={form.price} onChange={e => set('price', e.target.value)} required />

          <label style={labelStyle}>رقم التواصل</label>
          <input style={inputStyle} placeholder="09xxxxxxxx" value={form.phone} onChange={e => set('phone', e.target.value)} />

          <label style={labelStyle}>اسم الشركة / المالك</label>
          <input style={inputStyle} placeholder="اختياري" value={form.company} onChange={e => set('company', e.target.value)} />

          <label style={labelStyle}>الوصف</label>
          <textarea style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
            placeholder="وصف العقار، المميزات..."
            value={form.description} onChange={e => set('description', e.target.value)} />

          <label style={labelStyle}>📷 صور العقار (حتى 8 صور)</label>
          <input type="file" accept="image/*" multiple style={{ ...inputStyle, padding: '8px' }}
            onChange={e => setImages(Array.from(e.target.files).slice(0, 8))} />
          {images.length > 0 && (
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '10px' }}>
              {images.map((img, i) => (
                <div key={i} style={{ position: 'relative' }}>
                  <img src={URL.createObjectURL(img)} alt=""
                    style={{ width: '64px', height: '64px', borderRadius: '8px', objectFit: 'cover' }} />
                  <button type="button" onClick={() => setImages(imgs => imgs.filter((_, j) => j !== i))}
                    style={{ position: 'absolute', top: '-4px', left: '-4px', background: '#e63946', color: '#fff', border: 'none', borderRadius: '50%', width: '18px', height: '18px', fontSize: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
                </div>
              ))}
            </div>
          )}

          <label style={labelStyle}>🎬 فيديو العقار (اختياري)</label>
          <input type="file" accept="video/*" style={{ ...inputStyle, padding: '8px' }}
            onChange={e => setVideo(e.target.files[0] || null)} />
          {video && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
              <p style={{ fontSize: '12px', color: '#28a745', margin: 0 }}>✅ {video.name}</p>
              <button type="button" onClick={() => setVideo(null)}
                style={{ background: '#e63946', color: '#fff', border: 'none', borderRadius: '6px', padding: '2px 8px', fontSize: '11px', cursor: 'pointer' }}>حذف</button>
            </div>
          )}

          {msg && <p style={{ color: '#e63946', fontSize: '13px', marginBottom: '10px', fontWeight: '700' }}>⚠️ {msg}</p>}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#aaa' : 'linear-gradient(135deg,#1a4187,#2563eb)',
            color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px',
            fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? '⏳ جاري الإرسال للمراجعة...' : '🚀 إرسال للمراجعة والنشر'}
          </button>
        </form>
      </div>
    </div>
  );
}



function BuildingCard({ b, onClick }) {
  const [imgIdx, setImgIdx] = useState(0);
  const imgs = b.images?.length ? b.images : [b.image].filter(Boolean);

  return (
    <div onClick={() => onClick(b)} style={{
      background: '#fff', borderRadius: '16px', overflow: 'hidden',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)', cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s', direction: 'rtl',
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.13)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)'; }}
    >
      {/* صورة */}
      <div style={{ position: 'relative', height: '180px', background: '#f5f5f5' }}>
        <img src={imgs[imgIdx] || 'https://via.placeholder.com/300x180?text=عقار'} alt={b.title}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        {imgs.length > 1 && (
          <>
            <button onClick={e => { e.stopPropagation(); setImgIdx(i => (i - 1 + imgs.length) % imgs.length); }}
              style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.4)', color: '#fff', border: 'none', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontSize: '14px' }}>‹</button>
            <button onClick={e => { e.stopPropagation(); setImgIdx(i => (i + 1) % imgs.length); }}
              style={{ position: 'absolute', top: '50%', left: '8px', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.4)', color: '#fff', border: 'none', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontSize: '14px' }}>›</button>
            <span style={{ position: 'absolute', bottom: '8px', left: '8px', background: 'rgba(0,0,0,0.5)', color: '#fff', fontSize: '11px', padding: '2px 8px', borderRadius: '10px' }}>{imgIdx + 1}/{imgs.length}</span>
          </>
        )}
        {/* شارة الحالة */}
        <span style={{
          position: 'absolute', top: '10px', right: '10px',
          background: b.status === 'بيع' ? '#1a4187' : '#0a8f5a',
          color: '#fff', fontSize: '11px', fontWeight: '700',
          padding: '3px 10px', borderRadius: '20px',
        }}>{b.status}</span>
        {/* شارة الفيديو */}
        {b.video && (
          <span style={{ position: 'absolute', top: '10px', left: '10px', background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: '14px', padding: '3px 8px', borderRadius: '8px' }}>🎬</span>
        )}
      </div>

      {/* محتوى */}
      <div style={{ padding: '12px 14px' }}>
        <p style={{ margin: '0 0 4px', fontWeight: '800', fontSize: '15px', lineHeight: '1.3' }}>{b.title}</p>
        <p style={{ margin: '0 0 8px', fontSize: '12px', color: '#888' }}>📍 {b.address}</p>

        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '10px' }}>
          {b.type && <span style={{ background: '#f0f4ff', color: '#1a4187', fontSize: '11px', padding: '3px 8px', borderRadius: '8px', fontWeight: '600' }}>🏠 {b.type}</span>}
          {b.rooms > 0 && <span style={{ background: '#f0f4ff', color: '#1a4187', fontSize: '11px', padding: '3px 8px', borderRadius: '8px', fontWeight: '600' }}>🛏 {b.rooms} غرف</span>}
          {b.floor > 0 && <span style={{ background: '#f0f4ff', color: '#1a4187', fontSize: '11px', padding: '3px 8px', borderRadius: '8px', fontWeight: '600' }}>🏢 ط{b.floor}</span>}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: '800', fontSize: '17px', color: '#1a4187' }}>${Number(b.price).toLocaleString()}</span>
          <span style={{ fontSize: '11px', color: '#aaa' }}>{b.published_at}</span>
        </div>
      </div>
    </div>
  );
}


function BuildingModal({ b, onClose }) {
  const [imgIdx, setImgIdx] = useState(0);
  const [showMap, setShowMap] = useState(false);
  const imgs = b.images?.length ? b.images : [b.image].filter(Boolean);

  const mapUrl = b.lat && b.lng
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${b.lng - 0.005},${b.lat - 0.005},${parseFloat(b.lng) + 0.005},${parseFloat(b.lat) + 0.005}&layer=mapnik&marker=${b.lat},${b.lng}`
    : null;

  const infoRow = (icon, label, val) => val ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid #f5f5f5' }}>
      <span style={{ color: '#888', fontSize: '13px' }}>{icon} {label}</span>
      <span style={{ fontWeight: '700', fontSize: '13px' }}>{val}</span>
    </div>
  ) : null;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)',
      zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: '100%', maxWidth: '560px',
        borderRadius: '20px 20px 0 0', maxHeight: '93vh',
        overflowY: 'auto', direction: 'rtl',
      }}>
        {/* الصور */}
        <div style={{ position: 'relative', height: '240px', background: '#111' }}>
          {imgs.length > 0 ? (
            <img src={imgs[imgIdx]} alt={b.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#555' }}>لا توجد صور</div>
          )}
          {imgs.length > 1 && (
            <>
              <button onClick={() => setImgIdx(i => (i - 1 + imgs.length) % imgs.length)}
                style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%', width: '34px', height: '34px', cursor: 'pointer', fontSize: '18px' }}>‹</button>
              <button onClick={() => setImgIdx(i => (i + 1) % imgs.length)}
                style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%', width: '34px', height: '34px', cursor: 'pointer', fontSize: '18px' }}>›</button>
              <div style={{ position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '5px' }}>
                {imgs.map((_, i) => (
                  <div key={i} onClick={() => setImgIdx(i)} style={{
                    width: i === imgIdx ? '18px' : '6px', height: '6px',
                    background: i === imgIdx ? '#fff' : 'rgba(255,255,255,0.5)',
                    borderRadius: '3px', cursor: 'pointer', transition: '0.2s',
                  }} />
                ))}
              </div>
            </>
          )}
          <button onClick={onClose} style={{
            position: 'absolute', top: '12px', right: '12px',
            background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none',
            borderRadius: '50%', width: '32px', height: '32px', cursor: 'pointer', fontSize: '16px',
          }}>✕</button>
          <span style={{
            position: 'absolute', top: '12px', left: '12px',
            background: b.status === 'بيع' ? '#1a4187' : '#0a8f5a',
            color: '#fff', fontSize: '12px', fontWeight: '700', padding: '4px 12px', borderRadius: '20px',
          }}>{b.status}</span>
        </div>

        <div style={{ padding: '18px 18px 30px' }}>
          {/* العنوان والسعر */}
          <h2 style={{ margin: '0 0 4px', fontSize: '20px', fontWeight: '800' }}>{b.title}</h2>
          <p style={{ margin: '0 0 12px', color: '#888', fontSize: '13px' }}>📍 {b.address}</p>
          <div style={{ background: 'linear-gradient(135deg,#1a4187,#2563eb)', borderRadius: '12px', padding: '14px 18px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px' }}>السعر</span>
            <span style={{ color: '#fff', fontSize: '22px', fontWeight: '800' }}>${Number(b.price).toLocaleString()}</span>
          </div>

          {/* المعلومات */}
          {infoRow('🏠', 'نوع العقار', b.type)}
          {infoRow('🛏', 'عدد الغرف', b.rooms)}
          {infoRow('🏢', 'الطابق', b.floor)}
          {infoRow('🏗', 'الشركة / المالك', b.company)}
          {infoRow('📅', 'تاريخ النشر', b.published_at)}

          {/* الوصف */}
          {b.description && (
            <div style={{ margin: '14px 0', padding: '12px', background: '#f9f9f9', borderRadius: '10px' }}>
              <p style={{ margin: '0 0 6px', fontWeight: '700', fontSize: '13px' }}>📝 الوصف</p>
              {b.description.split('\n').map((line, i) => (
                <p key={i} style={{ margin: '2px 0', fontSize: '13px', color: '#444' }}>• {line}</p>
              ))}
            </div>
          )}

          {/* الفيديو */}
          {b.video && (
            <div style={{ margin: '14px 0' }}>
              <p style={{ margin: '0 0 8px', fontWeight: '700', fontSize: '13px' }}>🎬 فيديو العقار</p>
              <video controls style={{ width: '100%', borderRadius: '12px', maxHeight: '220px' }}>
                <source src={b.video} />
                متصفحك لا يدعم الفيديو
              </video>
            </div>
          )}

          {/* الخريطة */}
          {mapUrl && (
            <div style={{ margin: '14px 0' }}>
              <button onClick={() => setShowMap(!showMap)} style={{
                width: '100%', padding: '10px', background: showMap ? '#e8f0fe' : '#f0f4ff',
                color: '#1a4187', border: '1px solid #c7d7f8', borderRadius: '10px',
                fontWeight: '700', fontSize: '13px', cursor: 'pointer', marginBottom: '8px',
              }}>
                🗺 {showMap ? 'إخفاء الخريطة' : 'عرض الخريطة التفاعلية'}
              </button>
              {showMap && (
                <iframe
                  src={mapUrl} title="خريطة العقار"
                  style={{ width: '100%', height: '220px', border: 'none', borderRadius: '12px' }}
                  loading="lazy"
                />
              )}
            </div>
          )}

          {/* أزرار التواصل */}
          <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
            {b.phone && (
              <a href={`/whatsapp/${b.phone.replace(/\D/g, '')}/مرحبا، أود الاستفسار عن العقار: ${encodeURIComponent(b.title)}`}
                style={{
                  flex: 1, padding: '13px', background: '#25D366', color: '#fff',
                  textAlign: 'center', borderRadius: '12px', textDecoration: 'none',
                  fontWeight: '700', fontSize: '14px',
                }}>
                💬 تواصل واتساب
              </a>
            )}
            <a href={`/sharing/${encodeURIComponent(`عقار للـ${b.status}: ${b.title}\n📍 ${b.address}\n💰 ${b.price}$`)}`}
              style={{
                flex: 1, padding: '13px', background: '#f0f4ff', color: '#1a4187',
                textAlign: 'center', borderRadius: '12px', textDecoration: 'none',
                fontWeight: '700', fontSize: '14px', border: '1px solid #c7d7f8',
              }}>
              📤 مشاركة
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}


function BuildingsMap({ buildings, onSelect }) {
  const withCoords = buildings.filter(b => b.lat && b.lng);
  const center = withCoords.length
    ? [withCoords[0].lat, withCoords[0].lng]
    : [36.2, 37.13];

  const markers = withCoords.map(b =>
    `&marker=${b.lat},${b.lng}`
  ).join('');

  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${parseFloat(center[1]) - 0.05},${parseFloat(center[0]) - 0.05},${parseFloat(center[1]) + 0.05},${parseFloat(center[0]) + 0.05}&layer=mapnik${markers}`;

  return (
    <div style={{ borderRadius: '16px', overflow: 'hidden', border: '2px solid #e0e8ff', marginBottom: '16px' }}>
      <div style={{ background: '#1a4187', padding: '10px 14px', color: '#fff', fontSize: '13px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '6px' }}>
        🗺 خريطة العقارات — {withCoords.length} عقار بإحداثيات
      </div>
      {withCoords.length > 0 ? (
        <iframe src={mapUrl} title="خريطة العقارات" style={{ width: '100%', height: '260px', border: 'none' }} loading="lazy" />
      ) : (
        <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7ff', color: '#888', fontSize: '13px' }}>
          لا توجد عقارات بإحداثيات جغرافية بعد
        </div>
      )}
    </div>
  );
}


function BankShopb() {
  const [buildings, setBuildings] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const tabs = ["الكل", "بيع", "إيجار"];
  const location = useLocation();

useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "bankshopb" }),
  }).catch(() => {});
}, []);




  // قراءة التاب من الرابط
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get("category");
    if (category && tabs.includes(category)) setActiveTab(category);
  }, [location.search]);

  const fetchBuildings = () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    fetch("https://syriacash.app/new/api.php?buildings", {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    })
      .then(res => { if (!res.ok) throw new Error("فشل تحميل العقارات"); return res.json(); })
      .then(data => { if (Array.isArray(data)) setBuildings(data); else setError("تنسيق البيانات غير صحيح"); })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchBuildings(); }, []);

  const filtered = buildings
    .filter(b => activeTab === 'الكل' || b.status === activeTab)
    .filter(b => !searchTerm || b.title?.includes(searchTerm) || b.address?.includes(searchTerm) || b.type?.includes(searchTerm));

  const counts = { 'الكل': buildings.length, 'بيع': buildings.filter(b => b.status === 'بيع').length, 'إيجار': buildings.filter(b => b.status === 'إيجار').length };

  return (
    <div style={{ padding: '14px', marginTop: '70px', direction: 'rtl', maxWidth: '900px', margin: '70px auto 0' }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '800', color: '#1a1a2e' }}>🏘 السوق العقاري</h2>
          <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#888' }}>{buildings.length} عقار متاح</p>
        </div>
        <button onClick={() => setShowAddForm(true)} style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '12px', padding: '10px 16px',
          fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
        }}>＋ أضف عقارك</button>
      </div>

      {/* بحث */}
      <div style={{ position: 'relative', marginBottom: '14px' }}>
        <input
          value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
          placeholder="🔍 ابحث بالعنوان، الموقع، النوع..."
          style={{
            width: '100%', padding: '11px 14px', borderRadius: '12px',
            border: '1px solid #e0e0e0', fontSize: '14px', outline: 'none',
            background: '#fafafa', boxSizing: 'border-box',
          }}
        />
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '14px', overflowX: 'auto' }}>
        {tabs.map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{
            padding: '8px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer',
            background: activeTab === tab ? '#1a4187' : '#f0f4ff',
            color: activeTab === tab ? '#fff' : '#1a4187',
            fontWeight: '700', fontSize: '13px', whiteSpace: 'nowrap',
            display: 'flex', alignItems: 'center', gap: '5px',
          }}>
            {tab} <span style={{ background: activeTab === tab ? 'rgba(255,255,255,0.2)' : '#dce8ff', padding: '1px 6px', borderRadius: '10px', fontSize: '11px' }}>{counts[tab]}</span>
          </button>
        ))}
        <button onClick={() => setShowMap(!showMap)} style={{
          padding: '8px 14px', borderRadius: '20px', border: '1px solid #c7d7f8',
          background: showMap ? '#e8f0fe' : '#fff', color: '#1a4187',
          fontWeight: '700', fontSize: '13px', cursor: 'pointer', marginRight: 'auto',
        }}>
          {showMap ? '🗺 إخفاء الخريطة' : '🗺 خريطة العقارات'}
        </button>
      </div>

      {/* الخريطة */}
      {showMap && <BuildingsMap buildings={buildings} onSelect={setSelectedBuilding} />}

      {/* Loading / Error */}
      {loading && <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>⏳ جاري التحميل...</div>}
      {error && <div style={{ textAlign: 'center', color: '#e63946', padding: '20px' }}>{error}</div>}

      {/* بطاقات */}
      {!loading && !error && (
        filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '50px', color: '#888' }}>
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>🏠</div>
            <p style={{ fontWeight: '700' }}>لا توجد عقارات مطابقة</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: '16px' }}>
            {filtered.map(b => <BuildingCard key={b.id} b={b} onClick={setSelectedBuilding} />)}
          </div>
        )
      )}

      {/* Modals */}
      {selectedBuilding && <BuildingModal b={selectedBuilding} onClose={() => setSelectedBuilding(null)} />}
      {showAddForm && <AddBuildingForm onClose={() => setShowAddForm(false)} onAdded={fetchBuildings} />}
    </div>
  );
}
























function BankShopu() {
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const tabs = ["الكل", "إيجار", "بيع"];
  const location = useLocation();

useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "car" }),
  }).catch(() => {});
}, []);







  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get("category");
    if (category && tabs.includes(category)) {
      setActiveTab(category);
    }
  }, [location.search]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    fetch("https://syriacash.app/new/api.php?storercar", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("فشل تحميل المطاعم");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) setServices(data);
        else setError("تنسيق البيانات غير صحيح");
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const filteredServices =
    activeTab === "الكل"
      ? services
      : services.filter((s) => s.categories?.includes(activeTab));

  return (
    <>
      <style>{`
        .services-container { padding: 16px; }

        .tabs {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
          overflow-x: auto;
        }

        .tab-btn {
          padding: 8px 16px;
          border-radius: 20px;
          border: 1px solid #ddd;
          background: #fff;
          cursor: pointer;
          white-space: nowrap;
          transition: 0.2s;
        }

        .tab-btn.active {
          background: #1a4187;
          color: #fff;
          border-color: #111;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 15px;
        }

        .store-card {
          border: 1px solid #eee;
          border-radius: 14px;
          padding: 15px;
          background: #fff;
          text-decoration: none;
          color: inherit;
          display: block;
          transition: 0.2s;
          direction: rtl;
        }

        .store-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 22px rgba(0,0,0,0.08);
        }

        .store-card.disabled { opacity: .5; cursor: not-allowed; }

        .store-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }

        .store-title { font-size: 16px; font-weight: bold; }

        .store-status {
          font-size: 12px;
          padding: 4px 10px;
          border-radius: 20px;
        }

        .store-status.open { background:#e7f8f0; color:#0a8f5a; }
        .store-status.closed { background:#ffecec; color:#c0392b; }

        /* ================= تقسيم المستطيل ================= */
        .store-body {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .logo-part {
          width: 33%;
          height: 90px;
          border-radius: 10px;
          background:#f5f5f5;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .logo-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 10px;
        }

        .info-part {
          width: 67%;
        }

        .store-info { 
        font-size: 14px; margin-bottom: 10px;
        
        
        display: flex;
    flex-direction: row-reverse;
        
        
        }

        .store-categories {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
              flex-direction: row-reverse;
        }

        .category-badge {
          background: #f3f3f3;
          padding: 4px 10px;
          border-radius: 14px;
          font-size: 12px;
        }

        .loading,.error { text-align:center; margin-top:30px; }
        .error { color:red; }
      `}</style>

      <div className="services-container">
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {loading && <div className="loading">جاري التحميل...</div>}
        {error && <div className="error">{error}</div>}

        {!loading && !error && (
          <div className="cards-grid">
            {filteredServices.map((service) => {
              const isClosed = !service.is_open;

              return (
                <Link
                  key={service.id}
                  to={isClosed ? "#" : `/liststoreru/${service.id}`}
                  onClick={(e) => isClosed && e.preventDefault()}
                  className={`store-card ${isClosed ? "disabled" : ""}`}
                >
                  <div className="store-header">
                    <div className="store-title">{service.title}</div>
                    <span className={`store-status ${isClosed ? "closed" : "open"}`}>
                      {isClosed ? "غير متاح" : "متاح"}
                    </span>
                  </div>

                  <div className="store-body">
                    <div className="logo-part">
                      <img
                        src={service.logo || service.image || "https://via.placeholder.com/120"}
                        className="logo-img"
                        alt="logo"
                      />
                    </div>

                    <div className="info-part">
                      <div className="store-info">
                        🛒: {service.products_count ?? 0}
                      </div>

                      <div className="store-categories">
                        {service.categories?.map((cat, i) => (
                          <span key={i} className="category-badge">
                            {cat}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}




function ListStoreru() {
  const [allCars, setAllCars] = useState([]); // جميع السيارات الأصلية
  const [filteredCars, setFilteredCars] = useState([]); // السيارات بعد التصفية
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [rentLoading, setRentLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [rentPeriod, setRentPeriod] = useState("يومي"); // فترة الإيجار
  const [phoneNumber, setPhoneNumber] = useState(""); // رقم الهاتف للإيجار
  const [showPhoneModal, setShowPhoneModal] = useState(false); // عرض مودال الهاتف
  const [rentalCompanyName, setRentalCompanyName] = useState(""); // اسم شركة التأجير
  const { id } = useParams(); // جلب الـ id من الرابط /liststorer/:id



const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [fatherName, setFatherName] = useState("");
const [motherName, setMotherName] = useState("");
const [nationalId, setNationalId] = useState("");
const [birthDate, setBirthDate] = useState("");







  // فترات الإيجار
  const rentPeriods = [
    { id: "يومي", label: "يومي" },
    { id: "اسبوعي", label: "أسبوعي" },
    { id: "شهري", label: "شهري" }
  ];

  // ----------------- تحميل بيانات شركة التأجير وسياراتها -------------------
  useEffect(() => {
    if (!id) {
      setError("معرف شركة التأجير غير موجود");
      setLoading(false);
      return;
    }

    const numId = parseInt(id);
    
    // جلب اسم شركة التأجير
    fetch(`https://syriacash.app/new/api.php?rentalcompany&id=${numId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.company) {
          setRentalCompanyName(data.company.name);
        } else {
          setRentalCompanyName("شركة تأجير غير معروفة");
        }
      })
      .catch(() => {
        setRentalCompanyName("شركة تأجير غير معروفة");
      });

    // جلب جميع سيارات الشركة
    fetch(`https://syriacash.app/new/api.php?rentalcars&company_id=${numId}&limit=100`)
      .then((res) => res.json())
      .then((result) => {
        if (result.success && Array.isArray(result.data)) {
          setAllCars(result.data);
          setFilteredCars(result.data); // في البداية، تعرض جميع السيارات
        } else {
          setAllCars([]);
          setFilteredCars([]);
        }
      })
      .catch(() => {
        setError("فشل تحميل السيارات");
        setAllCars([]);
        setFilteredCars([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  // ----------------- البحث المحلي داخل السيارات -------------------
  useEffect(() => {
    if (searchTerm.trim() === "") {
      // إذا كان البحث فارغاً، عرض جميع السيارات
      setFilteredCars(allCars);
      return;
    }

    // البحث المحلي في اسم السيارة ومواصفاتها
    const searchLower = searchTerm.toLowerCase().trim();
    const filtered = allCars.filter(car => {
      const nameMatch = car.name?.toLowerCase().includes(searchLower);
      const brandMatch = car.brand?.toLowerCase().includes(searchLower);
      const modelMatch = car.model?.toLowerCase().includes(searchLower);
      const fuelMatch = car.fuel_type?.toLowerCase().includes(searchLower);
      const transmissionMatch = car.transmission?.toLowerCase().includes(searchLower);
      
      return nameMatch || brandMatch || modelMatch || fuelMatch || transmissionMatch;
    });

    setFilteredCars(filtered);
  }, [searchTerm, allCars]);

  // ----------------- فتح مودال السيارة -------------------
  const openCarModal = (car) => {
    setSelectedCar(car);
    setModalOpen(true);
  };

  // ----------------- فتح مودال طلب الإيجار -------------------
  const handleRentRequest = () => {
    setShowPhoneModal(true);
  };

  // ----------------- تأكيد طلب الإيجار -------------------
  const confirmRentRequest = async () => {
  
    if (
  !firstName.trim() ||
  !lastName.trim() ||
  !fatherName.trim() ||
  !motherName.trim() ||
  !nationalId.trim() ||
  !birthDate.trim() ||
  !phoneNumber.trim()
) {
  setMessage({ text: "❗ يرجى تعبئة جميع الحقول المطلوبة", type: "error" });
  return;
}


    if (!selectedCar) return;
    setRentLoading(true);

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?rentrequest`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
  car_id: selectedCar.id,
  company_id: id,
  period: rentPeriod,
  phone_number: phoneNumber,
  first_name: firstName,
  last_name: lastName,
  father_name: fatherName,
  mother_name: motherName,
  national_id: nationalId,
  birth_date: birthDate,
  user_token: localStorage.getItem("authToken") || null
}),



        }
      );

      const data = await res.json();

      if (data.success) {
        setMessage({ text: "✅ تم إرسال طلب الإيجار بنجاح! سنتصل بك قريباً.", type: "success" });
        setPhoneNumber("");
        setShowPhoneModal(false);
        setModalOpen(false);
      } else {
        setMessage({ text: data.message || "فشل إرسال الطلب", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setRentLoading(false);
    }
  };

  // ----------------- حساب سعر الفترة المحددة -------------------
  const calculatePrice = (car) => {
    if (!car) return 0;
    
    switch(rentPeriod) {
      case "يومي":
        return car.daily_price;
      case "اسبوعي":
        return car.weekly_price;
      case "شهري":
        return car.monthly_price;
      default:
        return car.daily_price;
    }
  };

  return (
    <>
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      <div className="services-container">
        {/* عرض اسم شركة التأجير */}
        {rentalCompanyName && (
          <div className="company-header">
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              {rentalCompanyName} - تأجير السيارات
            </h2>
          </div>
        )}

        {/* البحث المحلي */}
        <div className="search-box">
          <input
            type="text"
            placeholder={`ابحث عن سيارة (ماركة، موديل، نوع)...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </div>

        <p style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
          ⚠️ الخدمة متاحة حالياً في مدينة إدلب
        </p>

        {/* حالة التحميل */}
        {loading && (
          <p style={{ textAlign: "center" }}>⏳ جاري تحميل السيارات...</p>
        )}

        {/* حالة الخطأ */}
        {error && !loading && (
          <p style={{ textAlign: "center", color: "red" }}>{error}</p>
        )}

        {/* حالة عدم وجود سيارات */}
        {!loading && !error && filteredCars.length === 0 && searchTerm === "" && (
          <p style={{ textAlign: "center" }}>لا توجد سيارات متاحة للايجار</p>
        )}

        {!loading && !error && filteredCars.length === 0 && searchTerm !== "" && (
          <p style={{ textAlign: "center" }}>لم يتم العثور على سيارات تطابق بحثك</p>
        )}

        {/* عرض عدد النتائج عند البحث */}
        {!loading && !error && searchTerm !== "" && filteredCars.length > 0 && (
          <p style={{ textAlign: "center", color: "#666", fontSize: "14px" }}>
            تم العثور على {filteredCars.length} سيارة
          </p>
        )}

        {/* السيارات */}
        {filteredCars.length > 0 && (
          <div className="cards-grid">
            {filteredCars.map((car) => (
              <div
                key={car.id}
                className="car-card"
                onClick={() => openCarModal(car)}
              >
                <ImageWithSkeleton
                  src={`https://syriacash.app/images/${car.image}`}
                  alt={car.name}
                />
                <div className="card-info">
                  <div className="card-title">{car.name}</div>
                  
                  {/* مواصفات مختصرة */}
                  <div className="car-specs">
                    <div className="spec-item">
                      <i className="fas fa-cog"></i>
                      {car.transmission === "manual" ? "عادي" : "أوتوماتيك"}
                    </div>
                    <div className="spec-item">
                      <i className="fas fa-gas-pump"></i>
                      {car.fuel_type === "diesel" ? "مازوت" : "بنزين"}
                    </div>
                
                  </div>

                  {/* الأسعار */}
                  <div className="prices-container">
                    <div className="price-row">
                      <span>يومي:</span>
                      <span className="price-value">{car.daily_price} $</span>
                    </div>
                    <div className="price-row">
                      <span>أسبوعي:</span>
                      <span className="price-value">{car.weekly_price} $</span>
                    </div>
                    <div className="price-row">
                      <span>شهري:</span>
                      <span className="price-value">{car.monthly_price} $</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* مودال السيارة */}
      {modalOpen && selectedCar && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalOpen(false)}>
              ✖
            </button>

            <div className="modal-body">
            

              {/* صورة السيارة */}
              <div style={{ textAlign: "center", margin: "20px 0" }}>
                <img
                  src={`https://syriacash.app/images/${selectedCar.image}`}
                  alt={selectedCar.name}
                  style={{
                    width: "100%",
                    maxWidth: "250px",
                    borderRadius: "15px",
                  }}
                />
              </div>

              {/* معلومات الشركة */}
            

              {/* مواصفات السيارة */}
              <div className="car-details">
             
                <div className="detail-item">
                  <strong>الموديل:</strong> {selectedCar.model}
                </div>
                <div className="detail-item">
                  <strong>سنة الصنع:</strong> {selectedCar.year}
                </div>
                <div className="detail-item">
                  <strong>نوع القير:</strong> {selectedCar.transmission === "manual" ? "عادي" : "أوتوماتيك"}
                </div>
                <div className="detail-item">
                  <strong>نوع الوقود:</strong> {selectedCar.fuel_type === "diesel" ? "مازوت" : "بنزين"}
                </div>
                <div className="detail-item">
                  <strong>اللون:</strong> {selectedCar.color}
                </div>
                {selectedCar.seats && (
                  <div className="detail-item">
                    <strong>عدد المقاعد:</strong> {selectedCar.seats}
                  </div>
                )}
              </div>

              {/* وصف إضافي */}
              {selectedCar.description && (
                <p style={{ opacity: 0.7, margin: "15px 0" }}>
                  {selectedCar.description}
                </p>
              )}

              {/* اختيار فترة الإيجار */}
              <div className="rent-period-selector" style={{ margin: "20px 0" }}>
              
                <div className="period-buttons">
                  {rentPeriods.map((period) => (
                    <button
                      key={period.id}
                      className={`period-btn ${rentPeriod === period.id ? 'active' : ''}`}
                      onClick={() => setRentPeriod(period.id)}
                    >
                      {period.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* عرض السعر حسب الفترة */}
              <p style={{ fontSize: "18px", fontWeight: "bold", color: "#2ecc71", margin: "15px 0" }}>
                <strong>السعر:</strong> {calculatePrice(selectedCar)} $
              </p>

              {/* زر طلب الإيجار */}
              <button
                className="rent-btn"
                onClick={handleRentRequest}
                style={{
                  backgroundColor: "#0e0770ff",
                  color: "white",
                  padding: "12px 24px",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  width: "100%",
                  marginTop: "15px"
                }}
              >
                <i className="fas fa-car" style={{ marginLeft: "8px" }}></i>
                طلب تأجير السيارة
              </button>
            </div>
          </div>
        </div>
      )}

      {/* مودال إدخال رقم الهاتف */}
      {showPhoneModal && (
        <div className="modal-overlay" onClick={() => setShowPhoneModal(false)}>
          <div className="modal-content phone-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPhoneModal(false)}>
              ✖
            </button>
            
            <div className="modal-body">
              <h3>طلب تأجير سيارة</h3>
              
              <div style={{ margin: "20px 0" }}>
                <p>
                  <strong>السيارة:</strong> {selectedCar?.name}
                </p>
                <p>
                  <strong>فترة الإيجار:</strong> {rentPeriod}
                </p>
                <p>
                  <strong>المبلغ:</strong> {calculatePrice(selectedCar)} ₺
                </p>
              </div>

          

<div className="form-gridx">

  <div className="input-groupx">
    <label>الاسم</label>
    <input value={firstName} onChange={e=>setFirstName(e.target.value)} />
  </div>

  <div className="input-groupx">
    <label>الكنية</label>
    <input value={lastName} onChange={e=>setLastName(e.target.value)} />
  </div>

  <div className="input-groupx">
    <label>اسم الأب</label>
    <input value={fatherName} onChange={e=>setFatherName(e.target.value)} />
  </div>

  <div className="input-groupx">
    <label>اسم الأم والكنية</label>
    <input value={motherName} onChange={e=>setMotherName(e.target.value)} />
  </div>

  <div className="input-groupx full">
    <label>الرقم الوطني</label>
    <input value={nationalId} onChange={e=>setNationalId(e.target.value)} />
  </div>

  <div className="input-groupx">
    <label>تاريخ الميلاد</label>
    <input type="date" value={birthDate} onChange={e=>setBirthDate(e.target.value)} />
  </div>

  <div className="input-groupx full">
    <label>رقم الهاتف</label>
    <input
      type="tel"
      placeholder="09xxxxxxxx"
      value={phoneNumber}
      onChange={(e) => setPhoneNumber(e.target.value)}
    />
  </div>

</div>



              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className="cancel-btn"
                  onClick={() => setShowPhoneModal(false)}
                  style={{
                    flex: 1,
                    padding: "12px",
                    backgroundColor: "#e74c3c",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer"
                  }}
                >
                  إلغاء
                </button>
                
                <button
                  className="confirm-rent-btn"
                  onClick={confirmRentRequest}
                  disabled={rentLoading}
                  style={{
                    flex: 1,
                    padding: "12px",
                    backgroundColor: "#2ecc71",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: rentLoading ? "not-allowed" : "pointer"
                  }}
                >
                  {rentLoading ? "⏳ جاري الإرسال..." : "تأكيد طلب الإيجار"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}







function BankShopd() {
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [productLoading, setProductLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [quantity, setQuantity] = useState(1);
  const observer = useRef();
  const location = useLocation();

  // ----------------- تحميل التصنيفات -------------------
  useEffect(() => {
    fetch("https://syriacash.app/new/api.php?categoriesd")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setCategories([{ id: "all", name: "الكل" }, ...data]);
        } else {
          setError("خطأ في جلب التصنيفات");
        }
      })
      .catch(() => setError("فشل الاتصال بالخادم"))
      .finally(() => setLoading(false));
  }, []);

  // ----------------- تحديث التبويب من الرابط -------------------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");
    if (categoryParam) setActiveTab(categoryParam);
  }, [location.search]);

  // ----------------- تحميل المنتجات -------------------
  const loadProducts = useCallback(
    async (reset = false) => {
      setProductLoading(true);
      try {
        const currentPage = reset ? 1 : page;
        const categoryParam = activeTab === "الكل" ? "all" : activeTab;

        const res = await fetch(
          `https://syriacash.app/new/api.php?shopsd&id=${categoryParam}&page=${currentPage}&limit=20`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          const newProducts = result.data;
          setServices((prev) => (reset ? newProducts : [...prev, ...newProducts]));
          setHasMore(currentPage < (result.total_pages || 1));
        } else {
          setHasMore(false);
        }
      } catch {
        setError("فشل تحميل المنتجات");
      } finally {
        setProductLoading(false);
      }
    },
    [activeTab, page]
  );

  useEffect(() => {
    setPage(1);
    loadProducts(true);
  }, [activeTab]);

  // ----------------- تحميل المزيد عند التمرير -------------------
  const lastProductRef = useCallback(
    (node) => {
      if (productLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [productLoading, hasMore]
  );

  useEffect(() => {
    if (page > 1) loadProducts();
  }, [page]);

  // ----------------- البحث -------------------
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchTerm.trim() === "") {
        setPage(1);
        loadProducts(true);
        return;
      }

      setProductLoading(true);
      try {
        const res = await fetch(
          `https://syriacash.app/new/api.php?searchd=${encodeURIComponent(searchTerm)}`
        );
        const result = await res.json();

        if (result.success && Array.isArray(result.data)) {
          setServices(result.data);
          setHasMore(false);
        } else {
          setServices([]);
        }
      } catch {
        setError("فشل الاتصال أثناء البحث");
      } finally {
        setProductLoading(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // ----------------- فتح المودال -------------------
  const openProductModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  // ----------------- إضافة للسلة -------------------
  const handleAddToCart = async () => {
    if (!selectedProduct?.id) return;
    setCartLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?addToCartd&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: selectedProduct.id,
            quantity,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setMessage({ text: "✅ تمت إضافة المنتج إلى السلة!", type: "success" });
        setQuantity(1);
        setModalOpen(false);
      } else {
        setMessage({ text: data.message || "فشل الإضافة", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setCartLoading(false);
    }
  };

  return (
    <>
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      <div className="services-container">
        {/* البحث */}
        <div className="search-box">
          <input
            type="text"
            placeholder="ابحث عن منتج..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </div>

        <p style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
          ⚠️ الخدمة متاحة حالياً في مدينة إدلب
        </p>

        {/* التصنيفات */}
        {!loading && (
          <div className="tabs">
            {categories.map((cat) => (
              <button
                key={cat.id}
                className={`tab-btn ${activeTab === cat.id ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(cat.id);
                  setSearchTerm("");
                }}
              >
                {cat.name}
              </button>
            ))}
          </div>
        )}

        {/* المنتجات */}
        <div className="cards-grid">
          {services.map((service, i) => {
            const isLast = i === services.length - 1;
            return (
              <div
                ref={isLast ? lastProductRef : null}
                key={service.id}
                className="service-card"
                onClick={() => openProductModal(service)}
              >
                <ImageWithSkeleton
                  src={`https://syriacash.app/images/${service.image}`}
                  alt={service.name}
                />
                <div className="card-info">
                  <div className="card-title">{service.name}</div>

                  {/* 🔥 اسم المطعم */}
                  <div className="card-restaurant">
                    🍽 {service.restaurant_name || "مطعم غير معروف"}
                  </div>

                  {/* 🔥 وصف مختصر */}
                  <div className="card-desc">
                    {service.description?.slice(0, 40) || ""}
                  </div>

                  <div className="card-price">{service.price} ₺</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* مودال المنتج */}
        {modalOpen && selectedProduct && (
          <div className="modal-overlay" onClick={() => setModalOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setModalOpen(false)}>
                ✖
              </button>

              <div className="modal-body">
                <h2>{selectedProduct.name}</h2>

                {/* صورة */}
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                  <img
                    src={`https://syriacash.app/images/${selectedProduct.image}`}
                    alt={selectedProduct.name}
                    style={{
                      width: "100%",
                      maxWidth: "150px",
                      borderRadius: "15px",
                    }}
                  />
                </div>

                {/* 🔥 اسم المطعم */}
                <p>
                  <strong>المطعم:</strong> {selectedProduct.restaurant_name}
                </p>

                {/* 🔥 الوصف */}
                <p style={{ opacity: 0.7 }}>{selectedProduct.description}</p>

                <p>
                  <strong>السعر:</strong> {selectedProduct.price} ₺
                </p>

                {/* كمية */}
                <div className="quantity-control">
                  <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                  <span>{quantity}</span>
                  <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>
                    −
                  </button>
                </div>

                <button
                  className="add-to-cart-btn"
                  onClick={handleAddToCart}
                  disabled={cartLoading}
                >
                  {cartLoading ? "⏳ جاري الإضافة..." : "🛒 أضف إلى السلة"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}


function useProvinces() {
  const [provinces, setProvinces] = useState([]);
  useEffect(() => {
    fetch("https://syriacash.app/new/api.php?getProvinces")
      .then(res => res.json())
      .then(data => setProvinces(Array.isArray(data) ? data : []))
      .catch(() => setProvinces([]));
  }, []);
  return provinces;
}

function OpenShop() {
  const [services, setServices] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [error, setError] = useState("");
  const [loadingServices, setLoadingServices] = useState(true);
  const [loadingTabs, setLoadingTabs] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false); // ✅ حالة واضحة بدل ref فقط

  const provinces = useProvinces(); // ✅ hook مشترك بدل تكرار الكود

  const [filters, setFilters] = useState({
    condition: "",
    type: "",
    date: "",
    province: ""
  });

  const token = localStorage.getItem("authToken");
  const limit = 20;
  const offsetRef = useRef(0);
  const isFetchingRef = useRef(false); // ✅ قفل حقيقي يمنع أي تحميل مزدوج

useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "openshop" }),
  }).catch(() => {});
}, []);





  // --------------------- التبويبات ---------------------
  useEffect(() => {
    fetch(`https://syriacash.app/new/api.php?listopen`, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    })
      .then(res => res.ok ? res.json() : Promise.reject("فشل تحميل التبويبات"))
      .then(data => {
        if (!Array.isArray(data)) throw "خطأ في التبويبات";
        setTabs([{ id: "all", name: "الكل" }, ...data]);
        setActiveTab("all");
      })
      .catch(err => setError(String(err)))
      .finally(() => setLoadingTabs(false));
  }, [token]);

  // --------------------- جلب الخدمات (نسخة موحدة بلا ازدواجية) ---------------------
  const fetchServices = useCallback((tabId, offset = 0) => {
    if (isFetchingRef.current) return; // ✅ منع التحميل المزدوج
    isFetchingRef.current = true;
    setLoadingServices(true);

    const url = tabId === "all"
      ? `https://syriacash.app/new/api.php?liststoreshop&limit=${limit}&offset=${offset}`
      : `https://syriacash.app/new/api.php?liststoreshop&id=${tabId}&limit=${limit}&offset=${offset}`;

    fetch(url, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    })
      .then(res => res.ok ? res.json() : Promise.reject("فشل تحميل الخدمات"))
      .then(data => {
        if (!Array.isArray(data)) {
          setHasMore(false);
          return;
        }
        if (offset === 0) {
          setServices(data);
          offsetRef.current = data.length;
        } else {
          setServices(prev => [...prev, ...data]);
          offsetRef.current += data.length;
        }
        setHasMore(data.length >= limit); // ✅ منطق أوضح: لو رجع أقل من limit، خلص
      })
      .catch(err => setError(String(err)))
      .finally(() => {
        setLoadingServices(false);
        setLoadingMore(false);
        isFetchingRef.current = false;
      });
  }, [token]);

  // --------------------- عند تغيير التبويب (مكان واحد فقط للتحميل) ---------------------
  useEffect(() => {
    if (!activeTab) return;
    offsetRef.current = 0;
    setServices([]);
    setHasMore(true);
    fetchServices(activeTab, 0);
  }, [activeTab]); // ✅ ما في استدعاء يدوي مكرر بالـ onClick بعد الآن

  // --------------------- Infinite Scroll ---------------------
  useEffect(() => {
    const handleScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY + 150 >= document.body.offsetHeight;
      if (nearBottom && hasMore && !isFetchingRef.current && activeTab) {
        setLoadingMore(true);
        fetchServices(activeTab, offsetRef.current);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeTab, hasMore, fetchServices]);

  // --------------------- تطبيق الفلاتر محلياً ---------------------
  const filteredServices = services.filter(service =>
    (filters.condition === "" || service.condition === filters.condition) &&
    (filters.type === "" || service.type === filters.type) &&
    (filters.province === "" || service.province === filters.province) &&
    (filters.date === "" || service.date === filters.date)
  );

  return (
    <div className="services-container">

      {/* التبويبات */}
      <div className="tabs-scroll">
        {loadingTabs ? <LoadingSpinner text="جاري تحميل التبويبات..." /> :
          tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)} // ✅ فقط تغيير الحالة، الـ useEffect بيتكفل بالباقي
            >
              {tab.name}
            </button>
          ))
        }
      </div>

      {/* أزرار الإضافة ومنشوراتي */}
      <div className="action-buttons">
        <Link to="/addpro">
          <button className="add-btn">إضافة خدمة</button>
        </Link>
        <Link to="/openshopmy">
          <button className="my-posts-btn">منشوراتي</button>
        </Link>
      </div>

      {/* فلاتر متقدمة */}
      <div className="filters-container">
        <select
          value={filters.condition}
          onChange={(e) => setFilters({ ...filters, condition: e.target.value })}
        >
          <option value="">الكل - الحالة</option>
          <option value="جديد">جديد</option>
          <option value="مستعمل">مستعمل</option>
        </select>

        <select
          value={filters.type}
          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
        >
          <option value="">الكل - الحركة</option>
          <option value="عرض">عرض</option>
          <option value="طلب">طلب</option>
        </select>

        <input
          type="date"
          value={filters.date}
          onChange={(e) => setFilters({ ...filters, date: e.target.value })}
        />

        <select
          value={filters.province}
          onChange={(e) => setFilters({ ...filters, province: e.target.value })}
        >
          <option value="">الكل - القسم</option>
          {provinces.map(prov => <option key={prov} value={prov}>{prov}</option>)}
        </select>

        {/* ✅ زر مسح الفلاتر - جديد */}
        {(filters.condition || filters.type || filters.date || filters.province) && (
          <button
            onClick={() => setFilters({ condition: "", type: "", date: "", province: "" })}
            style={{ background: "#f0f0f0", border: "1px solid #ddd", borderRadius: "8px", padding: "8px 12px", cursor: "pointer" }}
          >
            ✕ مسح الفلاتر
          </button>
        )}
      </div>

      {/* عرض الخدمات */}
      {loadingServices && services.length === 0 ? (
        <LoadingSpinner text="جاري تحميل الخدمات..." />
      ) : error ? (
        <div style={{ color: "red", marginTop: "20px" }}>{error}</div>
      ) : filteredServices.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "20px", color: "#888" }}>
          <div style={{ fontSize: "36px", marginBottom: "8px" }}>📭</div>
          لا توجد خدمات مطابقة للفلاتر الحالية
        </div>
      ) : (
        <div className="cards-grid">
          {filteredServices.map(service => (
            <Link
              to={`/productsopen/${service.id}`}
              key={service.id}
              className="service-card-link"
            >
              <div className="service-card">
                <div className="card-icon">
                  <div className="image-wrapper">
                    {!service.icon ? (
                      <img
                        src="/images/default.png"
                        alt={service.title}
                        className="service-image visible"
                      />
                    ) : (
                      <ImageWithSkeleton src={`https://syriacash.app/new/${service.icon}`} alt={service.title} />
                    )}
                  </div>
                </div>

                <div className="card-title">{service.title}</div>
                <div className="card-desc">{service.description}</div>
                <div className="card-info">
                  <span>{service.type} | {service.condition}</span><br />
                  <span>{service.province} | {service.date}</span>
                </div>
                <div className="card-heart">
                  <i className={`fas fa-heart ${service.favorite ? "red" : ""}`}></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {/* ✅ مؤشرات واضحة لنهاية القائمة أو التحميل الإضافي */}
      {loadingMore && (
        <div style={{ textAlign: "center", margin: "20px", color: "#666" }}>
          ⏳ جاري تحميل المزيد...
        </div>
      )}
      {!loadingServices && !hasMore && services.length > 0 && (
        <div style={{ textAlign: "center", margin: "20px", color: "#aaa", fontSize: "13px" }}>
          — لا يوجد المزيد من النتائج —
        </div>
      )}

      <style jsx>{`
        .tabs-scroll {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;
          overflow-x: auto;
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
          padding-bottom: 5px;
        }

        .tab-btn {
          flex: 0 0 auto;
          padding: 8px 16px;
          border: none;
          border-radius: 8px;
          background: #f0f0f0;
          cursor: pointer;
          transition: 0.3s;
        }
        .tab-btn.active { background: #007bff; color: #fff; }

        .action-buttons {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;
        }
        .add-btn { background: #28a745; color: white; border-radius: 8px; padding: 8px 16px; border: none; cursor: pointer; }
        .add-btn:hover { background: #218838; }
        .my-posts-btn { background: #ffc107; color: #212529; border-radius: 8px; padding: 8px 16px; border: none; cursor: pointer; }
        .my-posts-btn:hover { background: #e0a800; }

        .filters-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
          margin-bottom: 15px;
        }
        select, input[type="date"] {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 15px;
        }
        .service-card {
          background: #fff;
          border-radius: 12px;
          padding: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          transition: transform 0.2s;
        }
        .service-card:hover { transform: translateY(-5px); }
        .service-image { width: 100%; height: 100px; object-fit: cover; border-radius: 8px; }
        .card-title { font-weight: bold; margin-top: 8px; }
        .card-desc { font-size: 14px; margin-top: 4px; }
        .card-info { font-size: 12px; color: #555; margin-top: 6px; }
        .card-heart { margin-top: 6px; color: #dc3545; }

        @media (max-width: 600px) {
          .action-buttons { flex-direction: row; justify-content: space-between; }
          .cards-grid { grid-template-columns: repeat(2, 1fr); }
        }
      `}</style>
    </div>
  );
}



function OpenShopMy() {
  const [services, setServices] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [error, setError] = useState("");
  const [loadingServices, setLoadingServices] = useState(true);
  const [loadingTabs, setLoadingTabs] = useState(true);
  const [message, setMessage] = useState({ text: "", type: "" }); // ✅ رسالة موحدة بدل alert
  const [deletingId, setDeletingId] = useState(null); // ✅ حالة تحميل واضحة أثناء الحذف

  const provinces = useProvinces();

  const [filters, setFilters] = useState({
    condition: "",
    type: "",
    date: "",
    province: ""
  });

  const token = localStorage.getItem("authToken");

  // جلب التبويبات
  useEffect(() => {
    fetch(`https://syriacash.app/new/api.php?listopen`, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    })
      .then(res => res.ok ? res.json() : Promise.reject("فشل تحميل التبويبات"))
      .then(data => {
        if (!Array.isArray(data)) throw "خطأ في التبويبات";
        setTabs([{ id: "all", name: "الكل" }, ...data]);
        setActiveTab("all");
      })
      .catch(err => setError(String(err)))
      .finally(() => setLoadingTabs(false));
  }, [token]);

  // جلب منشوراتي عند تغيير التبويب
  useEffect(() => {
    if (!activeTab) return;
    setLoadingServices(true);
    setError("");

    const url = activeTab === "all"
      ? `https://syriacash.app/new/api.php?liststoreshopmy&token=${token}`
      : `https://syriacash.app/new/api.php?liststoreshopmy&id=${activeTab}&token=${token}`;

    fetch(url, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    })
      .then(res => res.ok ? res.json() : Promise.reject("فشل تحميل الخدمات"))
      .then(data => Array.isArray(data) ? setServices(data) : setError("خطأ في البيانات"))
      .catch(err => setError(String(err)))
      .finally(() => setLoadingServices(false));
  }, [activeTab, token]);

  const filteredServices = services.filter(service =>
    (filters.condition === "" || service.condition === filters.condition) &&
    (filters.type === "" || service.type === filters.type) &&
    (filters.province === "" || service.province === filters.province) &&
    (filters.date === "" || service.date === filters.date)
  );

  // ✅ حذف منظم بدون alert المتصفح
  const handleDelete = (serviceId) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا المنتج؟")) return;
    setDeletingId(serviceId);

    fetch(`https://syriacash.app/new/api.php?deleteproduct&id=${serviceId}&token=${token}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setServices(prev => prev.filter(s => s.id !== serviceId));
          setMessage({ text: "🗑️ تم حذف المنتج بنجاح", type: "success" });
        } else {
          setMessage({ text: data.message || "حدث خطأ أثناء الحذف", type: "error" });
        }
      })
      .catch(() => setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" }))
      .finally(() => setDeletingId(null));
  };

  return (
    <div className="services-container">
      <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: "", type: "" })} />

      {/* التبويبات */}
      <div className="tabs-scroll">
        {loadingTabs ? <LoadingSpinner text="جاري تحميل التبويبات..." /> :
          tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))
        }
      </div>

      {/* الفلاتر */}
      <div className="filters-container">
        <select value={filters.condition} onChange={(e) => setFilters({ ...filters, condition: e.target.value })}>
          <option value="">الكل - الحالة</option>
          <option value="جديد">جديد</option>
          <option value="مستعمل">مستعمل</option>
        </select>

        <select value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })}>
          <option value="">الكل - الحركة</option>
          <option value="عرض">عرض</option>
          <option value="طلب">طلب</option>
        </select>

        <input type="date" value={filters.date} onChange={(e) => setFilters({ ...filters, date: e.target.value })} />

        <select value={filters.province} onChange={(e) => setFilters({ ...filters, province: e.target.value })}>
          <option value="">الكل - القسم</option>
          {provinces.map(prov => <option key={prov} value={prov}>{prov}</option>)}
        </select>
      </div>

      {/* عرض المنشورات */}
      {loadingServices ? (
        <LoadingSpinner text="جاري تحميل منشوراتك..." />
      ) : error ? (
        <div style={{ color: "red", marginTop: "20px" }}>{error}</div>
      ) : filteredServices.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "20px", color: "#888" }}>
          <div style={{ fontSize: "36px", marginBottom: "8px" }}>📝</div>
          لا توجد منشورات مطابقة للفلاتر الحالية
        </div>
      ) : (
        <div className="cards-grid">
          {filteredServices.map(service => (
            <div key={service.id} className="service-card">
              <div className="card-icon">
                <img
                  src={service.icon && service.icon !== "" ? `/new/${service.icon}` : "/images/default.png"}
                  alt={service.title}
                  className="service-image"
                />
              </div>
              <div className="card-title">{service.title}</div>
              <div className="card-desc">{service.description}</div>
              <div className="card-info">
                <span>{service.type} | {service.condition}</span><br />
                <span>{service.province} | {service.date}</span><br />
                <span className={service.status === "approved" ? "status-approved" : "status-pending"}>
                  {service.status === "approved" ? "✅ تم عرضه" : "⏳ في انتظار الموافقة"}
                </span>
              </div>
              <div className="card-actions">
                <button
                  className="edit-btn"
                  onClick={() => window.location.href = `/editproduct/${service.id}`}
                >
                  ✏️ تعديل
                </button>
                <button
                  className="delete-btn"
                  disabled={deletingId === service.id}
                  onClick={() => handleDelete(service.id)}
                >
                  {deletingId === service.id ? "⏳ جاري الحذف..." : "🗑️ حذف"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <style jsx>{`
        .tabs-scroll {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;
          overflow-x: auto;
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
          padding-bottom: 5px;
        }
        .tab-btn {
          flex: 0 0 auto;
          padding: 8px 16px;
          border: none;
          border-radius: 8px;
          background: #f0f0f0;
          cursor: pointer;
          transition: 0.3s;
        }
        .tab-btn.active { background: #007bff; color: #fff; }
        .tabs-scroll::-webkit-scrollbar { display: none; }

        .filters-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
          margin-bottom: 15px;
        }
        select, input[type="date"] {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 15px;
        }
        .service-card {
          background: #fff;
          border-radius: 12px;
          padding: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          transition: transform 0.2s;
        }
        .service-card:hover { transform: translateY(-5px); }
        .service-image { width: 100%; height: 100px; object-fit: cover; border-radius: 8px; }
        .card-title { font-weight: bold; margin-top: 8px; }
        .card-desc { font-size: 14px; margin-top: 4px; }
        .card-info { font-size: 12px; color: #555; margin-top: 6px; }
        .status-approved { color: #28a745; font-weight: 600; }
        .status-pending { color: #f0a500; font-weight: 600; }
        .card-actions { margin-top: 10px; display: flex; gap: 8px; }
        .edit-btn { flex: 1; padding: 6px 10px; border: none; border-radius: 6px; background: #007bff; color: white; cursor: pointer; }
        .edit-btn:hover { background: #0056b3; }
        .delete-btn { flex: 1; padding: 6px 10px; border: none; border-radius: 6px; background: #dc3545; color: white; cursor: pointer; }
        .delete-btn:hover { background: #a71d2a; }
        .delete-btn:disabled { background: #999; cursor: not-allowed; }

        @media (max-width: 600px) {
          .cards-grid { grid-template-columns: repeat(2, 1fr); }
        }
      `}</style>
    </div>
  );
}





function AddProductForm() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [condition, setCondition] = useState("");
  const [province, setProvince] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("SYP");
  const [images, setImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("error");
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const navigate = useNavigate();

const [provinces, setProvinces] = React.useState([]);

React.useEffect(() => {
  fetch("https://syriacash.app/new/api.php?getProvinces")
    .then(res => res.json())
    .then(data => setProvinces(data))
    .catch(err => console.error(err));
}, []);


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch("https://syriacash.app/new/api.php?listopen");
        const data = await res.json();
        if (Array.isArray(data)) setCategories(data);
      } catch (err) {
        console.error("خطأ في جلب الأقسام:", err);
      }
    };
    fetchCategories();
  }, []);

  const handleImageChange = (e) => setImages(Array.from(e.target.files));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description || !condition || !province || !category || !price || !currency) {
      setMessage("يرجى ملء جميع الحقول المطلوبة.");
      setMessageType("error");
      return;
    }

    if (images.length === 0) {
      setMessage("يرجى رفع صورة واحدة على الأقل.");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("");
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("type", "عرض");
    formData.append("title", title);
    formData.append("description", description);
    formData.append("condition", condition);
    formData.append("province", province);
    formData.append("category", category);
    formData.append("price", price);
    formData.append("currency", currency);
    images.forEach((img, index) => formData.append(`images[${index}]`, img));

    try {
      const token = localStorage.getItem("authToken");

      const xhr = new XMLHttpRequest();
      xhr.open("POST", `https://syriacash.app/new/api.php?addproduct&&token=${token}`);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) setUploadProgress(Math.round((event.loaded / event.total) * 100));
      };

      xhr.onload = () => {
        setLoading(false);
        setUploadProgress(0);
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText);
          if (data.success) {
            setMessage("تم إضافة المنتج بنجاح!");
            setMessageType("success");
            setTitle("");
            setDescription("");
            setCondition("");
            setProvince("");
            setCategory("");
            setPrice("");
            setCurrency("SYP");
            setImages([]);
            navigate("/openshopmy");
          } else {
            setMessage(data.message || "حدث خطأ أثناء الإضافة.");
            setMessageType("error");
          }
        } else {
          setMessage("خطأ في الاتصال بالخادم.");
          setMessageType("error");
        }
      };

      xhr.onerror = () => {
        setLoading(false);
        setUploadProgress(0);
        setMessage("خطأ أثناء رفع الملفات.");
        setMessageType("error");
      };

      xhr.send(formData);
    } catch (err) {
      setLoading(false);
      setUploadProgress(0);
      setMessage("خطأ في الاتصال بالخادم.");
      setMessageType("error");
    }
  };

  return (
    <div className="add-product-container">
      <h2>إضافة عرض جديد</h2>
      <form onSubmit={handleSubmit}>
        <label>
          اسم المنتج:
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </label>

        <label>
          الوصف:
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} required />
        </label>

        <label>
          الحالة:
          <select value={condition} onChange={(e) => setCondition(e.target.value)} required>
            <option value="">اختر الحالة</option>
            <option value="جديد">جديد</option>
            <option value="مستعمل">مستعمل</option>
          </select>
        </label>

        <label>
          المنطقة:
          <select value={province} onChange={(e) => setProvince(e.target.value)} required>
            <option value="">اختر المنطقة</option>
            {provinces.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </label>

        <label>
          القسم:
          <select value={category} onChange={(e) => setCategory(e.target.value)} required>
            <option value="">اختر القسم</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </label>

        <label>
          السعر:
          <input type="number" min="0" value={price} onChange={(e) => setPrice(e.target.value)} required />
        </label>

        <label>
          العملة:
          <select value={currency} onChange={(e) => setCurrency(e.target.value)} required>
            <option value="SYP">الليرة السورية</option>
            <option value="TRY">الليرة التركية</option>
            <option value="USD">الدولار</option>
          </select>
        </label>

        <label>
          الصور (مطلوبة):
          <input type="file" accept="image/*" multiple onChange={handleImageChange} />
        </label>

        <button type="submit" disabled={loading}>
          {loading ? "جارٍ الإضافة..." : "إضافة المنتج"}
        </button>

        {loading && (
          <div style={{ marginTop: "10px" }}>
            <div style={{ width: "100%", backgroundColor: "#f0f0f0", borderRadius: "8px", overflow: "hidden" }}>
              <div style={{ width: `${uploadProgress}%`, height: "8px", backgroundColor: "#28a745", transition: "width 0.2s" }} />
            </div>
            <p style={{ fontSize: "12px", marginTop: "4px" }}>{uploadProgress}%</p>
          </div>
        )}
      </form>

      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage("")}
      />

      <style jsx>{`
        .add-product-container {
          max-width: 500px;
          margin: auto;
          padding: 20px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          margin-top: 74px;
          direction: rtl;
        }
        h2 {
          text-align: center;
          margin-bottom: 20px;
        }
        form {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        label {
          display: flex;
          flex-direction: column;
          font-weight: bold;
          font-size: 14px;
        }
        input,
        select,
        textarea {
          padding: 8px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }
        textarea {
          resize: vertical;
          min-height: 80px;
        }
        button {
          padding: 10px;
          background: #28a745;
          color: #fff;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s;
        }
        button:disabled {
          background: #6c757d;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
}



function Store() {
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [showAddStore, setShowAddStore] = useState(false); // ✅ جديد

  const myAccount = localStorage.getItem("accountNumber"); // ✅ جديد

  const tabs = [
    "الكل",
    "مكتبات ودور نشر",
    "تجهيزات الشبكات",
    "العطورات",
    "الإكسسوارات",
  ];

  const location = useLocation();





useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "store" }),
  }).catch(() => {});
}, []);

  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");

    if (categoryParam && tabs.includes(categoryParam)) {
      setActiveTab(categoryParam);
    }
  }, [location.search]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    fetch("https://syriacash.app/new/api.php?store", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("فشل تحميل الخدمات");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setServices(data);
        } else {
          setError("خطأ في تنسيق البيانات");
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const filteredServices =
    activeTab === "الكل"
      ? services
      : services.filter((service) => service.category === activeTab);

  return (
    <div className="services-container">
      {/* ✅ زر إضافة متجر */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <button onClick={() => setShowAddStore(true)} style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '20px', padding: '9px 16px',
          fontSize: '13px', fontWeight: '700', cursor: 'pointer',
        }}>
          🏪 ＋ أضف متجرك
        </button>
      </div>

      {showAddStore && (
        <AddStoreForm onClose={() => setShowAddStore(false)} onAdded={() => {}} />
      )}

      {/* التبويبات */}
      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* تحميل أو خطأ */}
      {loading ? (
        <div>جاري تحميل الخدمات...</div>
      ) : error ? (
        <div style={{ color: "red" }}>{error}</div>
      ) : (
        <div className="cards-grid">
          {filteredServices.map((service, i) => {
            const isOwner = myAccount && service.owner_account && String(service.owner_account) === String(myAccount); // ✅ جديد

            return (
              <div key={i} style={{ position: 'relative' }}>
                {/* ✅ زر إدارة المتجر إذا كنت المالك */}
                {isOwner && (
                  <>
                    <span style={{
                      position: 'absolute', top: '10px', left: '10px', zIndex: 2,
                      background: '#1a4187', color: '#fff', fontSize: '11px', fontWeight: '700',
                      padding: '4px 10px', borderRadius: '20px', boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    }}>
                      👑 متجرك
                    </span>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = `/mystore`;
                      }}
                      style={{
                        position: 'absolute', bottom: '10px', left: '10px', zIndex: 2,
                        background: '#28a745', color: '#fff', border: 'none',
                        borderRadius: '10px', padding: '6px 12px', fontSize: '12px',
                        fontWeight: '700', cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                      }}
                    >
                      ✏️ إدارة المتجر
                    </button>
                  </>
                )}

                <Link
                  to={`/liststore/${service.id}`}
                  className="service-card-link"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="service-card">
                    <div className="card-icon">
                      <ImageWithSkeleton
                        src={`https://syriacash.app/images/${service.icon}`}
                        alt={service.title}
                      />
                    </div>

                    <div className="card-title">{service.title}</div>

                    <div className="card-products-count">
                      🛒 {service.products_count ?? 0}
                    </div>

                    <div className="card-desc">{service.description}</div>

                    <div className="card-heart">
                      <i
                        className={`fas fa-heart ${
                          service.favorite ? "red" : ""
                        }`}
                      ></i>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}








function Storer() {
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
const [showAddRestaurant, setShowAddRestaurant] = useState(false);
const tabs = ["الكل", "المشاوي", "الغربي", "البيتزا", "الحلويات و الضيافة", "المقاهي و الكوكتيل", "الشاورما", "العصائر"];
  const location = useLocation();


useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "restaurant" }),
  }).catch(() => {});
}, []);






  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get("category");
    if (category && tabs.includes(category)) {
      setActiveTab(category);
    }
  }, [location.search]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    fetch("https://syriacash.app/new/api.php?storer", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("فشل تحميل المطاعم");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) setServices(data);
        else setError("تنسيق البيانات غير صحيح");
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const filteredServices =
    activeTab === "الكل"
      ? services
      : services.filter((s) => s.categories?.includes(activeTab));

  return (
    <>
      <style>{`
        .services-container { padding: 16px; }

        .tabs {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
          overflow-x: auto;
        }

        .tab-btn {
          padding: 8px 16px;
          border-radius: 20px;
          border: 1px solid #ddd;
          background: #fff;
          cursor: pointer;
          white-space: nowrap;
          transition: 0.2s;
        }

        .tab-btn.active {
          background: #1a4187;
          color: #fff;
          border-color: #111;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 15px;
        }

        .store-card {
          border: 1px solid #eee;
          border-radius: 14px;
          padding: 15px;
          background: #fff;
          text-decoration: none;
          color: inherit;
          display: block;
          transition: 0.2s;
          direction: rtl;
        }

        .store-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 22px rgba(0,0,0,0.08);
        }

        .store-card.disabled { opacity: .5; cursor: not-allowed; }

        .store-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }

        .store-title { font-size: 16px; font-weight: bold; }

        .store-status {
          font-size: 12px;
          padding: 4px 10px;
          border-radius: 20px;
        }

        .store-status.open { background:#e7f8f0; color:#0a8f5a; }
        .store-status.closed { background:#ffecec; color:#c0392b; }

        /* ================= تقسيم المستطيل ================= */
        .store-body {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .logo-part {
          width: 33%;
          height: 90px;
          border-radius: 10px;
          background:#f5f5f5;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .logo-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 10px;
        }

        .info-part {
          width: 67%;
        }

        .store-info { 
        font-size: 14px; margin-bottom: 10px;
        
        
        display: flex;
    flex-direction: row-reverse;
        
        
        }

        .store-categories {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
              flex-direction: row-reverse;
        }

        .category-badge {
          background: #f3f3f3;
          padding: 4px 10px;
          border-radius: 14px;
          font-size: 12px;
        }

        .loading,.error { text-align:center; margin-top:30px; }
        .error { color:red; }
      `}</style>



      <div className="services-container">


  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
    <button onClick={() => setShowAddRestaurant(true)} style={{
      background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
      border: 'none', borderRadius: '20px', padding: '9px 16px',
      fontSize: '13px', fontWeight: '700', cursor: 'pointer',
    }}>
      🍽 ＋ أضف مطعمك
    </button>
  </div>

         {showAddRestaurant && (
    <AddRestaurantForm onClose={() => setShowAddRestaurant(false)} onAdded={() => {}} />
  )}
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {loading && <div className="loading">جاري التحميل...</div>}
        {error && <div className="error">{error}</div>}

        {!loading && !error && (



          <div className="cards-grid">
            {filteredServices.map((service) => {
              const isClosed = !service.is_open;

              return (
                <Link
                  key={service.id}
                  to={isClosed ? "#" : `/liststorer/${service.id}`}
                  onClick={(e) => isClosed && e.preventDefault()}
                  className={`store-card ${isClosed ? "disabled" : ""}`}
                >
                  <div className="store-header">
                    <div className="store-title">{service.title}</div>
                    <span className={`store-status ${isClosed ? "closed" : "open"}`}>
                      {isClosed ? "غير متاح" : "متاح"}
                    </span>
                  </div>

                  <div className="store-body">
                    <div className="logo-part">
                      <img
                        src={service.logo || service.image || "https://via.placeholder.com/120"}
                        className="logo-img"
                        alt="logo"
                      />
                    </div>

                    <div className="info-part">
                      <div className="store-info">
                        🛒: {service.products_count ?? 0}
                      </div>

                      <div className="store-categories">
                        {service.categories?.map((cat, i) => (
                          <span key={i} className="category-badge">
                            {cat}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}




function DrinksSidePanel({ isOpen, onClose }) {
  const [drinks, setDrinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addingId, setAddingId] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    fetch('https://syriacash.app/new/api.php?market_drinks')
      .then(res => res.json())
      .then(data => {
        if (data.success) setDrinks(data.data || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isOpen]);

  const handleAddToCart = (drink) => {
    setAddingId(drink.id);
    fetch(`https://syriacash.app/new/api.php?addToCart&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: drink.id, quantity: 1 }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage({ text: `✅ تمت إضافة ${drink.name} إلى السلة`, type: 'success' });
        } else {
          setMessage({ text: data.message || 'فشل الإضافة', type: 'error' });
        }
      })
      .catch(() => setMessage({ text: 'خطأ في الاتصال بالخادم', type: 'error' }))
      .finally(() => setAddingId(null));
  };

  if (!isOpen) return null;

  return (
    <>
      {/* خلفية معتمة */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          zIndex: 10000,
        }}
      />

      {/* اللوحة الجانبية المنزلقة */}
      <div
        style={{
          position: 'fixed', top: 0, left: 0, height: '100%', width: '85%', maxWidth: '360px',
          background: '#fff', zIndex: 10001, boxShadow: '4px 0 20px rgba(0,0,0,0.2)',
          display: 'flex', flexDirection: 'column',
          animation: 'slideInDrinks 0.25s ease-out',
        }}
      >
        <style>{`
          @keyframes slideInDrinks {
            from { transform: translateX(-100%); }
            to { transform: translateX(0); }
          }
        `}</style>

        {/* رأس اللوحة */}
        <div style={{
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <h3 style={{ margin: 0, fontSize: '17px', fontWeight: '800' }}>🥤 مشروبات من الماركيت</h3>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
            width: '30px', height: '30px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer',
          }}>✕</button>
        </div>

        <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

        {/* محتوى اللوحة */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '14px', direction: 'rtl' }}>
          {loading ? (
            <LoadingSpinner text="جاري تحميل المشروبات..." />
          ) : drinks.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#888', marginTop: '30px' }}>
              لا توجد مشروبات متاحة حالياً
            </p>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {drinks.map(drink => (
                <div key={drink.id} style={{
                  background: '#f9f9f9', borderRadius: '12px', padding: '8px',
                  textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                }}>
                  <img
                    src={drink.image ? `https://syriacash.app/images/${drink.image}` : 'https://via.placeholder.com/100'}
                    alt={drink.name}
                    style={{ width: '100%', height: '80px', objectFit: 'contain', marginBottom: '6px' }}
                  />
                  <p style={{ fontSize: '12px', fontWeight: '700', margin: '2px 0', minHeight: '32px' }}>{drink.name}</p>
                  <p style={{ fontSize: '13px', color: '#1a4187', fontWeight: '800', margin: '2px 0' }}>{drink.price} ₺</p>
                  <button
                    onClick={() => handleAddToCart(drink)}
                    disabled={addingId === drink.id}
                    style={{
                      width: '100%', padding: '6px', marginTop: '4px',
                      background: addingId === drink.id ? '#aaa' : '#28a745',
                      color: '#fff', border: 'none', borderRadius: '8px',
                      fontSize: '11px', fontWeight: '700',
                      cursor: addingId === drink.id ? 'wait' : 'pointer',
                    }}
                  >
                    {addingId === drink.id ? '⏳' : '🛒 أضف'}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}






function CommunityWall() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [content, setContent] = useState('');
  const [posting, setPosting] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [activeCommentsPostId, setActiveCommentsPostId] = useState(null);

  const offsetRef = useRef(0);
  const isFetchingRef = useRef(false);
  const limit = 15;

  const token = localStorage.getItem('authToken');
  const myAvatar = localStorage.getItem('userAvatar') || '/images/user.png';


useEffect(() => {
  const token = localStorage.getItem("authToken");
  fetch(`https://syriacash.app/new/api.php?mark_seen&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section: "community" }),
  }).catch(() => {});
}, []);





  const fetchPosts = (offset = 0) => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    if (offset === 0) setLoading(true); else setLoadingMore(true);

    fetch(`https://syriacash.app/new/api.php?community_wall&token=${token}&limit=${limit}&offset=${offset}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.posts)) {
          if (offset === 0) {
            setPosts(data.posts);
            offsetRef.current = data.posts.length;
          } else {
            setPosts(prev => [...prev, ...data.posts]);
            offsetRef.current += data.posts.length;
          }
          setHasMore(data.posts.length >= limit);
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        setLoadingMore(false);
        isFetchingRef.current = false;
      });
  };

  useEffect(() => { fetchPosts(0); }, []);

  useEffect(() => {
    const handleScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY + 150 >= document.body.offsetHeight;
      if (nearBottom && hasMore && !isFetchingRef.current) {
        fetchPosts(offsetRef.current);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasMore]);

  const handlePost = () => {
    const trimmed = content.trim();
    if (!trimmed) return;
    if (trimmed.length > 140) {
      setMessage({ text: 'الحد الأقصى 140 حرفاً', type: 'error' });
      return;
    }

    setPosting(true);
    fetch(`https://syriacash.app/new/api.php?add_community_post&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content: trimmed }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setContent('');
          setMessage({ text: data.message, type: 'success' });
        } else {
          setMessage({ text: data.message || 'فشل النشر', type: 'error' });
        }
      })
      .catch(() => setMessage({ text: 'خطأ في الاتصال بالخادم', type: 'error' }))
      .finally(() => setPosting(false));
  };

  const handleToggleLike = (postId) => {
    // تحديث فوري بالواجهة (Optimistic UI)
    setPosts(prev => prev.map(p => {
      if (p.id !== postId) return p;
      const nowLiked = !p.liked_by_me;
      return {
        ...p,
        liked_by_me: nowLiked,
        likes_count: nowLiked ? p.likes_count + 1 : Math.max(0, p.likes_count - 1),
      };
    }));

    fetch(`https://syriacash.app/new/api.php?toggle_like&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ postId }),
    }).catch(() => {});
  };

  const remaining = 140 - content.length;

  return (
    <div style={{ maxWidth: '600px', margin: '70px auto 20px', direction: 'rtl', padding: '0 14px' }}>
      <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

      <h2 style={{ textAlign: 'center', marginBottom: '16px' }}>💬 مجتمع سوريا كاش</h2>

      {/* فورم النشر */}
      <div style={{ background: '#fff', borderRadius: '14px', padding: '14px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', marginBottom: '18px' }}>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value.slice(0, 140))}
          placeholder="شو عم يصير معك اليوم؟ (140 حرف كحد أقصى)"
          style={{
            width: '100%', minHeight: '70px', border: '1px solid #e0e0e0', borderRadius: '10px',
            padding: '10px', fontSize: '14px', resize: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
          <span style={{ fontSize: '12px', color: remaining < 20 ? '#e63946' : '#888' }}>{remaining} حرف متبقي</span>
          <button
            onClick={handlePost}
            disabled={posting || !content.trim()}
            style={{
              background: posting || !content.trim() ? '#aaa' : 'linear-gradient(135deg,#1a4187,#2563eb)',
              color: '#fff', border: 'none', borderRadius: '20px', padding: '8px 18px',
              fontSize: '13px', fontWeight: '700', cursor: posting || !content.trim() ? 'not-allowed' : 'pointer',
            }}
          >
            {posting ? '⏳ جاري النشر...' : '📝 نشر'}
          </button>
        </div>
      </div>

      {/* قائمة المنشورات */}
      {loading ? (
        <LoadingSpinner text="جاري تحميل المنشورات..." />
      ) : posts.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#888' }}>لا توجد منشورات بعد، كن أول من ينشر! 🎉</p>
      ) : (
        posts.map(post => (
          <PostCard
            key={post.id}
            post={post}
            onToggleLike={() => handleToggleLike(post.id)}
            isCommentsOpen={activeCommentsPostId === post.id}
            onToggleComments={() => setActiveCommentsPostId(prev => prev === post.id ? null : post.id)}
          />
        ))
      )}

      {loadingMore && <p style={{ textAlign: 'center', color: '#666' }}>⏳ جاري تحميل المزيد...</p>}
      {!loading && !hasMore && posts.length > 0 && (
        <p style={{ textAlign: 'center', color: '#aaa', fontSize: '13px' }}>— لا يوجد المزيد من المنشورات —</p>
      )}
    </div>
  );
}


function PostCard({ post, onToggleLike, isCommentsOpen, onToggleComments }) {
  const isPending = post.status === 'pending';
  const isRejected = post.status === 'rejected';
  const isMuted = isPending || isRejected; // ✅ حالة العرض الرمادي

  return (
    <div style={{
      background: isMuted ? '#f2f2f2' : '#fff',
      borderRadius: '14px',
      padding: '14px',
      marginBottom: '12px',
      boxShadow: isMuted ? 'none' : '0 2px 8px rgba(0,0,0,0.06)',
      border: isMuted ? '1px dashed #ccc' : 'none',
      opacity: isMuted ? 0.65 : 1,
      position: 'relative',
    }}>
      {/* ✅ شارة الحالة */}
      {isPending && (
        <span style={{
          position: 'absolute', top: '10px', left: '10px',
          background: '#ffc107', color: '#5c4400', fontSize: '10px', fontWeight: '700',
          padding: '3px 10px', borderRadius: '20px',
        }}>
          ⏳ قيد المراجعة
        </span>
      )}
      {isRejected && (
        <span style={{
          position: 'absolute', top: '10px', left: '10px',
          background: '#f5c6cb', color: '#721c24', fontSize: '10px', fontWeight: '700',
          padding: '3px 10px', borderRadius: '20px',
        }}>
          ❌ تم الرفض
        </span>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
        <img
          src={post.user_image || '/images/user.png'}
          alt={post.user_name}
          style={{
            width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover',
            filter: isMuted ? 'grayscale(60%)' : 'none', // ✅ صورة رمادية شوي
          }}
        />
        <div>
          <p style={{ margin: 0, fontWeight: '700', fontSize: '14px', color: isMuted ? '#777' : '#000' }}>{post.user_name}</p>
          <p style={{ margin: 0, fontSize: '11px', color: '#999' }}>{post.date}</p>
        </div>
      </div>

      <p style={{
        margin: '0 0 10px', fontSize: '14px', lineHeight: '1.6', wordBreak: 'break-word',
        color: isMuted ? '#666' : '#000',
      }}>
        {post.content}
      </p>

      {/* ✅ التفاعلات معطّلة للمنشورات قيد المراجعة/المرفوضة */}
      {!isMuted && (
        <div style={{ display: 'flex', gap: '18px', borderTop: '1px solid #f0f0f0', paddingTop: '8px' }}>
          <button
            onClick={onToggleLike}
            style={{
              background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
              color: post.liked_by_me ? '#e63946' : '#888', fontSize: '13px', fontWeight: '700',
            }}
          >
            <i className={`fas fa-heart`} style={{ color: post.liked_by_me ? '#e63946' : '#ccc' }}></i>
            {post.likes_count}
          </button>

          <button
            onClick={onToggleComments}
            style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', color: '#888', fontSize: '13px', fontWeight: '700' }}
          >
            <i className="fas fa-comment"></i> {post.comments_count}
          </button>
        </div>
      )}

      {isMuted && (
        <p style={{ fontSize: '11px', color: '#999', margin: '6px 0 0', textAlign: 'center' }}>
          {isPending ? '👁️ هذا المنشور مرئي لك فقط حتى تتم مراجعته' : '⚠️ هذا المنشور لم يُوافق عليه'}
        </p>
      )}

      {isCommentsOpen && !isMuted && <CommentsSection postId={post.id} />}
    </div>
  );
}






function CommentsSection({ postId }) {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newComment, setNewComment] = useState('');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');

  const token = localStorage.getItem('authToken');

const fetchComments = () => {
  setLoading(true);
  fetch(`https://syriacash.app/new/api.php?get_comments&postId=${postId}&token=${token}`)
    .then(res => res.json())
    .then(data => {
      if (data.success) setComments(data.comments || []);
    })
    .finally(() => setLoading(false));
};

  useEffect(() => { fetchComments(); }, [postId]);

  const handleSend = () => {
    const trimmed = newComment.trim();
    if (!trimmed) return;
    if (trimmed.length > 140) {
      setMsg('الحد الأقصى 140 حرفاً');
      return;
    }

    setSending(true);
    fetch(`https://syriacash.app/new/api.php?add_comment&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ postId, content: trimmed }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setNewComment('');
          setMsg(data.message);
        } else {
          setMsg(data.message || 'فشل الإرسال');
        }
      })
      .catch(() => setMsg('خطأ في الاتصال بالخادم'))
      .finally(() => setSending(false));
  };

  return (
    <div style={{ marginTop: '10px', borderTop: '1px dashed #eee', paddingTop: '10px' }}>
      {loading ? (
        <p style={{ fontSize: '12px', color: '#888' }}>⏳ جاري تحميل التعليقات...</p>
      ) : comments.length === 0 ? (
        <p style={{ fontSize: '12px', color: '#888' }}>لا توجد تعليقات بعد</p>
      ) : (
        comments.map(c => (
          <div key={c.id} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
            <img src={c.user_image || '/images/user.png'} alt="" style={{ width: '26px', height: '26px', borderRadius: '50%', objectFit: 'cover' }} />
            <div style={{ background: '#f5f5f5', borderRadius: '10px', padding: '6px 10px', flex: 1 }}>
              <p style={{ margin: 0, fontSize: '12px', fontWeight: '700' }}>{c.user_name}</p>
              <p style={{ margin: 0, fontSize: '13px' }}>{c.content}</p>
            </div>
          </div>
        ))
      )}

      <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
        <input
          value={newComment}
          onChange={(e) => setNewComment(e.target.value.slice(0, 140))}
          placeholder="اكتب تعليقاً..."
          style={{ flex: 1, padding: '8px 10px', borderRadius: '20px', border: '1px solid #ddd', fontSize: '13px' }}
        />
        <button
          onClick={handleSend}
          disabled={sending || !newComment.trim()}
          style={{
            background: sending ? '#aaa' : '#1a4187', color: '#fff', border: 'none',
            borderRadius: '20px', padding: '8px 14px', fontSize: '12px', fontWeight: '700',
            cursor: sending ? 'not-allowed' : 'pointer',
          }}
        >
          {sending ? '⏳' : 'إرسال'}
        </button>
      </div>

      {msg && <p style={{ fontSize: '11px', color: '#e63946', marginTop: '4px' }}>{msg}</p>}
    </div>
  );
}


function ListStore() {
  const [services, setServices] = useState([]); // كل المنتجات المجلوبة
  const [displayedServices, setDisplayedServices] = useState([]); // المنتجات المعروضة
  const [tabs, setTabs] = useState(["الكل"]);
  const [activeTab, setActiveTab] = useState("الكل");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const { id } = useParams();
  const location = useLocation();

  const [storeInfo, setStoreInfo] = useState(null); // بيانات المتجر كاملة (فيها owner_account)
  const myAccount = localStorage.getItem("accountNumber");
  const isOwner = storeInfo?.owner_account && String(storeInfo.owner_account) === String(myAccount);
  const [showProductForm, setShowProductForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null); // ✅ لمعرفة أي منتج قيد الحذف حالياً
  const [message, setMessage] = useState({ text: "", type: "" });

  const limit = 20; // عدد المنتجات لكل تحميل
  const offsetRef = useRef(0);
  const loadingMoreRef = useRef(false);

  // --------------------- جلب بيانات المتجر (الاسم + owner_account) ---------------------
  useEffect(() => {
    fetch(`https://syriacash.app/new/api.php?store_info&id=${id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.store) {
          setStoreInfo(data.store);
        }
      })
      .catch(() => {});
  }, [id]);

  // --------------------- جلب التبويبات ---------------------
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    fetch(`https://syriacash.app/new/api.php?listTabs&id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(res => {
        if (!res.ok) throw new Error("فشل تحميل التبويبات");
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data)) setTabs(["الكل", ...data.map(t => t.name)]);
        else setError("خطأ في تنسيق التبويبات");
      })
      .catch(err => setError(err.message));
  }, [id]);

  // --------------------- تبويب من الـ query string ---------------------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get("category");
    if (categoryParam && tabs.includes(categoryParam)) setActiveTab(categoryParam);
  }, [location.search, tabs]);

  // --------------------- جلب الخدمات ---------------------
  const fetchServices = (offset = 0, q = "") => {
    loadingMoreRef.current = true;
    const token = localStorage.getItem("authToken");

    let url = `https://syriacash.app/new/api.php?liststore&id=${id}&limit=${limit}&offset=${offset}`;
    if (q.trim() !== "") url += `&q=${encodeURIComponent(q)}`;

    fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (!res.ok) throw new Error("فشل تحميل الخدمات");
        return res.json();
      })
      .then(data => {
        if (data.success && Array.isArray(data.services)) {
          if (offset === 0 || q.trim() !== "") {
            setServices(data.services);
            setDisplayedServices(data.services);
            offsetRef.current = data.services.length;
          } else {
            setServices(prev => [...prev, ...data.services]);
            setDisplayedServices(prev => [...prev, ...data.services]);
            offsetRef.current += data.services.length;
          }
        } else {
          if (offset === 0 || q.trim() !== "") {
            setServices([]);
            setDisplayedServices([]);
          }
        }
      })
      .catch(err => setError(err.message))
      .finally(() => {
        setLoading(false);
        loadingMoreRef.current = false;
      });
  };

  // --------------------- تحميل أول ---------------------
  useEffect(() => {
    fetchServices();
  }, [id]);

  // --------------------- البحث التلقائي عند كتابة 3 أحرف ---------------------
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim().length >= 3) {
        offsetRef.current = 0;
        fetchServices(0, searchTerm);
      } else if (searchTerm.trim() === "") {
        // مسح البحث
        offsetRef.current = 0;
        fetchServices();
      }
    }, 500); // تأخير 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // --------------------- البحث عند الضغط على Enter ---------------------
  const handleSearch = () => {
    offsetRef.current = 0;
    fetchServices(0, searchTerm);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  // --------------------- Infinite Scroll ---------------------
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 100 >=
          document.documentElement.scrollHeight &&
        !loadingMoreRef.current &&
        searchTerm.trim() === ""
      ) {
        fetchServices(offsetRef.current);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [searchTerm]);

  // --------------------- تصفية حسب التبويب ---------------------
  const filteredServices = displayedServices.filter(
    service => activeTab === "الكل" || service.category === activeTab
  );

  // --------------------- تحديث القوائم محلياً بعد حفظ منتج ---------------------
  const updateProductInLists = (saved) => {
    const updater = (list) => {
      const exists = list.some(p => p.id === saved.id);
      if (exists) {
        return list.map(p =>
          p.id === saved.id
            ? { ...p, title: saved.name, description: saved.description, icon: saved.image }
            : p
        );
      }
      return [...list, { id: saved.id, title: saved.name, description: saved.description, icon: saved.image }];
    };
    setServices(prev => updater(prev));
    setDisplayedServices(prev => updater(prev));
  };

  // --------------------- حذف منتج من القوائم محلياً ---------------------
  const removeProductFromLists = (productId) => {
    setServices(prev => prev.filter(p => p.id !== productId));
    setDisplayedServices(prev => prev.filter(p => p.id !== productId));
  };

  // --------------------- فتح فورم التعديل بجلب البيانات الخام الصحيحة ---------------------
  const openEditProduct = async (service) => {
    setEditLoading(true);
    try {
      const res = await fetch(`https://syriacash.app/new/api.php?get_store_product_raw&id=${service.id}`);
      const data = await res.json();
      if (data.success && data.product) {
        setEditingProduct(data.product); // ✅ بيانات خام صحيحة: name, price, description, image
      } else {
        // fallback في حال فشل الجلب
        setEditingProduct({ id: service.id, name: service.title, image: service.icon, description: "", price: "" });
      }
    } catch {
      setEditingProduct({ id: service.id, name: service.title, image: service.icon, description: "", price: "" });
    } finally {
      setEditLoading(false);
      setShowProductForm(true);
    }
  };

  // --------------------- حذف منتج ---------------------
  const handleDeleteProduct = async (productId) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا المنتج؟")) return;

    setDeletingId(productId);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(`https://syriacash.app/new/api.php?delete_store_product&token=${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId }),
      });
      const data = await res.json();

      if (data.success) {
        removeProductFromLists(productId);
        setMessage({ text: "🗑️ تم حذف المنتج بنجاح", type: "success" });
      } else {
        setMessage({ text: data.message || "فشل حذف المنتج", type: "error" });
      }
    } catch {
      setMessage({ text: "خطأ في الاتصال بالخادم", type: "error" });
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="services-container">
      <MessageDisplay
        message={message.text}
        type={message.type}
        onClose={() => setMessage({ text: "", type: "" })}
      />

      {/* ✅ شارة + زر إضافة منتج - تظهر فقط لصاحب المتجر */}
      {isOwner && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: '10px',
          padding: '10px 14px', marginBottom: '14px', flexWrap: 'wrap', gap: '8px',
        }}>
          <span style={{ color: '#2e7d32', fontWeight: '700', fontSize: '13px' }}>
            👑 أنت مالك هذا المتجر
          </span>
          <button
            onClick={() => { setEditingProduct(null); setShowProductForm(true); }}
            style={{
              background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
              border: 'none', borderRadius: '20px', padding: '8px 14px',
              fontSize: '13px', fontWeight: '700', cursor: 'pointer',
            }}
          >
            ＋ أضف منتج
          </button>
        </div>
      )}

      {/* 🔍 شريط البحث */}
      <div className="search-box">
        <input
          type="text"
          placeholder="ابحث عن منتج..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          className="search-input"
        />
        <button className="search-btn" onClick={handleSearch}>
          <i className="fas fa-search"></i>
        </button>
      </div>

      {/* التبويبات */}
      <div className="tabs">
        {tabs.map(tab => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => {
              setActiveTab(tab);
              if (tab === "الكل") {
                setSearchTerm(""); // مسح البحث عند الضغط على "الكل"
                offsetRef.current = 0;
                fetchServices(); // جلب كل الخدمات
              } else {
                setDisplayedServices(services.filter(s => s.category === tab));
              }
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* تحميل أو خطأ */}
      {loading ? (
        <div>جاري تحميل الخدمات...</div>
      ) : error ? (
        <div style={{ color: "red" }}>{error}</div>
      ) : filteredServices.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>لا توجد منتجات مطابقة</div>
      ) : (
        <div className="cards-grid">
          {filteredServices.map(service => (
            <div key={service.id} className="service-card-link" style={{ position: 'relative', display: 'block' }}>
              {/* ✅ أزرار التعديل والحذف - تظهر فقط لصاحب المتجر */}
              {isOwner && (
                <div style={{
                  position: 'absolute', top: '8px', left: '8px', zIndex: 2,
                  display: 'flex', gap: '6px',
                }}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openEditProduct(service);
                    }}
                    disabled={editLoading || deletingId === service.id}
                    style={{
                      background: editLoading ? '#888' : '#1a4187', color: '#fff', border: 'none',
                      borderRadius: '8px', padding: '4px 10px', fontSize: '11px',
                      fontWeight: '700', cursor: editLoading ? 'wait' : 'pointer',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                    }}
                  >
                    {editLoading ? '⏳' : '✏️ تعديل'}
                  </button>

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDeleteProduct(service.id);
                    }}
                    disabled={deletingId === service.id || editLoading}
                    style={{
                      background: deletingId === service.id ? '#888' : '#c0392b', color: '#fff', border: 'none',
                      borderRadius: '8px', padding: '4px 10px', fontSize: '11px',
                      fontWeight: '700', cursor: deletingId === service.id ? 'wait' : 'pointer',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                    }}
                  >
                    {deletingId === service.id ? '⏳' : '🗑️ حذف'}
                  </button>
                </div>
              )}

              <Link
                to={`/products/${service.id}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="service-card">
                  <div className="card-icon">
                    <ImageWithSkeleton
                      src={`https://syriacash.app/images/${service.icon}`}
                      alt={service.title}
                    />
                  </div>
                  <div className="card-title">{service.title}</div>
                  <div className="card-desc">{service.description}</div>
                  <div className="card-heart">
                    <i className={`fas fa-heart ${service.favorite ? "red" : ""}`}></i>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}

      {/* ✅ فورم إضافة/تعديل منتج - يظهر فقط لصاحب المتجر */}
      {showProductForm && (
        <StoreProductForm
          product={editingProduct}
          storeId={storeInfo?.id || id}
          onClose={() => setShowProductForm(false)}
          onSaved={(saved) => {
            updateProductInLists(saved);
            setShowProductForm(false);
            setMessage({ text: "✅ تم حفظ المنتج بنجاح", type: "success" });
          }}
        />
      )}
    </div>
  );
}






function EditProductForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [condition, setCondition] = useState("");
  const [province, setProvince] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("SYP");
  const [existingImages, setExistingImages] = useState([]); // ✅ الصور الحالية المحفوظة
  const [newImages, setNewImages] = useState([]); // ✅ الصور الجديدة (اختياري)
  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("error");
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true); // ✅ تحميل بيانات المنتج أول مرة
  const [uploadProgress, setUploadProgress] = useState(0);

  const provinces = useProvinces(); // ✅ نفس الـ hook المشترك

  const token = localStorage.getItem("authToken");

  // ✅ جلب التصنيفات
  useEffect(() => {
    fetch("https://syriacash.app/new/api.php?listopen")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setCategories(data);
      })
      .catch(err => console.error("خطأ في جلب الأقسام:", err));
  }, []);

  // ✅ جلب بيانات المنتج الحالية للتعديل
  useEffect(() => {
    if (!id) return;
    fetch(`https://syriacash.app/new/api.php?get_openshop_product&id=${id}&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.product) {
          const p = data.product;
          setTitle(p.title || "");
          setDescription(p.description || "");
          setCondition(p.condition || "");
          setProvince(p.province || "");
          setCategory(p.category || "");
          setPrice(p.price || "");
          setCurrency(p.currency || "SYP");
          setExistingImages(Array.isArray(p.images) ? p.images : []);
        } else {
          setMessage(data.message || "تعذر تحميل بيانات المنتج");
          setMessageType("error");
        }
      })
      .catch(() => {
        setMessage("خطأ في الاتصال بالخادم");
        setMessageType("error");
      })
      .finally(() => setPageLoading(false));
  }, [id, token]);

  const handleImageChange = (e) => setNewImages(Array.from(e.target.files));

  const removeExistingImage = (index) => {
    setExistingImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description || !condition || !province || !category || !price || !currency) {
      setMessage("يرجى ملء جميع الحقول المطلوبة.");
      setMessageType("error");
      return;
    }

    if (isNaN(price) || Number(price) <= 0) {
      setMessage("يرجى إدخال سعر صحيح أكبر من صفر.");
      setMessageType("error");
      return;
    }

    if (existingImages.length === 0 && newImages.length === 0) {
      setMessage("يرجى الإبقاء على صورة واحدة على الأقل أو رفع صورة جديدة.");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("");
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("productId", id);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("condition", condition);
    formData.append("province", province);
    formData.append("category", category);
    formData.append("price", price);
    formData.append("currency", currency);
    formData.append("existingImages", JSON.stringify(existingImages)); // ✅ الصور المتبقية بعد الحذف
    newImages.forEach((img, index) => formData.append(`images[${index}]`, img));

    try {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `https://syriacash.app/new/api.php?updateproduct&token=${token}`);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) setUploadProgress(Math.round((event.loaded / event.total) * 100));
      };

      xhr.onload = () => {
        setLoading(false);
        setUploadProgress(0);
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText);
          if (data.success) {
            setMessage("✅ تم تعديل المنتج بنجاح!");
            setMessageType("success");
            setTimeout(() => navigate("/openshopmy"), 1200);
          } else {
            setMessage(data.message || "حدث خطأ أثناء التعديل.");
            setMessageType("error");
          }
        } else {
          setMessage("خطأ في الاتصال بالخادم.");
          setMessageType("error");
        }
      };

      xhr.onerror = () => {
        setLoading(false);
        setUploadProgress(0);
        setMessage("خطأ أثناء رفع الملفات.");
        setMessageType("error");
      };

      xhr.send(formData);
    } catch (err) {
      setLoading(false);
      setUploadProgress(0);
      setMessage("خطأ في الاتصال بالخادم.");
      setMessageType("error");
    }
  };

  if (pageLoading) return <LoadingSpinner text="جاري تحميل بيانات المنتج..." />;

  return (
    <div className="add-product-container">
      <h2>تعديل العرض</h2>
      <form onSubmit={handleSubmit}>
        <label>
          اسم المنتج:
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </label>

        <label>
          الوصف:
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} required />
        </label>

        <label>
          الحالة:
          <select value={condition} onChange={(e) => setCondition(e.target.value)} required>
            <option value="">اختر الحالة</option>
            <option value="جديد">جديد</option>
            <option value="مستعمل">مستعمل</option>
          </select>
        </label>

        <label>
          المنطقة:
          <select value={province} onChange={(e) => setProvince(e.target.value)} required>
            <option value="">اختر المنطقة</option>
            {provinces.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </label>

        <label>
          القسم:
          <select value={category} onChange={(e) => setCategory(e.target.value)} required>
            <option value="">اختر القسم</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </label>

        <label>
          السعر:
          <input type="number" min="0" value={price} onChange={(e) => setPrice(e.target.value)} required />
        </label>

        <label>
          العملة:
          <select value={currency} onChange={(e) => setCurrency(e.target.value)} required>
            <option value="SYP">الليرة السورية</option>
            <option value="TRY">الليرة التركية</option>
            <option value="USD">الدولار</option>
          </select>
        </label>

        {/* ✅ عرض الصور الحالية مع إمكانية حذفها */}
        {existingImages.length > 0 && (
          <div style={{ marginBottom: "10px" }}>
            <p style={{ fontWeight: "bold", fontSize: "13px", marginBottom: "6px" }}>الصور الحالية:</p>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              {existingImages.map((img, i) => (
                <div key={i} style={{ position: "relative" }}>
                  <img
                    src={img.startsWith('http') ? img : `https://syriacash.app/new/${img}`}
                    alt=""
                    style={{ width: "70px", height: "70px", borderRadius: "8px", objectFit: "cover" }}
                  />
                  <button
                    type="button"
                    onClick={() => removeExistingImage(i)}
                    style={{
                      position: "absolute", top: "-6px", left: "-6px",
                      background: "#e74c3c", color: "#fff", border: "none",
                      borderRadius: "50%", width: "20px", height: "20px",
                      fontSize: "11px", cursor: "pointer",
                    }}
                  >✕</button>
                </div>
              ))}
            </div>
          </div>
        )}

        <label>
          إضافة صور جديدة (اختياري):
          <input type="file" accept="image/*" multiple onChange={handleImageChange} />
        </label>

        {newImages.length > 0 && (
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "10px" }}>
            {newImages.map((img, i) => (
              <img key={i} src={URL.createObjectURL(img)} alt=""
                style={{ width: "70px", height: "70px", borderRadius: "8px", objectFit: "cover" }} />
            ))}
          </div>
        )}

        <button type="submit" disabled={loading}>
          {loading ? "جارٍ الحفظ..." : "💾 حفظ التعديلات"}
        </button>

        {loading && (
          <div style={{ marginTop: "10px" }}>
            <div style={{ width: "100%", backgroundColor: "#f0f0f0", borderRadius: "8px", overflow: "hidden" }}>
              <div style={{ width: `${uploadProgress}%`, height: "8px", backgroundColor: "#28a745", transition: "width 0.2s" }} />
            </div>
            <p style={{ fontSize: "12px", marginTop: "4px" }}>{uploadProgress}%</p>
          </div>
        )}
      </form>

      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage("")}
      />

      <style jsx>{`
        .add-product-container {
          max-width: 500px;
          margin: auto;
          padding: 20px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          margin-top: 74px;
          direction: rtl;
        }
        h2 {
          text-align: center;
          margin-bottom: 20px;
        }
        form {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        label {
          display: flex;
          flex-direction: column;
          font-weight: bold;
          font-size: 14px;
        }
        input,
        select,
        textarea {
          padding: 8px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }
        textarea {
          resize: vertical;
          min-height: 80px;
        }
        button {
          padding: 10px;
          background: #28a745;
          color: #fff;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s;
        }
        button:disabled {
          background: #6c757d;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
}








function ProductDetailss() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [mainImage, setMainImage] = useState('');
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    setLoading(true);
    fetch(`https://syriacash.app/new/api.php?productstor=${id}`)
      .then(res => {
        if (!res.ok) throw new Error('فشل تحميل بيانات المنتج');
        return res.json();
      })
      .then(data => {
        setProduct(data);
        if (data.images && data.images.length > 0) {
          setMainImage(data.images[0]);
        }
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [id]);

  const handleAddToCart = () => {
    setCartLoading(true);
    setMessage({ text: '', type: '' });

const token = localStorage.getItem('authToken');
     

    fetch(`https://syriacash.app/new/api.php?addToCarts&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: id, quantity: 1 })
    })
      .then(res => {
        if (!res.ok) throw new Error('حدث خطأ أثناء الإضافة إلى السلة');
        return res.json();
      })
      .then(data => {
        if (data.success) {
          setMessage({ text: 'تمت إضافة المنتج إلى السلة بنجاح!', type: 'success' });
        } else {
          setMessage({ text: data.message || 'فشل في الإضافة إلى السلة', type: 'error' });
        }
      })
      .catch(() => setMessage({ text: 'حدث خطأ في الاتصال بالخادم', type: 'error' }))
      .finally(() => setCartLoading(false));
  };

  if (loading) return <LoadingSpinner text="جاري تحميل تفاصيل المنتج..." />;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!product) return <div>لم يتم العثور على المنتج.</div>;

  return (
    <div className="myapp-container">
      <h1 className="myapp-title">{product.title}</h1>





      <div className="myapp-content">

   <div className="myapp-details-column details-card">
          <p><strong>السعر:</strong> <span className="myapp-price">{product.price.toLocaleString()}₺</span></p>
   
          {product.supplier && <p><strong>المورد:</strong> {product.supplier}</p>}

          {product.description && (
            <>
              <h3>الوصف</h3>
              <p>{product.description}</p>
            </>
          )}

          {/* عرض الحقول المرنة */}
          {product.extraFields && Object.entries(product.extraFields).length > 0 && (
            <>
              <h3>معلومات إضافية</h3>
              {Object.entries(product.extraFields).map(([key, value]) => (
                <p key={key}><strong>{key}:</strong> {value}</p>
              ))}
            </>
          )}

          <div className="myapp-buttons">
            <button
              className="myapp-cart-button"
              onClick={handleAddToCart}
              disabled={cartLoading}
            >
              {cartLoading ? 'جاري الإضافة...' : 'أضف إلى السلة'}
            </button>
          </div>

          <MessageDisplay
            message={message.text}
            type={message.type}
            onClose={() => setMessage({ text: '', type: '' })}
          />
        </div>


        <div className="myapp-images-column">
          <img src={mainImage} alt="صورة المنتج الرئيسية" className="myapp-main-image" />
          <div className="myapp-thumbnail-container">
            {product.images && product.images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`صورة مصغرة ${i + 1}`}
                className={`myapp-thumbnail ${img === mainImage ? 'myapp-thumbnail-active' : ''}`}
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>
        </div>

     
      </div>
    </div>
  );
}



function ProductDetailsopen() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [mainImage, setMainImage] = useState('');

  useEffect(() => {
    setLoading(true);
    fetch(`https://syriacash.app/new/api.php?productstoropen=${id}`)
      .then(res => {
        if (!res.ok) throw new Error('فشل تحميل بيانات المنتج');
        return res.json();
      })
      .then(data => {
        setProduct(data);
        if (data.images && data.images.length > 0) {
          setMainImage(data.images[0]);
        }
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div>جاري تحميل تفاصيل المنتج...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!product) return <div>لم يتم العثور على المنتج.</div>;

  // رابط واتس آب
  const whatsappLink = product.phone
    ? `https://wa.me/${product.phone.replace(/\D/g, '')}?text=مرحبا، أود الاستفسار عن المنتج: ${encodeURIComponent(product.title)}`
    : '#';

  return (
    <div className="myapp-container">
      <h1 className="myapp-title">{product.title}</h1>









      <div className="myapp-content">


<div className="myapp-details-column">

  <div className="myapp-info-grid">

    <div className="myapp-info-card price">
      <span className="icon">💰</span>
      <div>
        <small>السعر</small>
        <strong>{product.price.toLocaleString()} </strong>
      </div>
    </div>

    <div className="myapp-info-card">
      <span className="icon">📄</span>
      <div>
        <small>الوصف</small>
        <strong>{product.description}</strong>
      </div>
    </div>

    <div className="myapp-info-card">
      <span className="icon">📍</span>
      <div>
        <small>المنطقة</small>
        <strong>{product.province}</strong>
      </div>
    </div>

  

    <div className="myapp-info-card">
      <span className="icon">✅</span>
      <div>
        <small>الحالة</small>
        <strong>{product.condition}</strong>
      </div>
    </div>

  </div>

     
<div className="myapp-buttons">
  {product.phone ? (
    <a
      href={`/whatsapp/${product.phone.replace(/\D/g, '')}/مرحبا، أود الاستفسار عن المنتج: ${encodeURIComponent(product.title)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="myapp-whatsapp-button"
    >
      مراسلة عبر واتس آب
    </a>
  ) : (
    <button disabled className="myapp-whatsapp-button">
      رقم الهاتف غير متوفر
    </button>
  )}
</div>

<style jsx>{`
  .myapp-whatsapp-button {
    display: inline-block;
    padding: 10px 20px;
    background-color: #25D366;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    transition: 0.3s;
  }
  .myapp-whatsapp-button:hover {
    background-color: #1ebe5d;
  }
  .myapp-whatsapp-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`}</style>

        </div>


        <div className="myapp-images-column">
          {mainImage && <img src={mainImage} alt="صورة المنتج الرئيسية" className="myapp-main-image" />}
          <div className="myapp-thumbnail-container">
            {product.images && product.images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`صورة مصغرة ${i + 1}`}
                className={`myapp-thumbnail ${img === mainImage ? 'myapp-thumbnail-active' : ''}`}
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>
        </div>

     
      </div>
    </div>
  );
}


function CartAndProducts() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [building, setBuilding] = useState("");
  const [floor, setFloor] = useState("");
  const [apartment, setApartment] = useState("");

  const [showCODModal, setShowCODModal] = useState(false);
  const [showHybridModal, setShowHybridModal] = useState(false);
  const [userBalance, setUserBalance] = useState(0);

  const [whatsapp, setWhatsapp] = useState("");
  const [sending, setSending] = useState(false);

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("success");

  const [isGuest, setIsGuest] = useState(false);

  // ─── أجور التوصيل من API ──────────────────────────────────────
  // الشكل المتوقع من API: { type0_low: 20, type0_high: 10, type0_threshold: 200, others: 20, mixed: 40 }
  const [shippingRates, setShippingRates] = useState(null);
  const [shippingLoading, setShippingLoading] = useState(true);

  // ─── تحميل الكوكيز ───────────────────────────────────────────
  useEffect(() => {
    const getCookie = (name) => {
      const v = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
      return v ? v.pop() : "";
    };
    setBuilding(getCookie("building"));
    setFloor(getCookie("floor"));
    setApartment(getCookie("apartment"));
    setWhatsapp(getCookie("whatsapp"));
  }, []);

  // ─── حفظ الكوكيز ─────────────────────────────────────────────
  const saveAddressCookies = () => {
    document.cookie = `building=${building}; path=/; max-age=31536000`;
    document.cookie = `floor=${floor}; path=/; max-age=31536000`;
    document.cookie = `apartment=${apartment}; path=/; max-age=31536000`;
    document.cookie = `whatsapp=${whatsapp}; path=/; max-age=31536000`;
  };

  // ─── تحقق من الضيف ───────────────────────────────────────────
  useEffect(() => {
    setIsGuest(localStorage.getItem("isGuest") === "true");
  }, []);

  // ─── جلب السلة ───────────────────────────────────────────────
  const fetchCart = () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    fetch(`https://syriacash.app/new/api.php?cart&token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        const updatedData = data.map((item) => ({
          ...item,
          quantity: Number(item.quantity) || 1,
          projectId: Number(item.id),
        }));
        setCartItems(updatedData);
      })
      .catch(() => {
        setMessage("⚠️ خطأ في تحميل السلة");
        setMessageType("error");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchCart(); }, []);

  // ─── جلب أجور التوصيل من API ─────────────────────────────────
  useEffect(() => {
    setShippingLoading(true);
    fetch("https://syriacash.app/new/api.php?shipping_rates")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.success) {
          setShippingRates(data.rates);
        } else {
          // قيم افتراضية احتياطية إذا فشل الـ API
          setShippingRates({
            type0_low: 30,
            type0_high: 30,
            type0_threshold: 200,
            others: 30,
            mixed: 40,
          });
        }
      })
      .catch(() => {
        // قيم افتراضية عند خطأ الاتصال
        setShippingRates({
          type0_low: 30,
          type0_high: 30,
          type0_threshold: 200,
          others: 30,
          mixed: 40,
        });
      })
      .finally(() => setShippingLoading(false));
  }, []);

  // ─── جلب الرصيد ──────────────────────────────────────────────
  useEffect(() => {
    if (isGuest) return;
    const token = localStorage.getItem("authToken");
    fetch(`https://syriacash.app/new/api.php?balancex&token=${token}`)
      .then((res) => res.json())
      .then((data) => { if (data.success) setUserBalance(Number(data.balance) || 0); })
      .catch(() => setUserBalance(0));
  }, [isGuest]);

  // ─── تحديث الكمية ────────────────────────────────────────────
  const updateQuantity = (projectId, newQty) => {
    if (newQty < 1) return;
    setCartItems((prev) =>
      prev.map((item) =>
        item.projectId === projectId ? { ...item, quantity: newQty } : item
      )
    );
    fetch(
      `https://syriacash.app/new/api.php?updateCart&token=${localStorage.getItem("authToken")}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId: projectId, quantity: newQty }),
      }
    );
  };

  // ─── دالة الدفع الموحدة ───────────────────────────────────────
  const completeOrderUnified = (paymentMethod) => {
    if (paymentMethod !== "BALANCE") {
      if (!/^\+?\d{1,}$/.test(whatsapp)) {
        setMessage("⚠️ الرقم غير صالح. يُرجى إدخال أرقام فقط");
        setMessageType("error");
        return;
      }
      saveAddressCookies();
    }

    setSending(true);

    fetch(
      `https://syriacash.app/new/api.php?checkout&token=${localStorage.getItem("authToken")}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: cartItems,
          paymentMethod,
          whatsapp,
          building,
          floor,
          apartment,
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setSending(false);
        if (data.success) {
          setShowCODModal(false);
          setShowHybridModal(false);
          setMessage("✅ تم إرسال الطلب بنجاح!");
          setMessageType("success");
          navigate("/oreder");
        } else {
          setMessage(data.message || "❌ حدث خطأ أثناء إتمام الطلب.");
          setMessageType("error");
        }
      })
      .catch(() => {
        setSending(false);
        setMessage("⚠️ خطأ في الاتصال، حاول مرة أخرى.");
        setMessageType("error");
      });
  };

  // ─── حذف منتج ────────────────────────────────────────────────
  const removeFromCart = (projectId) => {
    const token = localStorage.getItem("authToken");
    setCartItems((prev) => prev.filter((item) => item.projectId !== projectId));
    fetch(`https://syriacash.app/new/api.php?removeCart&token=${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: projectId }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setMessage("🗑️ تم حذف المنتج من السلة بنجاح");
          setMessageType("success");
        } else {
          setMessage(data.message || "⚠️ لم يتم حذف المنتج من الخادم");
          setMessageType("error");
        }
      })
      .catch(() => setMessage("⚠️ خطأ أثناء حذف المنتج من الخادم"));
  };

  // ─── حسابات عامة ─────────────────────────────────────────────
  const getItemsByCurrency = (currency) =>
    cartItems.filter((item) => item.currency === currency);

  const totalOf = (items) =>
    items.reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0);

  // ─── حساب الشحن بناءً على الأسعار القادمة من API ─────────────
  const calculateShipping = (items, subtotal) => {
    // قيم افتراضية في حال لم تُحمَّل الأسعار بعد
    const rates = shippingRates || {
      type0_low: 20,
      type0_high: 10,
      type0_threshold: 200,
      others: 20,
      mixed: 40,
    };
    const hasType0      = items.some((i) => i.type == "0" || i.type == 0);
    const hasOtherTypes = items.some((i) => i.type == "1" || i.type == "2" || i.type == "5");
    if (hasType0 && !hasOtherTypes)
      return subtotal < rates.type0_threshold ? rates.type0_low : rates.type0_high;
    if (!hasType0 && hasOtherTypes) return rates.others;
    if (hasType0 && hasOtherTypes)  return rates.mixed;
    return 0;
  };

  // ─── حسابات HYBRID ───────────────────────────────────────────

  // الماركت فقط — لحساب الخصم من الرصيد
  const marketItems      = cartItems.filter((i) => i.type == "0" || i.type == 0);
  const marketSubtotal   = totalOf(marketItems);
  const marketShipping   = marketItems.length > 0
    ? (marketSubtotal < (shippingRates?.type0_threshold ?? 200)
        ? (shippingRates?.type0_low ?? 20)
        : (shippingRates?.type0_high ?? 10))
    : 0;
  const marketWithShip   = marketSubtotal + marketShipping;
  const hybridUsedBalance  = Math.min(userBalance, marketWithShip);

  // كامل السلة — للإجمالي الذي يُعرض
  const allItems         = cartItems;
  const allSubtotal      = totalOf(allItems);
  const allShipping      = calculateShipping(allItems, allSubtotal);
  const allGrandTotal    = allSubtotal + allShipping;
  const hybridRemainingCOD = Math.max(0, allGrandTotal - hybridUsedBalance);

  // إظهار زر HYBRID: ماركت موجود وفوق 100
  const showHybridBtn = !isGuest && marketItems.length > 0 && marketSubtotal >= 100;

  // ─── حقول العنوان المشتركة (JSX مباشر وليس component لتجنب فقدان الـ focus) ──
  const addressFields = (
    <>
      <input
        value={building}
        onChange={(e) => setBuilding(e.target.value)}
        placeholder="🏢 رقم البناء"
        style={{ width: "90%", padding: "10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }}
      />
      <input
        value={floor}
        onChange={(e) => setFloor(e.target.value)}
        placeholder="⬆️ الطابق"
        style={{ width: "90%", padding: "10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }}
      />
      <input
        value={apartment}
        onChange={(e) => setApartment(e.target.value)}
        placeholder="🚪 الشقة"
        style={{ width: "90%", padding: "10px", marginBottom: "12px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }}
      />
    </>
  );



  // ─── Loading / Empty ──────────────────────────────────────────
  if (loading || shippingLoading)
    return (
      <div className="status-message">
        <div className="spinner"></div>
        <p>جاري تحميل السلة...</p>
      </div>
    );

  if (cartItems.length === 0)
    return (
      <div className="status-message empty">
        <i className="fas fa-shopping-cart"></i>
        <p>السلة فارغة</p>
      </div>
    );

  return (
    <div className="cart-container">
      <MessageDisplay message={message} type={messageType} onClose={() => setMessage(null)} />

      <h1>🛒 سلة التسوق</h1>

      {["SYP", "USD", "TRY"].map((curr) => {
        const items = getItemsByCurrency(curr);
        if (items.length === 0) return null;

        const symbol    = curr === "SYP" ? "ل.س" : curr === "USD" ? "$" : "₺";
        const label     = curr === "SYP" ? "المنتجات بالليرة السورية" : curr === "USD" ? "المنتجات بالدولار" : "المنتجات بالليرة التركية";
        const subtotal  = totalOf(items);
        const shipping  = calculateShipping(items, subtotal);
        const grandTotal = subtotal + shipping;

        return (
          <div key={curr} className="cart-section" style={{ marginBottom: "20px" }}>
            <h2>{label}</h2>

            {items.map((item) => (
              <div key={item.projectId} className="cart-item" style={{ display: "flex", marginBottom: "10px" }}>
                <img
                  src={item.images?.[0]} alt={item.title} width={80}
                  style={{ cursor: "pointer", marginRight: "10px", borderRadius: "8px" }}
                  onClick={() => navigate(`/product/${item.projectId}`)}
                />
                <div>
                  <h3 style={{ cursor: "pointer", color: "#007bff", margin: 0 }}
                    onClick={() => navigate(`/product/${item.projectId}`)}>
                    {item.title}
                  </h3>
                  <p style={{ margin: "2px 0" }}>السعر: {Number(item.price).toFixed(2)} {symbol}</p>
                  <div className="quantity-control">
                    <button onClick={() => updateQuantity(item.projectId, item.quantity - 1)}>−</button>
                    <input
                      type="number" value={item.quantity} min="1"
                      onChange={(e) => updateQuantity(item.projectId, parseInt(e.target.value) || 1)}
                    />
                    <button onClick={() => updateQuantity(item.projectId, item.quantity + 1)}>+</button>
                    <button className="remove-btn" onClick={() => removeFromCart(item.projectId)} title="حذف المنتج">🗑️</button>
                  </div>
                </div>
              </div>
            ))}

            <p><strong>إجمالي {label}: {subtotal.toFixed(2)} {symbol}</strong></p>
            <p>{shipping > 0 ? `أجور التوصيل: ${shipping} ${symbol}` : "🚚 التوصيل مجاني"}</p>
            <p><strong>المجموع الكلي: {grandTotal.toFixed(2)} {symbol}</strong></p>
          </div>
        );
      })}

      {/* تنبيه إذا الماركت موجود لكن أقل من 100 */}
      {!isGuest && marketItems.length > 0 && marketSubtotal < 100 && (
        <p style={{
          textAlign: "center", color: "#888", fontSize: "13px",
          backgroundColor: "#f9f9f9", padding: "8px", borderRadius: "8px", margin: "10px 0"
        }}>
          💡 أضف منتجات ماركت بقيمة 100 ₺ أو أكثر لتفعيل خيار الدفع المختلط
        </p>
      )}

      {/* ─── أزرار الدفع ─────────────────────────────────────── */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>

        {/* 💳 الدفع من الرصيد */}
        {!isGuest && (
          <button onClick={() => completeOrderUnified("BALANCE")}
            style={{ backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "8px", padding: "12px 20px", margin: "5px", cursor: "pointer" }}>
            💳 الدفع من الرصيد
          </button>
        )}

        {/* 💜 رصيد على الماركت + الباقي عند التسليم */}
        {showHybridBtn && (
          <button onClick={() => setShowHybridModal(true)}
            style={{ backgroundColor: "#6f42c1", color: "#fff", border: "none", borderRadius: "8px", padding: "12px 20px", margin: "5px", cursor: "pointer" }}>
            💜 رصيدي على الماركت + الباقي عند التسليم
          </button>
        )}

        {/* 🚚 الدفع عند الاستلام */}
        <button onClick={() => setShowCODModal(true)}
          style={{ backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "8px", padding: "12px 20px", margin: "5px", cursor: "pointer" }}>
          🚚 الدفع عند الاستلام
        </button>

        {/* 🗑️ تفريغ السلة */}
        <button
          onClick={() => {
            setCartItems([]);
            fetch(`https://syriacash.app/new/api.php?clearCart&token=${localStorage.getItem("authToken")}`);
          }}
          style={{ backgroundColor: "#dc3545", color: "#fff", border: "none", borderRadius: "8px", padding: "12px 20px", margin: "5px", cursor: "pointer" }}>
          🗑️ تفريغ السلة
        </button>
      </div>

      {/* ─── Modal: الدفع عند الاستلام ───────────────────────── */}
      {showCODModal && (
        <div
          style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}
          onClick={() => setShowCODModal(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ backgroundColor: "#f0fff4", border: "2px solid #28a745", padding: "25px", borderRadius: "14px", width: "90%", maxWidth: "420px", textAlign: "center", direction: "rtl", maxHeight: "90vh", overflowY: "auto" }}
          >
            <h3 style={{ color: "#28a745" }}>🧾 اتفاقية الدفع عند الاستلام</h3>
            <p style={{ fontSize: "15px", color: "#333" }}>
              ⚠️ أؤكد أنني أعيش في إدلب المدينة وأتعهد باستلام الطلبية والدفع عند التسليم.
            </p>
            <input type="tel" inputMode="numeric" value={whatsapp}
              onChange={(e) => setWhatsapp(e.target.value)}
              placeholder="📱 رقم الواتساب للتأكيد"
              style={{ width: "90%", padding: "10px", border: "1px solid #ccc", borderRadius: "8px", fontSize: "14px", marginBottom: "12px" }}
            />
            <input value={building} onChange={(e) => setBuilding(e.target.value)} placeholder="🏢 رقم البناء"
              style={{ width: "90%", padding: "10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }} />
            <input value={floor} onChange={(e) => setFloor(e.target.value)} placeholder="⬆️ الطابق"
              style={{ width: "90%", padding: "10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }} />
            <input value={apartment} onChange={(e) => setApartment(e.target.value)} placeholder="🚪 الشقة"
              style={{ width: "90%", padding: "10px", marginBottom: "12px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }} />
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button onClick={() => setShowCODModal(false)}
                style={{ backgroundColor: "#ccc", color: "#333", borderRadius: "8px", padding: "10px 20px", border: "none", cursor: "pointer" }}>
                إلغاء
              </button>
              <button onClick={() => completeOrderUnified("COD")} disabled={sending}
                style={{ backgroundColor: sending ? "#999" : "#28a745", color: "#fff", borderRadius: "8px", padding: "10px 20px", border: "none", cursor: sending ? "not-allowed" : "pointer" }}>
                {sending ? "جاري الإرسال..." : "تأكيد الطلب"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Modal: رصيد على الماركت + باقي الطلب كله عند التسليم ── */}
      {showHybridModal && (
        <div
          style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}
          onClick={() => setShowHybridModal(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ backgroundColor: "#f5f0ff", border: "2px solid #6f42c1", padding: "25px", borderRadius: "14px", width: "90%", maxWidth: "420px", textAlign: "center", direction: "rtl", maxHeight: "90vh", overflowY: "auto" }}
          >
            <h3 style={{ color: "#6f42c1" }}>💜 الدفع المختلط</h3>
            <div style={{ backgroundColor: "#fff", borderRadius: "10px", padding: "12px", marginBottom: "14px", fontSize: "14px", lineHeight: "2", textAlign: "right" }}>
              <p style={{ fontWeight: "bold", color: "#6f42c1", marginBottom: 0 }}>🏪 خصم الرصيد على الماركت:</p>
              <p style={{ margin: "2px 0" }}>مجموع الماركت: <strong>{marketSubtotal.toFixed(2)} ₺</strong></p>
              <p style={{ margin: "2px 0" }}>رسوم توصيل الماركت: <strong>{marketShipping} ₺</strong></p>
              <p style={{ margin: "2px 0" }}>إجمالي الماركت: <strong>{marketWithShip.toFixed(2)} ₺</strong></p>
              <hr style={{ border: "none", borderTop: "1px solid #e0d0ff", margin: "8px 0" }} />
              <p style={{ fontWeight: "bold", color: "#333", marginBottom: 0 }}>🛒 كامل الطلب:</p>
              <p style={{ margin: "2px 0" }}>إجمالي كامل الطلب: <strong>{allGrandTotal.toFixed(2)} ₺</strong></p>
              <hr style={{ border: "none", borderTop: "1px solid #e0d0ff", margin: "8px 0" }} />
              <p style={{ margin: "2px 0" }}>💰 رصيدك المتاح: <strong>{userBalance.toFixed(2)} ₺</strong></p>
              <hr style={{ border: "none", borderTop: "1px solid #ddd", margin: "8px 0" }} />
              <p style={{ margin: "2px 0" }}>✅ سيُخصم من رصيدك (الماركت): <strong style={{ color: "#6f42c1" }}>{hybridUsedBalance.toFixed(2)} ₺</strong></p>
              <p style={{ margin: "2px 0" }}>🚚 الباقي عند التسليم: <strong style={{ color: "#e63946" }}>{hybridRemainingCOD.toFixed(2)} ₺</strong></p>
            </div>
            <input type="tel" inputMode="numeric" value={whatsapp}
              onChange={(e) => setWhatsapp(e.target.value)}
              placeholder="📱 رقم الواتساب للتأكيد"
              style={{ width: "90%", padding: "10px", border: "1px solid #ccc", borderRadius: "8px", fontSize: "14px", marginBottom: "12px" }}
            />
            <input value={building} onChange={(e) => setBuilding(e.target.value)} placeholder="🏢 رقم البناء"
              style={{ width: "90%", padding: "10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }} />
            <input value={floor} onChange={(e) => setFloor(e.target.value)} placeholder="⬆️ الطابق"
              style={{ width: "90%", padding: "10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }} />
            <input value={apartment} onChange={(e) => setApartment(e.target.value)} placeholder="🚪 الشقة"
              style={{ width: "90%", padding: "10px", marginBottom: "12px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "14px" }} />
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button onClick={() => setShowHybridModal(false)}
                style={{ backgroundColor: "#ccc", color: "#333", borderRadius: "8px", padding: "10px 20px", border: "none", cursor: "pointer" }}>
                إلغاء
              </button>
              <button onClick={() => completeOrderUnified("HYBRID")} disabled={sending}
                style={{ backgroundColor: sending ? "#999" : "#6f42c1", color: "#fff", borderRadius: "8px", padding: "10px 20px", border: "none", cursor: sending ? "not-allowed" : "pointer" }}>
                {sending ? "جاري الإرسال..." : "تأكيد الطلب"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



















function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // ✅ دالة تتحقق مما إذا كان المستخدم داخل WebView
    const isInWebView = (() => {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      return (
        ua.includes("wv") || // Android WebView
        ua.includes("FBAN") || // Facebook
        ua.includes("FBAV") || // Facebook App Browser
        ua.includes("Instagram") || // Instagram in-app
        ua.includes("Line") // LINE app
      );
    })();

    if (isInWebView) {
      console.log("⚠️ التثبيت غير متاح داخل WebView");
      return; // لا نعرض النافذة إطلاقًا
    }

    // ✅ التقاط حدث Android install prompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      console.log("✅ تم التقاط حدث beforeinstallprompt");
      // نعرض النافذة بعد تأخير بسيط
      setTimeout(() => setShowPopup(true), 3000);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // ✅ تحقق من iPhone Safari
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent.toLowerCase());
    const isInStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    if (isIos && !isInStandalone) {
      setTimeout(() => setShowPopup(true), 3000);
    }

    // ✅ تنظيف الحدث عند إزالة المكون
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  // ✅ عملية التثبيت
  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log("🔹 نتيجة التثبيت:", outcome);
      setShowPopup(false);
    }
  };

  const closePopup = () => setShowPopup(false);

  if (!showPopup) return null;

  // ✅ تصميم النافذة المنبثقة
  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#10b981",
        color: "#fff",
        borderRadius: "16px",
        padding: "14px 18px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        zIndex: 9999,
        textAlign: "center",
        fontSize: "15px",
        width: "90%",
        maxWidth: "380px",
        animation: "fadeIn 0.4s ease",
      }}
    >
      <p style={{ marginBottom: "10px" }}>
        📲 هل ترغب بتثبيت تطبيق <strong>سوريا كاش</strong> على شاشتك؟
      </p>

      {deferredPrompt ? (
        <button
          onClick={handleInstall}
          style={{
            background: "#fff",
            color: "#10b981",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            padding: "8px 14px",
            cursor: "pointer",
          }}
        >
          تثبيت التطبيق
        </button>
      ) : (
        <p style={{ fontSize: "14px" }}>
          من متصفح Safari اضغط <strong>مشاركة</strong> ثم اختر
          <br />
          “📎 إضافة إلى الشاشة الرئيسية”
        </p>
      )}

      <button
        onClick={closePopup}
        style={{
          display: "block",
          margin: "10px auto 0",
          background: "transparent",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          fontSize: "13px",
        }}
      >
        إغلاق ✖️
      </button>
    </div>
  );
}



function ServiceMtn() {
  const [phone, setPhone] = useState('');
  const [confirmPhone, setConfirmPhone] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [useDiscount, setUseDiscount] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });
  const [points, setPoints] = useState(0); // ✅ عدد النقاط

  const unitPrice = 1.15;
  const navigate = useNavigate();

  const basePrice = selectedPackage ? Number(selectedPackage) * unitPrice : 0;
  const totalPrice = useDiscount ? basePrice * 0.92 : basePrice;

  const [newsText, setNewsText] = useState('');

  // ✅ استدعاء الأخبار
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch('https://syriacash.app/new/api.php?newsTicker=1');
        const data = await res.json();
        if (data.success && data.news) {
          setNewsText(data.news);
        }
      } catch (err) {
        console.error('فشل تحميل الأخبار:', err);
      }
    };

    fetchNews();
  }, []);

  // ✅ استدعاء عدد النقاط
  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(`https://syriacash.app/new/api.php?getPoints=1&token=${token}`);
        const data = await res.json();
        if (data.success && data.points !== undefined) {
          setPoints(data.points);
        }
      } catch (err) {
        console.error('فشل تحميل النقاط:', err);
      }
    };

    fetchPoints();
  }, []);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhone(value);
    }
  };

  const handleConfirmPhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setConfirmPhone(value);
    }
  };

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => {
      setMessage({ text: '', type: '', show: false });
    }, 3000);
  };

  const handleSubmit = async () => {
    if (!/^09\d{8}$/.test(phone)) {
      showAndHideMessage("يرجى إدخال رقم يبدأ بـ 09 ويتكون من 10 خانات", "error");
      return;
    }

    if (phone !== confirmPhone) {
      showAndHideMessage("رقم التأكيد لا يطابق الرقم المدخل", "error");
      return;
    }

    if (!selectedPackage) {
      showAndHideMessage("يرجى اختيار الباقة", "error");
      return;
    }

    if (useDiscount && points < 1000) {
      showAndHideMessage("❌ لا تملك نقاط كافية لاستخدام الخصم", "error");
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '', show: false });

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?newmtn&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone,
          package: selectedPackage,
          total: totalPrice,
          discountUsed: useDiscount ? 1 : 0,
        }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        setTimeout(() => {
          navigate('/oreder');
        }, 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك المالي لا يكفي", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showAndHideMessage("خطأ في الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header">
        <h4>تفاصيل الخدمة</h4>
      </div>

      <div className="service-icon">
        <img src="/images/mtn.png" alt="تحويل الأموال" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <NewsTicker text={newsText} />

      <h2 className="service-title">تحويل وحدات MTN</h2>
      <p className="service-desc">تحويل سريع وآمن</p>

      <input
        type="text"
        placeholder="أدخل رقم الهاتف"
        value={phone}
        onChange={handlePhoneChange}
        className="input-field"
        inputMode="numeric"
      />

      <input
        type="text"
        placeholder="أعد إدخال رقم الهاتف للتأكيد"
        value={confirmPhone}
        onChange={handleConfirmPhoneChange}
        className="input-field"
        inputMode="numeric"
      />

      <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>
⚠️ تأكد من إدخال الرقم بشكل صحيح. الخدمة خاصة بأرقام  MTN المسبقة والمستخدم يتحمل مسؤولية الخطأ.
      </p>

      <select
        value={selectedPackage}
        onChange={(e) => setSelectedPackage(e.target.value)}
        className="select-field"
      >
        <option value="">-- اختر الباقة --</option>
        <option value="2000">2000</option>
        <option value="2500">2500</option>
        <option value="3000">3000</option>
        <option value="3500">3500</option>
        <option value="4000">4000</option>
        <option value="6000">6000</option>
        <option value="7000">7000</option>
        <option value="8500">8500</option>
        <option value="9000">9000</option>
        <option value="10000">10000</option>
        <option value="11000">11000</option>
        <option value="15000">15000</option>
        <option value="17000">17000</option>
        <option value="19000">19000</option>
        <option value="20000">20000</option>
        <option value="26000">26000</option>
        <option value="28000">28000</option>
        <option value="30000">30000</option>
        <option value="32000">32000</option>
        <option value="34000">34000</option>
        <option value="36000">36000</option>
        <option value="40000">40000</option>
        <option value="42000">42000</option>
        <option value="48000">48000</option>
        <option value="50000">50000</option>
        <option value="55000">55000</option>
        <option value="60000">60000</option>
        <option value="65000">65000</option>
        <option value="70000">70000</option>
        <option value="75000">75000</option>
      </select>

      {/* ✅ عرض النقاط وخيار الخصم */}
      <div style={{ marginTop: '15px' }}>
        <p>رصيد نقاطك الحالي: <b>{points}</b></p>
        <label>
          <input
            type="checkbox"
            checked={useDiscount}
            onChange={() => {
              if (points >= 1000) {
                setUseDiscount(!useDiscount);
              } else {
                showAndHideMessage("❌ لا تملك نقاط كافية لاستخدام الخصم", "error");
              }
            }}
          />
          أريد استخدام 1000 نقطة للحصول على خصم 8%
        </label>
      </div>

      <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
        {loading ? 'جاري الإرسال...' : `تأكيد الطلب - ${totalPrice.toFixed(2)} ل.س`}
      </button>

      {message.show && (
        <MessageDisplay
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: '', type: '', show: false })}
        />
      )}
    </div>
  );
}






function ServiceMtnf() {
  const [phone, setPhone] = useState('');
  const [confirmPhone, setConfirmPhone] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });

  const unitPrice = 1.15;
  const navigate = useNavigate();
  const totalPrice = selectedPackage ? Number(selectedPackage) * unitPrice : 0;

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) setPhone(value);
  };

  const handleConfirmPhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) setConfirmPhone(value);
  };

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => setMessage({ text: '', type: '', show: false }), 3000);
  };

  const handleSubmit = async () => {
    if (!/^09\d{8}$/.test(phone)) {
      showAndHideMessage("يرجى إدخال رقم يبدأ بـ 09 ويتكون من 10 خانات", "error");
      return;
    }
    if (phone !== confirmPhone) {
      showAndHideMessage("رقم التأكيد لا يطابق الرقم المدخل", "error");
      return;
    }
    if (!selectedPackage || isNaN(selectedPackage) || Number(selectedPackage) <= 0) {
      showAndHideMessage("يرجى إدخال قيمة صالحة للفاتورة", "error");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?newmtnf&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, package: selectedPackage, total: totalPrice }),
      });
      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        setTimeout(() => navigate('/oreder'), 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك المالي لا يكفي", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }
    } catch {
      showAndHideMessage("خطأ في الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header"><h4>تفاصيل الخدمة</h4></div>
      <div className="service-icon">
        <img src="/images/a.png" alt="تحويل الأموال" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <h2 className="service-title">خاص بالفواتير MTN</h2>
      <p className="service-desc">تسديد فواتير MTN بسرعة وأمان</p>

      <input type="text" placeholder="أدخل رقم الهاتف" value={phone}
             onChange={handlePhoneChange} className="input-field" inputMode="numeric" />
      <input type="text" placeholder="أعد إدخال رقم الهاتف للتأكيد" value={confirmPhone}
             onChange={handleConfirmPhoneChange} className="input-field" inputMode="numeric" />

      <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>
        ⚠️  تأكد من إدخال الرقم بشكل صحيح. المستخدم يتحمل مسؤولية الخطأ مخصص لارقام MTN لاحقة الدفع. 
      </p>

      <input type="number" placeholder="أدخل قيمة الفاتورة" value={selectedPackage}
             onChange={(e) => setSelectedPackage(e.target.value)} className="input-field"
             min="500" step="1" />

      <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
        {loading ? 'جاري الإرسال...' : `تأكيد الطلب - ${totalPrice.toFixed(2)} ل.س`}
      </button>

      {message.show && <MessageDisplay message={message.text} type={message.type}
                                       onClose={() => setMessage({ text: '', type: '', show: false })} />}
    </div>
  );
}



function ServiceSriatelf() {
  const [phone, setPhone] = useState('');
  const [confirmPhone, setConfirmPhone] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });

  const unitPrice = 1.15;
  const navigate = useNavigate();
  const totalPrice = selectedPackage ? Number(selectedPackage) * unitPrice : 0;

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) setPhone(value);
  };

  const handleConfirmPhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) setConfirmPhone(value);
  };

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => setMessage({ text: '', type: '', show: false }), 3000);
  };

  const handleSubmit = async () => {
    if (!/^09\d{8}$/.test(phone)) {
      showAndHideMessage("يرجى إدخال رقم يبدأ بـ 09 ويتكون من 10 خانات", "error");
      return;
    }
    if (phone !== confirmPhone) {
      showAndHideMessage("رقم التأكيد لا يطابق الرقم المدخل", "error");
      return;
    }
    if (!selectedPackage || isNaN(selectedPackage) || Number(selectedPackage) <= 0) {
      showAndHideMessage("يرجى إدخال قيمة صالحة للفاتورة", "error");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?syriatelf&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, package: selectedPackage, total: totalPrice }),
      });
      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        setTimeout(() => navigate('/oreder'), 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك المالي لا يكفي", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }
    } catch {
      showAndHideMessage("خطأ في الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header"><h4>تفاصيل الخدمة</h4></div>
      <div className="service-icon">
        <img src="/images/b.png" alt="تحويل الأموال" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <h2 className="service-title">خاص بالفواتير Syriatel</h2>
      <p className="service-desc">تسديد فواتير Syriatel بسرعة وأمان</p>

      <input type="text" placeholder="أدخل رقم الهاتف" value={phone}
             onChange={handlePhoneChange} className="input-field" inputMode="numeric" />
      <input type="text" placeholder="أعد إدخال رقم الهاتف للتأكيد" value={confirmPhone}
             onChange={handleConfirmPhoneChange} className="input-field" inputMode="numeric" />

      <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>
  ⚠️ تأكد من إدخال الرقم بشكل صحيح. مخصص للارقام لاحقة الدفع من سيريتل المستخدم يتحمل مسؤولية الخطأ.
      </p>

      <input type="number" placeholder="أدخل قيمة الفاتورة" value={selectedPackage}
             onChange={(e) => setSelectedPackage(e.target.value)} className="input-field"
             min="500" step="1" />

      <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
        {loading ? 'جاري الإرسال...' : `تأكيد الطلب - ${totalPrice.toFixed(2)} ل.س`}
      </button>

      {message.show && <MessageDisplay message={message.text} type={message.type}
                                       onClose={() => setMessage({ text: '', type: '', show: false })} />}
    </div>
  );
}





function ServiceSriatel() {
  const [phone, setPhone] = useState('');
  const [confirmPhone, setConfirmPhone] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });
  const [newsText, setNewsText] = useState('');

  // ✅ النقاط
  const [points, setPoints] = useState(0);
  const [useDiscount, setUseDiscount] = useState(false);

  const unitPrice = 1.15;
  const navigate = useNavigate();

  const basePrice = selectedPackage ? Number(selectedPackage) * unitPrice : 0;
  const totalPrice = useDiscount ? basePrice * 0.92 : basePrice; // ✅ خصم 8%

  // ✅ جلب الأخبار
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch('https://syriacash.app/new/api.php?newsTicker=2');
        const data = await res.json();
        if (data.success && data.news) {
          setNewsText(data.news);
        }
      } catch (err) {
        console.error('فشل تحميل الأخبار:', err);
      }
    };
    fetchNews();
  }, []);

  // ✅ جلب عدد النقاط
  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(`https://syriacash.app/new/api.php?getPoints=1&token=${token}`);
        const data = await res.json();
        if (data.success && data.points !== undefined) {
          setPoints(data.points);
        }
      } catch (err) {
        console.error('فشل تحميل النقاط:', err);
      }
    };
    fetchPoints();
  }, []);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhone(value);
    }
  };

  const handleConfirmPhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setConfirmPhone(value);
    }
  };

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => {
      setMessage({ text: '', type: '', show: false });
    }, 3000);
  };

  const handleSubmit = async () => {
    if (!/^09\d{8}$/.test(phone)) {
      showAndHideMessage("يرجى إدخال رقم يبدأ بـ 09 ويتكون من 10 خانات", "error");
      return;
    }

    if (phone !== confirmPhone) {
      showAndHideMessage("رقم التأكيد لا يطابق الرقم المدخل", "error");
      return;
    }

    if (!selectedPackage) {
      showAndHideMessage("يرجى اختيار الباقة", "error");
      return;
    }

    if (useDiscount && points < 1000) {
      showAndHideMessage("❌ لا تملك نقاط كافية لاستخدام الخصم", "error");
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '', show: false });

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?newsyria&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone,
          package: selectedPackage,
          total: totalPrice,
          discountUsed: useDiscount ? 1 : 0, // ✅ إرسال إذا استخدم خصم
        }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        setTimeout(() => {
          navigate('/oreder');
        }, 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك المالي لا يكفي", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showAndHideMessage("خطأ في الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header">
        <h4>تفاصيل الخدمة</h4>
      </div>

      <div className="service-icon">
        <img src="/images/syriatel.png" alt="تحويل الأموال" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <NewsTicker text={newsText} />

      <h2 className="service-title">تحويل وحدات سيريتل</h2>
      <p className="service-desc">تحويل سريع وآمن</p>

      <input
        type="text"
        placeholder="أدخل رقم الهاتف"
        value={phone}
        onChange={handlePhoneChange}
        className="input-field"
        inputMode="numeric"
      />

      <input
        type="text"
        placeholder="أعد إدخال رقم الهاتف للتأكيد"
        value={confirmPhone}
        onChange={handleConfirmPhoneChange}
        className="input-field"
        inputMode="numeric"
      />

      <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>
        ⚠️ تأكد من إدخال الرقم بشكل صحيح. الخدمة خاصة بأرقام سيريتل والمستخدم يتحمل مسؤولية الخطأ.
      </p>

      <select
        value={selectedPackage}
        onChange={(e) => setSelectedPackage(e.target.value)}
        className="select-field"
      >
        <option value="">-- اختر الباقة --</option>
        {/* نفس الباقات القديمة */}
        <option value="2013">2013</option>
        <option value="2301">2301</option>
        <option value="2396">2396</option>
        <option value="2588">2588</option>
        <option value="3068">3068</option>
        <option value="4026">4026</option>
        <option value="4506">4506</option>
        <option value="4793">4793</option>
        <option value="5273">5273</option>
        <option value="6232">6232</option>
        <option value="6807">6807</option>
        <option value="7190">7190</option>
        <option value="7766">7766</option>
        <option value="8149">8149</option>
        <option value="8628">8628</option>
        <option value="9587">9587</option>
        <option value="10067">10067</option>
        <option value="10546">10546</option>
        <option value="11505">11505</option>
        <option value="12464">12464</option>
        <option value="13039">13039</option>
        <option value="14381">14381</option>
        <option value="16011">16011</option>
        <option value="16299">16299</option>
        <option value="17257">17257</option>
        <option value="18312">18312</option>
        <option value="23969">23969</option>
        <option value="28763">28763</option>
        <option value="31639">31639</option>
        <option value="36912">36912</option>
        <option value="43144">43144</option>
        <option value="47938">47938</option>
        <option value="57526">57526</option>
        <option value="62320">62320</option>
        <option value="71907">71907</option>
        <option value="76701">76701</option>
        <option value="94918">94918</option>
        <option value="105465">105465</option>
        <option value="124640">124640</option>
        <option value="191754">191754</option>
        <option value="210930">210930</option>
        <option value="239693">239693</option>
        <option value="383509">383509</option>
        <option value="479386">479386</option>
        <option value="958772">958772</option>
        <option value="1438159">1438159</option>
      </select>

      {/* ✅ عرض النقاط وخيار الخصم */}
      <div style={{ marginTop: '15px' }}>
        <p>رصيد نقاطك الحالي: <b>{points}</b></p>
        <label>
          <input
            type="checkbox"
            checked={useDiscount}
            onChange={() => {
              if (points >= 1000) {
                setUseDiscount(!useDiscount);
              } else {
                showAndHideMessage("❌ لا تملك نقاط كافية لاستخدام الخصم", "error");
              }
            }}
          />
          أريد استخدام 1000 نقطة للحصول على خصم 8%
        </label>
      </div>

      <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
        {loading ? 'جاري الإرسال...' : `تأكيد الطلب - ${totalPrice.toFixed(2)} ل.س`}
      </button>

      {message.show && (
        <MessageDisplay
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: '', type: '', show: false })}
        />
      )}
    </div>
  );
}







function Chatgpt() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });
  const navigate = useNavigate();
  const fixedPrice = 26.0;

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => setMessage({ text: '', type: '', show: false }), 3000);
  };

  const handlePurchase = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?chatgpt&token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          total: fixedPrice,
        }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        setTimeout(() => navigate('/orders'), 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك غير كافٍ", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      showAndHideMessage("⚠️ فشل الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      {/* أيقونة الخدمة */}
      <div className="service-icon" style={{ textAlign: 'center', marginBottom: '15px' }}>
        <img
          src="/images/chat.png" // ← غيّر هذا المسار حسب صورة الأيقونة عندك
          alt="خدمة ChatGPT"
          style={{ width: '100px', borderRadius: '20px' }}
        />
      </div>

      <h2 className="service-title">اشتراك ChatGPT لمدة شهر</h2>
      <p className="service-desc">سعر الخدمة: 26 دولار</p>

      <button onClick={handlePurchase} className="submit-btn" disabled={loading}>
        {loading ? '...جاري التنفيذ' : '🛒 شراء الآن'}
      </button>

      {message.show && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}
    </div>
  );
}



function CarReport() {
  const [vin, setVin] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });
  const navigate = useNavigate();
  const fixedPrice = 3.0;

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => setMessage({ text: '', type: '', show: false }), 3000);
  };

  const handlePurchase = async () => {
    if (vin.trim().length < 17) {
      showAndHideMessage("يرجى إدخال رقم شاصي صالح (لا يقل عن 10 محارف)", "error");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?carreport&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vin: vin.trim(),
          total: fixedPrice,
        }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        setTimeout(() => navigate('/orders'), 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك غير كافٍ", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      showAndHideMessage("⚠️ فشل الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      {/* أيقونة الخدمة */}
      <div className="service-icon" style={{ textAlign: 'center', marginBottom: '15px' }}>
        <img
          src="/images/car.png" // ← ضع صورة مناسبة هنا
          alt="تقرير السيارة"
          style={{ width: '120px', borderRadius: '15px' }}
        />
      </div>

      <h2 className="service-title">🔍 تقرير السيارة</h2>
      <p className="service-desc" style={{ marginBottom: '20px', fontSize: '16px', color: '#555' }}>
        احصل على تقرير مفصّل لتاريخ السيارة المستعملة من خلال رقم الشاصي (VIN)، يشمل بيانات الحوادث، الفحص الفني، بلد المنشأ، والمزيد.
      </p>

      <input
        type="text"
        placeholder="أدخل رقم الشاصي (VIN)"
        value={vin}
        onChange={(e) => setVin(e.target.value)}
        className="input-field"
        style={{ textAlign: 'center', marginBottom: '20px', padding: '10px', fontSize: '16px' }}
      />

      <button onClick={handlePurchase} className="submit-btn" disabled={loading}>
        {loading ? '...جاري التنفيذ' : `🛒 شراء التقرير - ${fixedPrice} دولار`}
      </button>

      {message.show && (
        <div className={`message ${message.type}`} style={{ marginTop: '20px', textAlign: 'center' }}>
          {message.text}
        </div>
      )}
    </div>
  );
}


function SamaNet() {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [billInfo, setBillInfo] = useState(null);
  const [action, setAction] = useState('');
  const [amount, setAmount] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });

  const fixedCommission = 10;
  const navigate = useNavigate();
  const finalAmount = amount ? (parseFloat(amount) * (1 + fixedCommission / 100)).toFixed(0) : '';

  const showMessage = (text, type) => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: '', type: '' }), 3000);
  };

  const handleSearch = async () => {
    if (!phone.trim()) {
      showMessage("يرجى إدخال رقم الهاتف", "error");
      return;
    }

    setLoading(true);
    setBillInfo(null);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?samanet&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone.trim() }),
      });

      const result = await response.json();

      if (result.success) {
        setBillInfo(result.data);
        showMessage("✅ تم جلب البيانات بنجاح", "success");
      } else {
        showMessage(result.message || "فشل في جلب البيانات", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      showMessage("⚠️ فشل الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    if (!phone || !action || !amount || !finalAmount) {
      showMessage("يرجى تعبئة جميع الحقول قبل التأكيد", "error");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://syriacash.app/new/api.php?confirmSamaNet", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: phone.trim(),
          action,
          amount: parseFloat(amount),
          finalAmount: parseFloat(finalAmount),
          token
        }),
      });

      const result = await response.json();

      if (result.success) {
        showMessage("✅ تم تنفيذ العملية بنجاح", "success");
        setTimeout(() => navigate("/orders"), 1500);
      } else {
        showMessage(result.message || "❌ فشل في تنفيذ العملية", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("⚠️ حدث خطأ أثناء الاتصال بالخادم", "error");
    }
  };

  return (
    <div className="service-container">
      <div className="service-icon text-center my-4">
        <img
          src="/images/xdsfsd.jpg"
          alt="استعلام الفاتورة"
          style={{ width: '100px', borderRadius: '15px' }}
        />
      </div>

      <h2 className="service-title text-center mb-3">📱 الاستعلام عن فاتورة الهاتف</h2>

      <div className="mb-3">
        <input
          type="text"
          placeholder="أدخل رقم الهاتف"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="form-control text-center"
          style={{ padding: '12px', fontSize: '16px' }}
        />
      </div>

      <button onClick={handleSearch} className="btn btn-primary w-100 mb-3" disabled={loading}>
        🔍 عرض الفاتورة
      </button>

      {message.text && (
        <div className={`alert alert-${message.type}`} role="alert">
          {message.text}
        </div>
      )}

      {loading && <div className="text-center">⏳ جاري التحميل...</div>}

      {billInfo && !loading && (
        <div className="mt-4 p-3 border rounded bg-light">
          {billInfo.map((item, index) => (
            <div key={index} className="bg-white p-3 mb-3 rounded shadow-sm">
              <p><strong>📞 الهاتف:</strong> {item.number}</p>
              <p><strong>👤 المشترك:</strong> {item.subscriber}</p>
              <p><strong>💰 قيمة الفاتورة:</strong> {item.invoice_amount} ل.س</p>
              <p><strong>📅 الأشهر:</strong> {item.months}</p>
              <p><strong>💳 الرصيد المالي:</strong> {item.financial_balance}</p>
              <p><strong>📦 الباقة:</strong> {item.sim_gb_balance}</p>
              <p><strong>📉 الجيغا المستخدمة:</strong> {item.used_gb}</p>
              <p><strong>📈 الجيغا المتبقية:</strong> {item.remaining_gb}</p>
              <p><strong>🎁 الخصومات:</strong> {item.discounts}</p>
              <p><strong>🚀 السرعة:</strong> {item.speed}</p>
            </div>
          ))}

          <div className="mb-3">
            <label className="form-label">اختر نوع العملية:</label>
            <select className="form-select" value={action} onChange={(e) => setAction(e.target.value)}>
              <option value="">--- اختر ---</option>
              <option value="payBill">تسديد فاتورة</option>
              <option value="renewData">تجديد الجيغات</option>
            </select>
          </div>

          {action === "payBill" && (
            <div className="mb-3">
              <label>قيمة الفاتورة:</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="form-control"
                placeholder="أدخل المبلغ"
              />
            </div>
          )}

          {action === "renewData" && (
            <div className="mb-3">
              <label>اختر الباقة:</label>
              <select className="form-select" onChange={(e) => setAmount(e.target.value)}>
                <option value="">--- اختر الباقة ---</option>
                <option value="1800">ADSL_5GB - 1800 ل.س</option>
                <option value="3300">ADSL_10GB - 3300 ل.س</option>
                <option value="5700">ADSL_20GB - 5700 ل.س</option>
                <option value="11500">ADSL_50GB - 11500 ل.س</option>
                <option value="19000">ADSL_100GB - 19000 ل.س</option>
              </select>
            </div>
          )}

          {amount && (
            <>
              <div className="input-group my-2">
                <span className="input-group-text">العمولة (%)</span>
                <input type="number" className="form-control" value={fixedCommission} readOnly />
              </div>

              <div className="input-group my-2">
                <span className="input-group-text">المبلغ بعد العمولة</span>
                <input type="text" className="form-control" value={finalAmount + " ل.س"} readOnly />
              </div>

              <button className="btn btn-success w-100 mt-3" onClick={handleConfirm}>
                ✅ تأكيد تنفيذ العملية
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}


function ChangePasswordForm() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCamera, setShowCamera] = useState(false);

  const webcamRef = useRef(null);
  const fileInputRef = useRef();

  // التقاط صورة من الكاميرا
 const capturePhoto = () => {
  const imageSrc = webcamRef.current.getScreenshot();
  if (imageSrc) {
    // تحويل base64 إلى ملف
    const byteString = atob(imageSrc.split(",")[1]);
    const mimeString = imageSrc.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    const file = new File([blob], "photo.jpg", { type: mimeString });

    setProfileImage(file);
    setPreview(URL.createObjectURL(file));
    setShowCamera(false);
  }
};

  // اختيار صورة من المعرض
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // إرسال البيانات
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword && newPassword !== confirmPassword) {
      setMessage("❌ كلمة المرور غير متطابقة");
      return;
    }

    setLoading(true);
    setMessage("");
    const token = localStorage.getItem("authToken");

    try {
      const formData = new FormData();
      if (newPassword) formData.append("newPassword", newPassword);
      if (profileImage) formData.append("profileImage", profileImage);

      const response = await fetch(
        `https://syriacash.app/new/api.php?change-password&token=${token}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.success) {
        setMessage("✅  تم تحديث البيانات بنجاح قم بتسجيل الخروج ومن ثم الدخول لملاحظة التغيرات" );
        setNewPassword("");
        setConfirmPassword("");
        setProfileImage(null);
        setPreview(null);
      } else {
        setMessage(`❌ ${result.message}`);
      }
    } catch {
      setMessage("❌ حدث خطأ أثناء الاتصال بالسيرفر");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cpf-container">
      <form className="cpf-form" onSubmit={handleSubmit}>
        <h2>🔐 تحديث الحساب</h2>

        {message && <div className="cpf-message">{message}</div>}

        <label>كلمة المرور الجديدة</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="كلمة المرور الجديدة"
        />

        <label>تأكيد كلمة المرور</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="تأكيد كلمة المرور"
        />

        <label>صورة الملف الشخصي</label>
        <div className="cpf-button-group">
          <button type="button" onClick={() => fileInputRef.current.click()}>
            📁 رفع صورة
          </button>
          <button type="button" onClick={() => setShowCamera(!showCamera)}>
            📸 التقاط صورة
          </button>
        </div>

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileSelect}
        />

        {showCamera && (
          <div className="cpf-camera-wrapper">
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className="cpf-camera-frame"
            />
            <button
              type="button"
              onClick={capturePhoto}
              className="cpf-capture-btn"
            >
              📸 التقط الصورة
            </button>
          </div>
        )}

        {preview && (
          <img src={preview} alt="معاينة الصورة" className="cpf-preview-image" />
        )}

        <button type="submit" disabled={loading} className="cpf-submit-btn">
          {loading ? "⏳ جاري الحفظ..." : "💾 حفظ التغييرات"}
        </button>
      </form>
    </div>
  );
}



function ServiceStarlink() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(true); // ✅
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAccounts = async () => {
      setAccountsLoading(true);
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`https://syriacash.app/new/api.php?accountsstar&token=${token}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });

        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setAccounts(result.data);
        } else {
          console.warn("فشل استرجاع القائمة", result.message);
        }
      } catch (error) {
        console.error("خطأ في تحميل الحسابات:", error);
      } finally {
        setAccountsLoading(false); // ⛔️ إيقاف التحميل بعد الانتهاء
      }
    };

    fetchAccounts();
  }, []);

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => setMessage({ text: '', type: '', show: false }), 3000);
  };

  const handleSubmit = async () => {
    if (!email || !password) {
      showAndHideMessage("يرجى إدخال البريد وكلمة المرور", "error");
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '', show: false });

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?newsstar&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تنفيذ الطلب بنجاح", "success");
        const newAccount = { email, password };
        setAccounts(prev => [...prev, newAccount]);
        setEmail('');
setPassword('');
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ الطلب", "error");
      }

    } catch (error) {
      console.error("Fetch error:", error);
      showAndHideMessage("خطأ في الاتصال بالخادم", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = (index) => {
    const updatedList = [...accounts];
    updatedList.splice(index, 1);
    setAccounts(updatedList);
  };

  return (
    <div className="service-container">
      <h4>تسجيل الدخول</h4>

      <div className="service-icon">
        <img src="/images/star.png" alt="سيريا كاش" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <input
        type="email"
        placeholder="أدخل البريد الإلكتروني"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="input-field"
      />
      <input
        type="password"
        placeholder="أدخل كلمة المرور"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="input-field"
      />
      <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
        {loading ? 'جاري الإرسال...' : 'اضف الحساب'}
      </button>

      {message.show && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      {accountsLoading ? (
        <LoadingSpinner text="جاري تحميل الحسابات..." />
      ) : accounts.length > 0 ? (
        <div className="accounts-list">
     
          {accounts.map((acc, idx) => (
            <div className="account-item" key={idx}>
              <span className={`status-icon ${acc.status === 'active' ? 'active' : 'inactive'}`}>
                {acc.status === 'active' ? '✅' : '❌'}
              </span>

              <span className="account-email">{acc.email}</span>

              <button className="btn-show" onClick={() => navigate(`/account/${acc.id}`)}>عرض</button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted text-center mt-3">لا توجد حسابات مضافة بعد</p>
      )}
    </div>
  );
}


function AccountDetails() {
  const { id } = useParams();
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAccountDetails = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const res = await fetch(`https://syriacash.app/new/api.php?accountstar=${id}&token=${token}`);
        const data = await res.json();
        if (data.success) {
          setAccount(data.data);
        } else {
          console.error("فشل تحميل التفاصيل");
        }
      } catch (err) {
        console.error("حدث خطأ في التحميل:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAccountDetails();
  }, [id]);

  if (loading || !account) {
    return <div className="loading">📦 جاري تحميل تفاصيل الحساب...</div>;
  }

  return (
    <div className="account-detail-container">
      <div className="account-detail-card">
        <h2>تفاصيل خدمة Starlink</h2>
        <div className="account-info-grid">
          <div><strong>📧 الإيميل:</strong> {account.email}</div>
                   <div><strong>👤 الاسم و اللقب:</strong> {account.name}</div>
                            <div><strong>📞 رقم الهاتف:</strong> {account.phone}</div>
          <div><strong>📅 تاريخ الاستحقاق:</strong> {account.date}</div>
          <div><strong>⚙️ حالة الخدمة:</strong> {account.status}</div>
          <div><strong>💵 مبلغ الفاتورة:</strong> {account.price} دولار</div>
          <div><strong>📌 حالة الفاتورة:</strong> {account.state === 'paid' || account.state == 1 ? '✅ مدفوعة' : '❌ غير مدفوعة'}</div>
          <div><strong>🗺 عنوان الخدمة :</strong> {account.map}</div>
          <div><strong>🧾 KIT:</strong> {account.kit || '—'}</div>
          <div><strong>🆔 SID:</strong> {account.sid || '—'}</div>
          <div><strong>🔢 SN:</strong> {account.sn || '—'}</div>
        </div>
        <button className="back-btn" onClick={() => navigate(-1)}>🔙 العودة</button>
      </div>
    </div>
  );
}


function TransactionCard({ transaction }) {
    const statusDotColor = STATUS_COLORS[transaction.status] || '#6c757d'; // لون رمادي افتراضي

    return (
        <div className="transaction-card">
            <div className="transaction-header">
                <h6 className="transaction-title">{transaction.title}</h6>
                {transaction.status && (
                    <div className="transaction-status">
                        <span className="status-dot" style={{ backgroundColor: statusDotColor }}></span>
                        <span style={{ color: statusDotColor }}>{transaction.status}</span>
                    </div>
                )}
                {/* لعرض 'قيد المعالجة' أو 'المعالجة' */}
                {transaction.processingStatus && (
                    <div className="transaction-status">
                        <span className="status-dot" style={{ backgroundColor: STATUS_COLORS['قيد المعالجة'] }}></span>
                        <span style={{ color: STATUS_COLORS['قيد المعالجة'] }}>{transaction.processingStatus}</span>
                    </div>
                )}
            </div>

            <div className="transaction-details-grid">
                <div className="detail-row">
                    <span className="detail-label">التاريخ</span>
                    <span className="detail-value">{transaction.date}</span>
                </div>
                {transaction.method && (
                    <div className="detail-row">
                        <span className="detail-label">طريقة الإيداع</span>
                        <span className="detail-value">{transaction.method}</span>
                    </div>
                )}
                {transaction.reason && (
                    <div className="detail-row">
                        <span className="detail-label">سبب المعالجة</span>
                        <span className="detail-value">{transaction.reason}</span>
                    </div>
                )}
                {transaction.orderId && (
                    <div className="detail-row">
                        <span className="detail-label">رقم العملية</span>
                        <span className="detail-value">{transaction.orderId}</span>
                    </div>
                )}
                 <div className="detail-row">
                    <span className="detail-label">المبلغ</span>
                    <span className={`detail-value amount-value ${transaction.amount.startsWith('-') ? 'amount-minus' : 'amount-plus'}`}>
                        {transaction.amount} {transaction.currency}
                    </span>
                </div>
            </div>

           
        </div>
    );
}



function FinancialActivityPage() {
  const [filter, setFilter] = useState('all');
  const [transactions, setTransactions] = useState([]);
  const [balances, setBalances] = useState(null); // ✅ state للأرصدة
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleAddBalance = () => {
    navigate("/recharge-balance");
  };

  const handleWithdraw = () => {
    navigate("/currency-exchange"); 
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('لم يتم العثور على التوكين، الرجاء تسجيل الدخول مجدداً.');
      setLoading(false);
      return;
    }

    // جلب الأرصدة
    const fetchBalances = async () => {
      try {
        const res = await fetch(`https://syriacash.app/new/api.php?balances&token=${token}`);
        const data = await res.json();
        if (data.success) {
          setBalances(data.balances);
        }
      } catch (err) {
        console.error("Error fetching balances:", err);
      }
    };

    // جلب المعاملات المالية
    const fetchTransactions = async () => {
      setLoading(true);
      setError(null);
      try {
        const API_ENDPOINT = `https://syriacash.app/new/api.php?get_orders&token=${token}`;
        const headers = { 'Content-Type': 'application/json' };
        const response = await fetch(API_ENDPOINT, { headers });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const formattedTransactions = data.orders.map(item => ({
          id: item.id || item.order_id,
          type: item.type,
          title: item.title || item.transaction_name,
          status: item.status,
          processingStatus: item.processing_status,
          date: item.date_time || item.transaction_date,
          amount: item.amount,
          method: item.payment_method,
          orderId: item.order_id,
          reason: item.reason,
          currency: item.currency,
        }));

        setTransactions(formattedTransactions);
      } catch (err) {
        console.error("Error fetching transactions:", err);
        setError(err.message || "فشل في جلب بيانات الحركة المالية.");
      } finally {
        setLoading(false);
      }
    };

    fetchBalances();
    fetchTransactions();
  }, []);

  const filteredTransactions = transactions.filter(t => {
    if (filter === 'all') return true;
    return t.type === filter;
  });

  return (
    <div className="container mt-4 mb-4">
      <h4 className="page-header-title">الحركة المالية</h4>

      <div style={{ direction: "rtl" }} className="mb-3 d-flex gap-2">
        <button className="btn btn-success" onClick={handleAddBalance}>
          + إضافة رصيد
        </button>
        <button className="btn btn-warning" onClick={handleWithdraw}>
          🔄 التصريف
        </button>
      </div>

      {/* ✅ شريط عرض الأرصدة */}
{/* شريط عرض الأرصدة */}
{balances && (
  <div
    className="balances-wrapper mb-4"
    style={{
      display: "flex",
      gap: "16px",
      overflowX: "auto",
      padding: "12px 0",
    }}
  >
    {Object.entries(balances).map(([currency, amount]) => (
      <div
        key={currency}
        className="balance-card-item"
        style={{
          flex: "0 0 auto",       // حجم كل بطاقة يعتمد على محتواها
          padding: "20px",        // زيادة حجم البطاقة
          borderRadius: "12px",
          background: "#1a4187",  // خلفية زرقاء داكنة بدل الأبيض
          color: "#fff",          // كتابة باللون الأبيض لتكون واضحة
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "140px",      // زيادة عرض البطاقة
          textAlign: "center",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
        }}
      >
        <span style={{ fontWeight: "600", fontSize: "16px" }}>{currency}</span>
        <strong style={{ fontSize: "22px", marginTop: "8px" }}>{amount}</strong>
      </div>
    ))}
  </div>
)}

      <div className="filter-buttons mb-4">
        <button className={`btn filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>
          جميع المعاملات
        </button>
        <button className={`btn filter-btn ${filter === 'incoming' ? 'active' : ''}`} onClick={() => setFilter('incoming')}>
          وارد
        </button>
        <button className={`btn filter-btn ${filter === 'outgoing' ? 'active' : ''}`} onClick={() => setFilter('outgoing')}>
          صادر
        </button>
      </div>

      {loading ? (
        <div className="text-center text-primary mt-5">
          <i className="fas fa-spinner fa-spin fa-2x"></i>
          <p className="mt-2">جاري تحميل المعاملات...</p>
        </div>
      ) : error ? (
        <div className="text-center text-danger mt-5">
          <i className="fas fa-exclamation-circle fa-2x"></i>
          <p className="mt-2">{error}</p>
        </div>
      ) : filteredTransactions.length === 0 ? (
        <div className="text-center text-muted mt-5">
          <i className="fas fa-info-circle fa-2x"></i>
          <p className="mt-2">لا توجد معاملات لعرضها في هذا الفلتر.</p>
        </div>
      ) : (
        <div className="transactions-list">
          {filteredTransactions.map(transaction => (
            <TransactionCard key={transaction.id} transaction={transaction} />
          ))}
        </div>
      )}
    </div>
  );
}


function InternalTransfer() {
  const [recipientAccount, setRecipientAccount] = useState('');
  const [currency, setCurrency] = useState('');
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });

  const token = localStorage.getItem('authToken');
   if (!token) {
    // إعادة توجيه المستخدم إذا لم يكن مسجلاً الدخول
    navigate('/', { replace: true });
  }


  const navigate = useNavigate();

  const handleAmountChange = (e) => {
    const value = e.target.value;
    // السماح فقط بالأرقام والنقطة العشرية
    if (/^\d*\.?\d*$/.test(value)) {
      setAmount(value);
    }
  };

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => {
      setMessage({ text: '', type: '', show: false });
    }, 3000);
  };

  const handleSubmit = async () => {
    if (!recipientAccount.trim()) {
      showAndHideMessage("يرجى إدخال رقم الحساب المحول له.", "error");
      return;
    }
    if (!currency) {
      showAndHideMessage("يرجى اختيار العملة.", "error");
      return;
    }
    if (!amount || Number(amount) <= 0) {
      showAndHideMessage("يرجى إدخال مبلغ صحيح أكبر من صفر.", "error");
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '', show: false });

    try {
   
      const response = await fetch(`https://syriacash.app/new/api.php?internal-transfer&token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${localStorage.getItem('authToken')}` // إذا كان يتطلب توثيق
        },
        body: JSON.stringify({
          recipientAccount,
          currency,
          amount: Number(amount),
        }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم التحويل بنجاح!", "success");
        setTimeout(() => { navigate('/tranmony'); }, 1500); // التحويل لصفحة الطلبات أو التأكيد
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك المالي لا يكفي لإتمام التحويل.", "error");
      } else if (result.error === 'invalid_account') {
        showAndHideMessage("❌ رقم الحساب المحول له غير صالح.", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تنفيذ التحويل.", "error");
      }

    } catch (error) {
      console.error("Fetch error:", error);
      showAndHideMessage("خطأ في الاتصال بالخادم. يرجى المحاولة لاحقاً.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header">
        <h4>تحويل داخلي</h4>
      </div>

      <div className="service-icon">
        {/* أيقونة للتحويل الداخلي - يمكنك استبدالها بصورة مناسبة */}
        <img src="https://placehold.co/120x120/cccccc/white?text=Transfer" alt="تحويل داخلي" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <h2 className="service-title">تحويل الأموال بين الحسابات</h2>
      <p className="service-desc">تحويل سريع وآمن داخل النظام</p>

      <input
        type="text"
        placeholder="أدخل رقم الحساب المحول له"
        value={recipientAccount}
        onChange={(e) => setRecipientAccount(e.target.value)}
        className="input-field"
        inputMode="numeric" // لتسهيل إدخال الأرقام على الجوال
      />

      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="select-field"
      >
        <option value="">-- اختر العملة --</option>
        <option value="1">دولار أمريكي ($)</option>
        <option value="2">ليرة تركية (TL)</option>
        <option value="3">ليرة سورية (SP)</option>
      </select>

      <input
        type="text"
        placeholder="أدخل المبلغ"
        value={amount}
        onChange={handleAmountChange}
        className="input-field"
        inputMode="decimal" // للسماح بالأرقام العشرية
      />

      <button onClick={handleSubmit} className="submit-btn" disabled={loading}>
        {loading ? 'جاري التحويل...' : `تأكيد التحويل`}
      </button>

      {/* عرض مكون الرسالة */}
      {message.show && (
        <MessageDisplay
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: '', type: '', show: false })}
        />
      )}
    </div>
  );
}

function MeatSelection() {
  return (
    <div className="container mt-4">
      <h5 className="mb-4 text-center fw-bold">
        <i className="fas fa-store me-2 text-danger"></i>
        اختر المتجر
      </h5>

      <div className="row gy-4">

        {/* فروج المراعي */}
        <div className="col-12">
          <Link to="/liststorer/21" className="text-decoration-none">
            <div className="modern-card">
              <div className="icon-box bg-warning">
                <i className="fas fa-drumstick-bite text-white"></i>
              </div>

              <div className="flex-grow-1 ms-3">
                <h6 className="mb-1 fw-bold text-dark">
                  فروج المراعي
                </h6>
                <p className="mb-0 text-muted small">
                  فروج طازج يومياً، نظافة وجودة عالية وأسعار منافسة
                </p>
              </div>

              <i className="fas fa-chevron-left text-muted"></i>
            </div>
          </Link>
        </div>

        {/* ملحمة عباد الرحمن */}
        <div className="col-12">
          <Link to="/liststorer/22" className="text-decoration-none">
            <div className="modern-card">
              <div className="icon-box bg-danger">
                <i className="fas fa-bacon text-white"></i>
              </div>

              <div className="flex-grow-1 ms-3">
                <h6 className="mb-1 fw-bold text-dark">
                  ملحمة عباد الرحمن
                </h6>
                <p className="mb-0 text-muted small">
                  لحوم بلدية طازجة يومياً مع أفضل تقطيع حسب الطلب
                </p>
              </div>

              <i className="fas fa-chevron-left text-muted"></i>
            </div>
          </Link>
        </div>

      </div>
    </div>
  );
}





function HomePage() {
  const navigate = useNavigate();
  const [balances, setBalances] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const [ads, setAds] = useState([]);
  const [adsLoading, setAdsLoading] = useState(true);
  const [adsError, setAdsError] = useState(null);


const [cities, setCities] = useState([]);
const [selectedCity, setSelectedCity] = useState("");
const [showCityModal, setShowCityModal] = useState(false);






  // العدادات
  const [newItemsCountStore, setNewItemsCountStore] = useState(0);
  const [newItemsCountProducts, setNewItemsCountProducts] = useState(0);
  const [newItemsCountOpenShop, setNewItemsCountOpenShop] = useState(0);
  const [newItemsCountPayments, setNewItemsCountPayments] = useState(0);
  const [newItemsCountFastFood, setNewItemsCountFastFood] = useState(0);
  const [newItemsCountUniversity, setNewItemsCountUniversity] = useState(0);

  const [newItemsCountUniversitycar, setNewItemsCountUniversitycar] = useState(0);


  const [newItemsCountCoupons, setNewItemsCountCoupons] = useState(0);
  const [newItemsCountAppointments, setNewItemsCountAppointments] = useState(0);
  const [newItemsCountOffers, setNewItemsCountOffers] = useState(0); // ✅ جديد - عداد العروض
const [newItemsCountServices, setNewItemsCountServices] = useState(0); // ✅ جديد - عداد الخدمات
 const [newItemsCountCommunity, setNewItemsCountCommunity] = useState(0); // ✅ جديد - عداد المجتمع

const [message, setMessage] = useState('');
  const [type, setType] = useState('success');

  const closeMessage = () => setMessage('');

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };


useEffect(() => {
  const savedCity = localStorage.getItem("city");

  if (!savedCity) {
    setShowCityModal(true);

    fetch("https://syriacash.app/new/api.php?cities")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCities(data.cities);
        }
      });
  }
}, []);


const handleSelectCity = () => {
  if (!selectedCity) {
    alert("❌ يجب اختيار مدينة");
    return;
  }

  // حفظ محلياً (localStorage)
  localStorage.setItem("city", selectedCity);
 const token = localStorage.getItem("authToken");
  // إرسال إلى PHP
  fetch(`https://syriacash.app/new/api.php?save_city&token=${token}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ cityId: selectedCity }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        console.log("تم حفظ المدينة في الكوكيز بنجاح");
      }
    })
    .catch((err) => console.log(err));

  setShowCityModal(false);
};




const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    animation: "fadeIn 0.3s",
  },
  modal: {
    background: "#fff",
    padding: "30px 25px",
    borderRadius: "15px",
    width: "350px",
    textAlign: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
    animation: "slideDown 0.3s",
  },
  title: {
    marginBottom: "10px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "700",
  },
  subtitle: {
    marginBottom: "20px",
    color: "#555",
    fontSize: "14px",
  },
  select: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    marginBottom: "20px",
    fontSize: "16px",
    outline: "none",
    transition: "border 0.3s",
  },
  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "linear-gradient(90deg, #28a745, #218838)",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.3s",
  },
};

  // جلب الإعلانات
  useEffect(() => {
    const referralCode = localStorage.getItem("referralCode");
    const token = localStorage.getItem("authToken");

    const apiUrl = referralCode
      ? `https://syriacash.app/new/api.php?ads&ref=${referralCode}&token=${token}`
      : `https://syriacash.app/new/api.php?ads&token=${token}`;

    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.ads)) setAds(data.ads);
        else setAdsError("خطأ في تحميل الإعلانات");
      })
      .catch(err => setAdsError(err.message))
      .finally(() => setAdsLoading(false));
  }, []);

  // جلب الأرصدة + العدادات
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('loggedIn');
    if (!isLoggedIn) {
      navigate('/');
      return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('لم يتم العثور على التوكين، الرجاء تسجيل الدخول مجدداً.');
      setLoading(false);
      return;
    }

    fetch(`https://syriacash.app/new/api.php?balances&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setBalances(data.balances);

          // دالة المقارنة والتخزين
   const compareAndSet = (key, apiValue, setState) => {
  const newValue = Number(apiValue || 0);
  const storedValue = localStorage.getItem(key);

  // أول مرة فقط → خزّن بدون إشعار
  if (storedValue === null) {
    localStorage.setItem(key, newValue);
    setState(0);
    return;
  }

  const oldValue = Number(storedValue);
  let diff = newValue - oldValue;

  if (diff > 0) {
    // حد أقصى 99
    diff = diff > 99 ? 99 : diff;
    setState(diff);
  } else {
    setState(0);
  }
};


          // استدعاء لجميع العدادات
          compareAndSet('newItemsCountStore', data.new_items_store || 0, setNewItemsCountStore);
          compareAndSet('newItemsCountProducts', data.new_items_products || 0, setNewItemsCountProducts);
          compareAndSet('newItemsCountOpenShop', data.new_items_openshop || 0, setNewItemsCountOpenShop);
          compareAndSet('newItemsCountPayments', data.new_items_payments || 0, setNewItemsCountPayments);

          compareAndSet('newItemsCountFastFood', data.newItemsCountFastFood || 0, setNewItemsCountFastFood);
          compareAndSet('newItemsCountUniversity', data.newItemsCountUniversity || 0, setNewItemsCountUniversity);

  compareAndSet('newItemsCountUniversitycar', data.newItemsCountUniversitycar || 0, setNewItemsCountUniversitycar);

          compareAndSet('newItemsCountCoupons', data.newItemsCountCoupons || 0, setNewItemsCountCoupons);
          compareAndSet('newItemsCountAppointments', data.newItemsCountAppointments || 0, setNewItemsCountAppointments);
          compareAndSet('newItemsCountOffers', data.newItemsCountOffers || 0, setNewItemsCountOffers); // ✅ جديد
compareAndSet('newItemsCountServices', data.newItemsCountServices || 0, setNewItemsCountServices); // ✅ جديد
       
compareAndSet('newItemsCountCommunity', data.newItemsCountCommunity || 0, setNewItemsCountCommunity); // ✅ جديد

} else {
          setError(data.message || 'خطأ في تحميل الأرصدة');
        }
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));

  }, [navigate]);

  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (loading || !balances) return <LoadingSpinner text="جاري تحميل البيانات..." />;

  return (
    <div className="container xxx">


{showCityModal && (
  <div style={styles.overlay}>
    <div style={styles.modal}>
      <h2 style={styles.title}>اختر مدينتك</h2>
      <p style={styles.subtitle}>لا يمكنك متابعة التطبيق بدون اختيار المدينة</p>

      <select
        value={selectedCity}
        onChange={(e) => setSelectedCity(e.target.value)}
        style={styles.select}
      >
        <option value="">-- اختر مدينة --</option>
        {cities.map((city) => (
          <option key={city.id} value={city.id}>
            {city.name}
          </option>
        ))}
      </select>

      <button style={styles.button} onClick={handleSelectCity}>
        تأكيد
      </button>
    </div>
  </div>
)}


<div
  onClick={() => navigate('/foodsearch')}
  style={{
    display: 'flex', alignItems: 'center', gap: '10px',
    background: '#fff', border: '2px solid #f0f0f0', borderRadius: '16px',
    padding: '14px 16px', marginBottom: '18px', cursor: 'pointer',
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
  }}
>
  <span style={{ fontSize: '22px' }}>🍽️</span>
  <span style={{ color: '#888', fontSize: '15px', flex: 1, textAlign: 'right' }}>
    ماذا تريد أن تأكل اليوم؟
  </span>
  <i className="fas fa-search" style={{ color: '#1a4187' }}></i>
</div>



      {/* الإعلانات */}
      <div className="row gx-3 mb-4 action-buttons">
        {adsLoading && <p>جاري تحميل الإعلانات...</p>}
        {adsError && <p style={{ color: 'red' }}>{adsError}</p>}
        {!adsLoading && !adsError && ads.length > 0 && (
          <Slider {...sliderSettings} style={{ width: '100%' }}>
            {ads.map((ad, idx) => (
              <div key={idx}>
                <a href={ad.link} rel="noopener noreferrer">
                  <ImageWithSkeleton
                    src={ad.imageUrl}
                    alt={`Ad ${idx + 1}`}
                    style={{ width: "100%", height: "100px", borderRadius: "8px", cursor: "pointer" }}
                  />
                </a>
              </div>
            ))}
          </Slider>
        )}
      </div>



      <MessageDisplay message={message} type={type} onClose={closeMessage} />








      {/* أزرار البطاقات */}
      <div className="row gx-3 gy-3 mb-4">
        <div className="col-6">
          <Link to="/fast" className="text-decoration-none text-dark">
            <div className="card card-quick-action position-relative">
              <i className="fas fa-hamburger"></i>
              {newItemsCountFastFood > 0 && <span className="notification-badge">{newItemsCountFastFood}</span>}
              <div className="card-body">
                <h6>المطاعم</h6>
                <p>اطلب وجباتك المفضلة بسرعة</p>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-6">
          <Link to="/shop?category=all" className="text-decoration-none text-dark">
            <div className="card card-quick-action position-relative">
              <i className="fas fa-box-open"></i>
              {newItemsCountProducts > 0 && <span className="notification-badge">{newItemsCountProducts}</span>}
              <div className="card-body">
                <h6>الماركيت</h6>
                <p>كل ما يحتاجه منزلك</p>
              </div>
            </div>
          </Link>
        </div>

        {/* ✅ بطاقة العروض الجديدة */}
        <div className="col-6">
          <Link to="/ofers" className="text-decoration-none text-dark">
            <div className="card card-quick-action position-relative">
              <i className="fas fa-tags" style={{ color: 'red' }}></i>
              {newItemsCountOffers > 0 && <span className="notification-badge">{newItemsCountOffers}</span>}
              <div className="card-body">
                <h6>العروض</h6>
                <p>أحدث عروض المتاجر والمطاعم</p>
              </div>
            </div>
          </Link>
        </div>

     

     <div className="col-6">
          <Link to="/liststorer/20" className="text-decoration-none text-dark">
            <div className="card card-quick-action position-relative">
              <i className="fas fa-apple-alt"></i>
              {newItemsCountOpenShop > 0 && <span className="notification-badge">{newItemsCountOpenShop}</span>}
              <div className="card-body">
                <h6>خضروات و فواكه</h6>
                <p>خضروات الوالي</p>
              </div>
            </div>
          </Link>
        </div>




     <div className="col-6">
          <Link to="/meat-selection" className="text-decoration-none text-dark">
            <div className="card card-quick-action position-relative">
              <i className="fas fa-drumstick-bite"></i>
              {newItemsCountOpenShop > 0 && <span className="notification-badge">{newItemsCountOpenShop}</span>}
              <div className="card-body">
                <h6>اللحوم و الفروج</h6>
                <p>الجودة اللي بتستاهلها</p>
              </div>
            </div>
          </Link>
        </div>




<div className="col-6">
  <Link to="/fast?category=الحلويات و الضيافة" className="text-decoration-none text-dark">
    <div className="card card-quick-action position-relative">
      <i className="fas fa-birthday-cake" style={{ color: '#e91e8c' }}></i>
      <div className="card-body">
        <h6>الحلويات و الضيافة</h6>
        <p>حلويات ومعجنات ولوازم الضيافة</p>
      </div>
    </div>
  </Link>
</div>

<div className="col-6">
  <Link to="/fast?category=المقاهي و الكوكتيل" className="text-decoration-none text-dark">
    <div className="card card-quick-action position-relative">
      <i className="fas fa-coffee" style={{ color: '#6f4e37' }}></i>
      <div className="card-body">
        <h6>ركن المشروبات</h6>
        <p>مشروبات ساخنة وكوكتيلات منعشة</p>
      </div>
    </div>
  </Link>
</div>





   <div className="col-6">
          <Link to="/store" className="text-decoration-none text-dark">
            <div className="card card-quick-action position-relative">
              <i className="fas fa-store"></i>
              {newItemsCountStore > 0 && <span className="notification-badge">{newItemsCountStore}</span>}
              <div className="card-body">
                <h6>المتاجر</h6>
                <p>عشرات المعارض بإنتظارك</p>
              </div>
            </div>
          </Link>
        </div>





   



{/* ✅ بطاقة مجتمع سوريا كاش الجديدة */}
<div className="col-6">
  <Link to="/community" className="text-decoration-none text-dark">
    <div className="card card-quick-action position-relative">
      <i className="fas fa-users" style={{ color: '#1a4187' }}></i>
      {newItemsCountCommunity > 0 && <span className="notification-badge">{newItemsCountCommunity}</span>}
      <div className="card-body">
        <h6>مجتمع سوريا كاش</h6>
        <p>شارك، علّق، وتفاعل مع الآخرين</p>
      </div>
    </div>
  </Link>
</div>



      </div>
    </div>
  );
}




function FoodSearchPage() {
  const [query, setQuery] = useState('');
  const [meals, setMeals] = useState([]);
  const [drinks, setDrinks] = useState([]);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [error, setError] = useState('');

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedKind, setSelectedKind] = useState(null); // 'meal' | 'drink' | 'offer'
  const [quantity, setQuantity] = useState(1);
  const [cartLoading, setCartLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // ✅ حالة اللوحة الجانبية لمشروبات الماركيت
  const [showDrinksPanel, setShowDrinksPanel] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const runSearch = (term) => {
    if (!term.trim()) return;
    setLoading(true);
    setSearched(true);
    setError('');

    fetch(`https://syriacash.app/new/api.php?food_search&q=${encodeURIComponent(term)}&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMeals(data.meals || []);
          setDrinks(data.drinks || []);
          setOffers(data.offers || []);
        } else {
          setError(data.message || 'حدث خطأ أثناء البحث');
          setMeals([]); setDrinks([]); setOffers([]);
        }
      })
      .catch(() => setError('خطأ في الاتصال بالخادم'))
      .finally(() => setLoading(false));
  };

  // بحث تلقائي بعد التوقف عن الكتابة
  useEffect(() => {
    const delay = setTimeout(() => {
      if (query.trim().length >= 2) runSearch(query);
      else { setMeals([]); setDrinks([]); setOffers([]); setSearched(false); }
    }, 500);
    return () => clearTimeout(delay);
  }, [query]);

  const totalResults = meals.length + drinks.length + offers.length;

  const openProductModal = (item, kind) => {
    // منع فتح مودال المطاعم المغلقة
    if (kind === 'meal' && item.is_open === false) return;
    setSelectedItem(item);
    setSelectedKind(kind);
    setQuantity(1);
    setModalOpen(true);
  };

  // إضافة مباشرة للسلة حسب نوع العنصر (نفس منطق قسم المطاعم)
  const handleAddToCart = () => {
    if (!selectedItem?.id) return;

    if (selectedKind === 'meal' && selectedItem.is_open === false) {
      setMessage({ text: '⚠️ هذا المطعم مغلق حالياً، لا يمكن إضافة الطلب', type: 'error' });
      return;
    }

    setCartLoading(true);

    let endpoint = '';
    if (selectedKind === 'drink') endpoint = 'addToCart';          // منتجات الماركت
    else if (selectedKind === 'meal') endpoint = 'addToCartf';      // وجبات المطاعم
    else if (selectedKind === 'offer') endpoint = 'addToCartofer';  // العروض

    fetch(`https://syriacash.app/new/api.php?${endpoint}&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: selectedItem.id,
        quantity,
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage({ text: '✅ تمت إضافة المنتج إلى السلة!', type: 'success' });
          setQuantity(1);
          setModalOpen(false);
        } else {
          setMessage({ text: data.message || 'فشل الإضافة', type: 'error' });
        }
      })
      .catch(() => setMessage({ text: 'خطأ في الاتصال بالخادم', type: 'error' }))
      .finally(() => setCartLoading(false));
  };

  const imageSrcFor = (item, kind) =>
    kind === 'drink' ? item.image : `https://syriacash.app/images/${item.image}`;

  const ResultCard = ({ item, kind }) => {
    const isClosed = kind === 'meal' && item.is_open === false;

    return (
      <div
        className="service-card"
        onClick={() => openProductModal(item, kind)}
        style={{
          position: 'relative',
          opacity: isClosed ? 0.55 : 1,
          cursor: isClosed ? 'not-allowed' : 'pointer',
        }}
      >
        <ImageWithSkeleton src={imageSrcFor(item, kind)} alt={item.name} />
        <div className="card-info">
          <div className="card-title">{item.name}</div>
          {item.restaurant_name && <div className="card-desc">🍽 {item.restaurant_name}</div>}
          {item.nameco && <div className="card-desc">🏪 {item.nameco}</div>}
          <div className="card-price-wrapper">
            {item.old_price && <span className="old-price">{item.old_price} ₺</span>}
            <span className="new-price">{item.price} ₺</span>
          </div>
        </div>

        {isClosed && (
          <span style={{
            position: 'absolute', top: '8px', right: '8px',
            background: '#c0392b', color: '#fff', fontSize: '11px', fontWeight: '700',
            padding: '3px 10px', borderRadius: '20px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
          }}>
            🔴 المطعم مغلق حالياً
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="services-container" style={{ marginTop: '70px', direction: 'rtl' }}>
      <MessageDisplay message={message.text} type={message.type} onClose={() => setMessage({ text: '', type: '' })} />

      {/* ✅ زر عائم لفتح قائمة المشروبات من الماركيت */}
      <button
        onClick={() => setShowDrinksPanel(true)}
        style={{
          position: 'fixed', left: '14px', bottom: '90px', zIndex: 500,
          background: 'linear-gradient(135deg,#1a4187,#2563eb)', color: '#fff',
          border: 'none', borderRadius: '50%', width: '56px', height: '56px',
          fontSize: '26px', boxShadow: '0 4px 14px rgba(0,0,0,0.25)', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        title="مشروبات من الماركيت"
      >
        🥤
      </button>

      {/* 🔍 شريط البحث */}
      <div className="search-box" style={{ marginBottom: '10px' }}>
        <input
          type="text"
          autoFocus
          placeholder="🍔 ابحث عن طعام، مشروب، أو عرض..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="search-input"
        />
        <button className="search-btn" onClick={() => runSearch(query)}>
          <i className="fas fa-search"></i>
        </button>
      </div>

      {loading && <LoadingSpinner text="جاري البحث..." />}
      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

      {!loading && searched && totalResults === 0 && !error && (
        <p style={{ textAlign: 'center', color: '#888', marginTop: '30px' }}>
          🔍 لا توجد نتائج مطابقة لبحثك
        </p>
      )}

      {!loading && meals.length > 0 && (
        <>
          <h5 style={{ margin: '16px 0 10px' }}>🍽 الأطعمة</h5>
          <div className="cards-grid">
            {meals.map(m => <ResultCard key={`meal-${m.id}`} item={m} kind="meal" />)}
          </div>
        </>
      )}

      {!loading && drinks.length > 0 && (
        <>
          <h5 style={{ margin: '20px 0 10px' }}>🥤 المشروبات</h5>
          <div className="cards-grid">
            {drinks.map(d => <ResultCard key={`drink-${d.id}`} item={d} kind="drink" />)}
          </div>
        </>
      )}

      {!loading && offers.length > 0 && (
        <>
          <h5 style={{ margin: '20px 0 10px' }}>🏷 العروض</h5>
          <div className="cards-grid">
            {offers.map(o => <ResultCard key={`offer-${o.id}`} item={o} kind="offer" />)}
          </div>
        </>
      )}

      {!searched && (
        <p style={{ textAlign: 'center', color: '#aaa', marginTop: '40px' }}>
          اكتب حرفين على الأقل لبدء البحث
        </p>
      )}

      {/* ✅ مودال المنتج - نفس نموذج قسم المطاعم */}
      {modalOpen && selectedItem && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalOpen(false)}>
              ✖
            </button>

            <div className="modal-body">
              <h2>{selectedItem.name}</h2>

              <div style={{ textAlign: "center", margin: "20px 0" }}>
                <img
                  src={imageSrcFor(selectedItem, selectedKind)}
                  alt={selectedItem.name}
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    borderRadius: "15px",
                    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                  }}
                />
              </div>

              {(selectedItem.restaurant_name || selectedItem.nameco) && (
                <p>
                  <strong>{selectedKind === 'meal' ? 'المطعم' : 'المصدر'}:</strong>{' '}
                  {selectedItem.restaurant_name || selectedItem.nameco}
                </p>
              )}

              <p>
                <strong>السعر:</strong>{" "}
                {selectedItem.old_price && (
                  <span className="old-price" style={{ marginLeft: "8px" }}>
                    {selectedItem.old_price} ₺
                  </span>
                )}
                <span className="new-price">{selectedItem.price} ₺</span>
              </p>

              <div className="quantity-control">
                <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                <span>{quantity}</span>
                <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>
                  −
                </button>
              </div>

              <button
                className="add-to-cart-btn"
                onClick={handleAddToCart}
                disabled={cartLoading}
              >
                {cartLoading ? "⏳ جاري الإضافة..." : "🛒 أضف إلى السلة"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ لوحة المشروبات الجانبية (نفس المكوّن المستخدم في ListStorer) */}
      <DrinksSidePanel isOpen={showDrinksPanel} onClose={() => setShowDrinksPanel(false)} />
    </div>
  );
}











function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  // ─── تفاصيل الطلب ────────────────────────────────────────
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('لم يتم العثور على التوكين');
      setLoading(false);
      return;
    }

    fetch(`https://syriacash.app/new/api.php?orders&token=${token}`, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.orders)) {
          setOrders(data.orders);
        } else {
          setError(data.message || 'فشل في تحميل الفواتير');
        }
      })
      .catch(() => setError('خطأ في الاتصال بالخادم'))
      .finally(() => setLoading(false));
  }, []);

  // ─── جلب تفاصيل الطلب ────────────────────────────────────
  const openOrderDetails = (order) => {
    setSelectedOrder(order);
    setOrderDetails(null);
    setDetailsError('');
    setDetailsLoading(true);

    const token = localStorage.getItem('authToken');
    fetch(`https://syriacash.app/new/api.php?order_details&id=${order.orderNumber}&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setOrderDetails(data);
        } else {
          setDetailsError(data.message || 'فشل في تحميل التفاصيل');
        }
      })
      .catch(() => setDetailsError('خطأ في الاتصال بالخادم'))
      .finally(() => setDetailsLoading(false));
  };

  const closeModal = () => {
    setSelectedOrder(null);
    setOrderDetails(null);
    setDetailsError('');
  };

  const filteredOrders = orders.filter(order => {
    if (filter === 'all') return true;
    if (filter === 'ok') return order.status === 'تمت الموافقة';
    if (filter === 'wit') return order.status === 'بالانتظار';
    if (filter === 'bad') return order.status === 'مرفوض';
    return true;
  });

  const statusColor = (status) => {
    if (status === 'تمت الموافقة') return '#28a745';
    if (status === 'مرفوض') return '#e63946';
    return '#f0a500';
  };

  return (
    <div className="container xxx">
      <div className="filter-buttons mb-4">
        <button className={`btn filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>جميع المعاملات</button>
        <button className={`btn filter-btn ${filter === 'ok' ? 'active' : ''}`} onClick={() => setFilter('ok')}>تمت الموافقة</button>
        <button className={`btn filter-btn ${filter === 'wit' ? 'active' : ''}`} onClick={() => setFilter('wit')}>بالانتظار</button>
        <button className={`btn filter-btn ${filter === 'bad' ? 'active' : ''}`} onClick={() => setFilter('bad')}>مرفوض</button>
      </div>

      {loading ? (
        <LoadingSpinner text="جاري تحميل الطلبات..." />
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : filteredOrders.length === 0 ? (
        <p>لا توجد معاملات حسب الفلتر الحالي</p>
      ) : (
        filteredOrders.map((order, index) => (
          <div className="order-card" key={index}
            onClick={() => openOrderDetails(order)}
            style={{ cursor: 'pointer' }}
          >
            <div className="order-header">
              <span className="detail-value" style={{ fontWeight: 'bold', color: statusColor(order.status) }}>
                {order.status}
              </span>
              <h6>{order.title}</h6>
            </div>

            <div className="order-details-row">
              <span className="detail-label">رقم الطلب</span>
              <span className="detail-value">{order.orderNumber}</span>
            </div>

            <div className="order-details-row">
              <span className="detail-label">التاريخ</span>
              <span className="detail-value">{order.date}</span>
            </div>

            <div className="order-details-row">
              <span className="detail-label">المبلغ</span>
              <span className={`detail-value amount-value ${order.amount < 0 ? 'amount-minus' : 'amount-plus'}`}>
                {order.amount} {order.currency}
              </span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {order.name}
            </div>

            <div style={{ textAlign: 'center', marginTop: '8px', color: '#007bff', fontSize: '13px' }}>
              اضغط لعرض التفاصيل ←
            </div>
          </div>
        ))
      )}

      {/* ─── Modal تفاصيل الطلب ─────────────────────────── */}
      {selectedOrder && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 9999,
            display: 'flex', alignItems: 'flex-end', justifyContent: 'center'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              backgroundColor: '#fff', width: '100%', maxWidth: '500px',
              borderRadius: '18px 18px 0 0', padding: '20px',
              maxHeight: '85vh', overflowY: 'auto', direction: 'rtl'
            }}
          >
            {/* رأس الـ Modal */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h5 style={{ margin: 0, fontWeight: 'bold' }}>🧾 تفاصيل الطلب #{selectedOrder.orderNumber}</h5>
              <button onClick={closeModal}
                style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>
                ✕
              </button>
            </div>

            {/* حالة الطلب */}
            <div style={{
              backgroundColor: statusColor(selectedOrder.status) + '18',
              border: `1px solid ${statusColor(selectedOrder.status)}`,
              borderRadius: '10px', padding: '10px 14px', marginBottom: '16px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
              <span style={{ color: statusColor(selectedOrder.status), fontWeight: 'bold' }}>
                {selectedOrder.status}
              </span>
              <span style={{ color: '#555', fontSize: '13px' }}>{selectedOrder.date}</span>
            </div>

            {/* التحميل */}
            {detailsLoading && (
              <div style={{ textAlign: 'center', padding: '30px 0' }}>
                <div className="spinner"></div>
                <p style={{ color: '#888', marginTop: '10px' }}>جاري تحميل المنتجات...</p>
              </div>
            )}

            {/* خطأ */}
            {detailsError && (
              <div style={{ color: '#e63946', textAlign: 'center', padding: '20px' }}>
                ⚠️ {detailsError}
              </div>
            )}

            {/* المنتجات */}
            {orderDetails && (
              <>
                <p style={{ color: '#888', fontSize: '13px', marginBottom: '12px' }}>
                  عدد المنتجات: <strong>{orderDetails.items_count}</strong>
                </p>

                {orderDetails.items.map((item, i) => (
                  <div key={i} style={{
                    border: '1px solid #eee', borderRadius: '12px',
                    padding: '12px', marginBottom: '12px',
                    display: 'flex', gap: '12px', alignItems: 'flex-start'
                  }}>
                    {/* صورة المنتج */}
                    {item.images && item.images[0] ? (
                      <img src={item.images[0]} alt={item.name}
                        style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '10px', flexShrink: 0 }}
                        onError={e => { e.target.style.display = 'none'; }}
                      />
                    ) : (
                      <div style={{
                        width: '70px', height: '70px', borderRadius: '10px',
                        backgroundColor: '#f0f0f0', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0
                      }}>
                        🛒
                      </div>
                    )}

                    {/* بيانات المنتج */}
                    <div style={{ flex: 1 }}>
                      <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '14px' }}>{item.name}</p>
                      {item.restaurant_name && (
                        <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#888' }}>{item.label} — {item.restaurant_name}</p>
                      )}
                      {item.store_name && (
                        <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#888' }}>{item.label} — {item.store_name}</p>
                      )}
                      {!item.restaurant_name && !item.store_name && (
                        <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#888' }}>{item.label}</p>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                        <span style={{ fontSize: '13px', color: '#555' }}>الكمية: {item.quantity}</span>
                        <span style={{ fontSize: '13px', color: '#007bff', fontWeight: 'bold' }}>
                          {item.subtotal} {item.currency}
                        </span>
                      </div>
                      <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#aaa' }}>
                        سعر الوحدة: {item.price} {item.currency}
                      </p>
                    </div>
                  </div>
                ))}

                {/* الإجمالي */}
                <div style={{
                  borderTop: '2px dashed #eee', paddingTop: '14px', marginTop: '8px'
                }}>
                  {orderDetails.order.shipping > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                      <span style={{ color: '#555' }}>🚚 أجور التوصيل</span>
                      <span style={{ fontWeight: 'bold' }}>{orderDetails.order.shipping} {orderDetails.order.currency}</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '15px' }}>💵 الإجمالي</span>
                    <span style={{ fontWeight: 'bold', fontSize: '15px', color: '#28a745' }}>
                      {orderDetails.order.total} {orderDetails.order.currency}
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}












function CurrencyExchange() {
  const [amount, setAmount] = useState('');
  const [fromCurrency, setFromCurrency] = useState('');
  const [toCurrency, setToCurrency] = useState('');
  const [convertedAmount, setConvertedAmount] = useState('0.00');
  const [loading, setLoading] = useState(false);
  const [exchangeRates, setExchangeRates] = useState({});
  const [showExchangeInfo, setShowExchangeInfo] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '', show: false });

  const navigate = useNavigate();

  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => {
      setMessage({ text: '', type: '', show: false });
    }, 3000);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setAmount(value);
      setShowExchangeInfo(false);
    }
  };

  // جلب أسعار الصرف من API
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`https://syriacash.app/new/api.php?get-exchange-rates&token=${token}`);
        const data = await response.json();

        if (data.success && data.rates) {
          setExchangeRates(data.rates);
        } else {
          showAndHideMessage("⚠️ فشل تحميل أسعار الصرف", "error");
        }
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
        showAndHideMessage("❌ فشل الاتصال بواجهة الأسعار", "error");
      }
    };

    fetchRates();
  }, []);

  // تحديث القيمة المحولة عند تغير المبلغ أو العملات أو الأسعار
  useEffect(() => {
    if (amount && fromCurrency && toCurrency && fromCurrency !== toCurrency) {
      const rate = exchangeRates[fromCurrency]?.[toCurrency];
      if (rate) {
        setConvertedAmount((Number(amount) * rate).toFixed(2));
      } else {
        setConvertedAmount('0.00');
      }
    } else {
      setConvertedAmount('0.00');
    }
  }, [amount, fromCurrency, toCurrency, exchangeRates]);

  const handlePreview = () => {
    if (!amount || Number(amount) <= 0) {
      showAndHideMessage("يرجى إدخال مبلغ صحيح للتحويل.", "error");
      return;
    }
    if (!fromCurrency) {
      showAndHideMessage("يرجى اختيار العملة المصدر.", "error");
      return;
    }
    if (!toCurrency) {
      showAndHideMessage("يرجى اختيار العملة المستهدفة.", "error");
      return;
    }
    if (fromCurrency === toCurrency) {
      showAndHideMessage("لا يمكن تحويل العملة إلى نفسها.", "error");
      return;
    }
    if (convertedAmount === '0.00' || !Number(convertedAmount)) {
      showAndHideMessage("لا يمكن حساب المبلغ المحول. يرجى التحقق من العملات.", "error");
      return;
    }
    setShowExchangeInfo(true);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setMessage({ text: '', type: '', show: false });

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://syriacash.app/new/api.php?currency-exchange&token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: Number(amount),
          fromCurrency,
          toCurrency,
          convertedAmount: Number(convertedAmount),
        }),
      });

      const result = await response.json();

      if (result.success) {
        showAndHideMessage("✅ تم تصريف العملات بنجاح!", "success");
        setTimeout(() => { navigate('/tranmony'); }, 1500);
      } else if (result.error === 'insufficient_balance') {
        showAndHideMessage("❌ رصيدك المالي من " + fromCurrency + " لا يكفي.", "error");
      } else {
        showAndHideMessage(result.message || "حدث خطأ أثناء تصريف العملات.", "error");
      }

    } catch (error) {
      console.error("Fetch error:", error);
      showAndHideMessage("خطأ في الاتصال بالخادم. يرجى المحاولة لاحقاً.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header">
        <h4>تصريف العملات</h4>
      </div>

      <div className="service-icon">
        <img src="https://placehold.co/120x120/cccccc/white?text=Exchange" alt="تصريف العملات" style={{ width: '120px', borderRadius: '22px' }} />
      </div>

      <h2 className="service-title">تبديل العملات</h2>
      <p className="service-desc">صرف العملات بين حساباتك بسهولة</p>

      <input
        type="text"
        placeholder="المبلغ المراد تصريفه"
        value={amount}
        onChange={handleAmountChange}
        className="input-field"
        inputMode="decimal"
      />

      <select
        value={fromCurrency}
        onChange={(e) => { setFromCurrency(e.target.value); setShowExchangeInfo(false); }}
        className="select-field"
      >
        <option value="">-- من عملة --</option>
        <option value="USD">دولار أمريكي ($)</option>
        <option value="TRY">ليرة تركية (TL)</option>
        <option value="SYP">ليرة سورية (SP)</option>
      </select>

      <select
        value={toCurrency}
        onChange={(e) => { setToCurrency(e.target.value); setShowExchangeInfo(false); }}
        className="select-field"
      >
        <option value="">-- إلى عملة --</option>
        <option value="USD">دولار أمريكي ($)</option>
        <option value="TRY">ليرة تركية (TL)</option>
        <option value="SYP">ليرة سورية (SP)</option>
      </select>

      <button onClick={handlePreview} className="submit-btn">
        عرض السعر
      </button>

      {showExchangeInfo && (
        <div className="converted-amount-display">
          <p>المبلغ بعد التحويل:</p>
          <h3>{convertedAmount} {toCurrency}</h3>
          <p style={{ fontSize: '14px', marginTop: '8px', color: '#666' }}>
            سعر الصرف: 1 {fromCurrency} = {exchangeRates[fromCurrency]?.[toCurrency] || 0} {toCurrency}
          </p>
          <button
            onClick={handleSubmit}
            className="submit-btn mt-3"
            disabled={loading}
          >
            {loading ? 'جاري التصريف...' : 'تأكيد العملية'}
          </button>
        </div>
      )}

      {message.show && (
        <MessageDisplay
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: '', type: '', show: false })}
        />
      )}
    </div>
  );
}




 function Outb() {


  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
       localStorage.setItem("out", "1");
    window.location.href = "/"; // يرجع المستخدم لصفحة الدخول
  };




   return (
  <div
  style={{
    position: "relative",
    inset: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px",
    
    zIndex: 9999,
  }}
>
  <div
    style={{
      backgroundColor: "#fff3cd",
      border: "1px solid #ffeeba",
      borderRadius: "14px",
      padding: "22px",
      color: "#856404",
      fontSize: "clamp(14px, 2.5vw, 16px)",
      lineHeight: "1.8",
      textAlign: "center",
      boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
      width: "100%",
      maxWidth: "420px",
      boxSizing: "border-box",
       marginTop: "80px",

    }}
  >
    <h3>🚫 حساب الزائر محدود</h3>

    <p style={{ marginTop: "10px" }}>
      عذرًا، حساب الزائر لا يمكنه الدخول لهذه الصفحة.
      <br />
      لإنشاء حساب دائم مرتبط برقمك والاستفادة من جميع الميزات،
      يرجى تسجيل الخروج وإنشاء حساب جديد.
    </p>

    <button
      onClick={handleLogout}
      style={{
        marginTop: "18px",
        padding: "10px 25px",
        backgroundColor: "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "15px",
      }}
    >
      🔒 تسجيل الدخول
    </button>
  </div>
</div>


  );

}




function PaymentMethods() {
  const [methods, setMethods] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isGuest, setIsGuest] = useState(false);

useEffect(() => {
  const token = localStorage.getItem("authToken");

  fetch(`https://syriacash.app/new/apix.php?paymentMethods&token=${token}`)
    .then((res) => res.json())
    .then((data) => {
      if (data?.success) {
        // ✅ تحديد نوع الحساب القادم من API
        if (data.type === "guest") {
          setIsGuest(true);
        } else {
          setIsGuest(false);
        }

        if (Array.isArray(data.data)) {
          setMethods(data.data);
        }
      }
    })
    .catch((err) => console.error("فشل تحميل طرق الدفع:", err))
    .finally(() => setLoading(false));
}, []);


  const handleCopy = (code) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setMessage("✅ تم نسخ الكود");
        setMessageType("success");
      })
      .catch(() => {
        setMessage("❌ لم يتم النسخ");
        setMessageType("error");
      });
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
       localStorage.setItem("out", "1");
    window.location.href = "/"; // يرجع المستخدم لصفحة الدخول
  };

  const getMethodUrl = (m) => {
    const candidates = [
      m?.url,
      m?.link,
      m?.payment_url,
      m?.redirect,
      m?.href,
      m?.meta?.url,
      m?.meta?.link,
    ].filter(Boolean);
    return candidates[0] || null;
  };

  return (
    <div
      style={{
        padding: "30px 15px",
        backgroundColor: "#f7f7f7",
        minHeight: "100vh",
        marginTop: "54px",
      }}
    >
      {/* ✅ رسالة النسخ */}
      {message && (
        <div
          style={{
            backgroundColor: messageType === "success" ? "#d1fae5" : "#fee2e2",
            color: messageType === "success" ? "#065f46" : "#991b1b",
            padding: "10px",
            borderRadius: "8px",
            marginBottom: "15px",
            textAlign: "center",
          }}
        >
          {message}
        </div>
      )}

      <div style={{ maxWidth: 900, margin: "auto", textAlign: "center" }}>
        {/* ✅ إذا كان المستخدم زائر */}
        {isGuest ? (
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "12px",
              padding: "25px",
              color: "#856404",
              fontSize: "16px",
              lineHeight: "1.8",
              textAlign: "center",
              boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
            }}
          >
            <h3>🚫 حساب الزائر محدود</h3>
            <p style={{ marginTop: "10px" }}>
              عذرًا، حساب الزائر لا يمكنه إضافة الرصيد أو استخدام ميزات الدفع.
              <br />
              لإنشاء حساب دائم مرتبط برقمك والاستفادة من جميع الميزات،
              يرجى تسجيل الخروج وإنشاء حساب جديد.
            </p>
            <button
              onClick={handleLogout}
              style={{
                marginTop: "20px",
                padding: "10px 25px",
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              🔒 تسجيل الدخول
            </button>
          </div>
        ) : (
          <>
            <h3 style={{ marginBottom: "20px" }}>اختر طريقة تعبئة الرصيد</h3>

            {loading && <p>⏳ جاري تحميل طرق الدفع...</p>}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                gap: "20px",
              }}
            >
              {!loading &&
                methods.map((method) => (
                  <div
                    key={method.id}
                    onClick={() => setSelected(method)}
                    style={{
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      padding: "20px 10px",
                      textAlign: "center",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(0,0,0,0.2)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0,0,0,0.1)")
                    }
                  >
                    {method.icon && (
                      <ImageWithSkeleton
                        src={`/images/${method.icon}`}
                        alt={method.name}
                        size={50}
                      />
                    )}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#333",
                        marginTop: "10px",
                      }}
                    >
                      {method.name}
                    </span>
                  </div>
                ))}
            </div>

            {/* ✅ نافذة التفاصيل */}
            {selected && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}
                onClick={() => setSelected(null)}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "25px",
                    borderRadius: "12px",
                    maxWidth: "500px",
                    width: "90%",
                    textAlign: "right",
                    position: "relative",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    onClick={() => setSelected(null)}
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      border: "none",
                      background: "transparent",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    ❌
                  </button>

                  <h4
                    style={{
                      fontSize: "20px",
                      marginBottom: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexDirection: "row-reverse",
                    }}
                  >
                    {selected.icon && (
                      <ImageWithSkeleton
                        src={`/images/${selected.icon}`}
                        alt={selected.name}
                        size={28}
                      />
                    )}
                    {selected.name}
                  </h4>

                  {selected.note && (
                    <p
                      style={{
                        backgroundColor: "#fef3c7",
                        padding: "10px",
                        borderRadius: "6px",
                        color: "#92400e",
                        marginBottom: "15px",
                        fontSize: "15px",
                      }}
                    >
                      💡 <strong>ملاحظة:</strong> {selected.note}
                    </p>
                  )}

                  {["code1", "code2", "code"].map(
                    (key) =>
                      selected[key] && (
                        <div
                          key={key}
                          style={{
                            fontSize: "16px",
                            direction: "ltr",
                            backgroundColor: "#f9f9f9",
                            padding: "10px",
                            borderRadius: "6px",
                            marginBottom: "10px",
                            border: "1px solid #eee",
                          }}
                        >
                          {selected[key]}{" "}
                          <button
                            type="button"
                            onClick={() => handleCopy(selected[key])}
                            style={{
                              marginLeft: "10px",
                              padding: "5px 8px",
                              fontSize: "13px",
                              backgroundColor: "#007bff",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                          >
                            📋 نسخ
                          </button>
                        </div>
                      )
                  )}

                  {getMethodUrl(selected) && (
                    <a
                      href={getMethodUrl(selected)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "block",
                        marginTop: "20px",
                        padding: "12px",
                        backgroundColor: "#10b981",
                        color: "#fff",
                        textAlign: "center",
                        borderRadius: "8px",
                        textDecoration: "none",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      🚀 ابدأ التعبئة
                    </a>
                  )}
                  <p
                    style={{
                      marginTop: "10px",
                      fontSize: "13px",
                      color: "red",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    ⚠️ تأكد من تحديث التطبيق لآخر إصدار للتواصل معنا عبر الواتس آب
                  </p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}







function PaymentPage() {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "", show: false });

  const token = localStorage.getItem("authToken");

  // ✅ دالة عرض الرسالة وإخفائها بعد 3 ثواني
  const showAndHideMessage = (text, type) => {
    setMessage({ text, type, show: true });
    setTimeout(() => {
      setMessage({ text: "", type: "", show: false });
    }, 3000);
  };

  // التحقق من حالة الدفع بعد العودة من البوابة
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const pid = params.get("paymentId");

    if (status && pid) {
      if (status === "success") {
        showAndHideMessage("✅ تم الدفع بنجاح", "success");
      } else if (status === "failed") {
        showAndHideMessage("❌ فشل الدفع، يرجى المحاولة مرة أخرى", "error");
      }
    }
  }, []);

  const handlePayment = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      showAndHideMessage("⚠️ أدخل مبلغ صحيح بالليرة السورية", "error");
      return;
    }

    if (!token) {
      showAndHideMessage("❌ لم يتم تسجيل الدخول", "error");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?createPayment&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: Number(amount) }),
        }
      );

      const data = await res.json();

      if (data.success && data.redirect_url) {
        window.location.href = data.redirect_url;
      } else {
        showAndHideMessage(data.message || "❌ فشل إنشاء الدفع", "error");
      }
    } catch (err) {
      console.error(err);
      showAndHideMessage("❌ حدث خطأ أثناء الاتصال بالسيرفر", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      {/* ✅ الهيدر */}
      <div className="service-header">
        <h4>بوابة الدفع</h4>
      </div>

      {/* ✅ أيقونة البنك */}
      <div className="service-icon">
        <img
          src="/images/shambank.png"
          alt="Bank Icon"
          style={{ width: "120px", borderRadius: "22px" }}
        />
      </div>

      {/* ✅ العنوان والوصف */}
      <h2 className="service-title">💳 الدفع عبر SyriaCash</h2>
      <p className="service-desc">أدخل المبلغ المراد دفعه</p>

      {/* ✅ إدخال المبلغ */}
      <input
        type="number"
        placeholder="المبلغ بالليرة السورية"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        className="input-field"
      />

      {/* ✅ زر الدفع */}
      <button
        onClick={handlePayment}
        className="submit-btn"
        disabled={loading}
      >
        {loading ? "⏳ جاري المعالجة..." : `إتمام الدفع - ${amount || 0} ل.س`}
      </button>

      {/* ✅ عرض الرسالة */}
      {message.show && (
        <MessageDisplay
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: "", type: "", show: false })}
        />
      )}
    </div>
  );
}






function PaymentStatus() {
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [message, setMessage] = useState({ text: "", type: "", show: false });

  const token = localStorage.getItem("authToken");

  const showMessage = (text, type) => {
    setMessage({ text, type, show: true });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get("id");
    const orderId = params.get("order_id"); // نستقبله إذا مررته مع الرابط

    if (!pid) {
      showMessage("⚠️ لم يتم العثور على رقم العملية", "error");
      setLoading(false);
      return;
    }

    const checkPayment = async () => {
      try {
        const res = await fetch(
          `https://syriacash.app/new/api.php?checkPayment&token=${token}&paymentId=${pid}&order_id=${orderId}`
        );
        const data = await res.json();

        if (data.success) {
          setPaymentData(data);
          showMessage(data.message, "success");
        } else {
          showMessage(data.message || "❌ العملية فشلت", "error");
        }
      } catch (err) {
        console.error("Error checking payment:", err);
        showMessage("⚠️ خطأ في الاتصال بالسيرفر", "error");
      } finally {
        setLoading(false);
      }
    };

    checkPayment();
  }, [token]);

  return (
    <div className="service-container">
      <div className="service-header">
        <h4>التحقق من الدفع</h4>
      </div>

      <div className="service-icon">
        <img
          src="/images/shambank.png"
          alt="Check Payment"
          style={{ width: "120px", borderRadius: "22px" }}
        />
      </div>

      <h2 className="service-title">🔎 متابعة حالة الدفع</h2>

      {loading ? (
        <p className="loading-text">⏳ جاري التحقق...</p>
      ) : (
        <>
          {message.show && (
            <MessageDisplay
              message={message.text}
              type={message.type}
              onClose={() => setMessage({ text: "", type: "", show: false })}
            />
          )}

          {/* ✅ عرض تفاصيل الدفع إذا العملية ناجحة */}
          {paymentData && paymentData.success && (
            <div className="payment-details">
              <p>💰 المبلغ المدفوع: <strong>{paymentData.amount} ل.س</strong></p>
              <p>👤 العميل: <strong>{paymentData.client}</strong></p>
              <p>🆔 رقم الطلب: <strong>{paymentData.order_id || "غير متوفر"}</strong></p>
            </div>
          )}
        </>
      )}
    </div>
  );
}




function ShamPaymentCheck() {
  const [operationId, setOperationId] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [message, setMessage] = useState({ text: "", type: "", show: false });

  const token = localStorage.getItem("authToken");

  const showMessage = (text, type) => {
    setMessage({ text, type, show: true });
  };

  const handleCheckPayment = async () => {
    if ( operationId.length !== 8) {
      showMessage("⚠️ رقم العملية يجب أن يتكون من 8 خانات ويبدأ بـ 2", "error");
      return;
    }

    setLoading(true);
    setMessage({ text: "", type: "", show: false });
    setPaymentData(null);

    try {
      const res = await fetch(
        `https://syriacash.app/new/api.php?checkPaymentx&token=${token}&paymentId=${operationId}`
      );
      const data = await res.json();

      if (data.success) {
        setPaymentData(data);
        showMessage(data.message || "✅ العملية ناجحة", "success");
      } else {
        showMessage(data.message || "❌ العملية فشلت", "error");
      }
    } catch (err) {
      console.error("Error checking payment:", err);
      showMessage("⚠️ خطأ في الاتصال بالسيرفر", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-container">
      <div className="service-header">
        <h4>التحقق من عملية شام كاش</h4>
      </div>

      <div className="service-icon">
        <img
          src="/images/sham.jpg"
          alt="Sham Bank"
          style={{ width: "120px", borderRadius: "22px" }}
        />
      </div>

      <h2 className="service-title">📝 أدخل رقم العملية</h2>

      <input
        type="text"
        value={operationId}
        onChange={(e) => setOperationId(e.target.value)}
        placeholder="2xxxxxxx"
        maxLength={9}
        className="operation-input"
        style={{
          padding: "10px",
          fontSize: "18px",
          textAlign: "center",
          borderRadius: "8px",
          border: "1px solid #ccc",
          marginBottom: "15px",
          width: "100%",
          direction: "ltr",
        }}
      />

      <button
        type="button"
        onClick={handleCheckPayment}
        disabled={loading}
        style={{
          backgroundColor: loading ? "#aaa" : "#00670b",
          color: "white",
          padding: "12px",
          border: "none",
          borderRadius: "8px",
          cursor: loading ? "not-allowed" : "pointer",
          width: "100%",
          fontSize: "18px",
        }}
      >
        {loading ? "⏳ جاري التحقق..." : "🔎 تحقق الآن"}
      </button>

      {message.show && (
        <MessageDisplay
          message={message.text}
          type={message.type}
          onClose={() => setMessage({ text: "", type: "", show: false })}
        />
      )}

      {/* ✅ عرض تفاصيل الدفع إذا العملية ناجحة */}
      {paymentData && paymentData.success && (
        <div className="payment-details" style={{ marginTop: "20px" }}>
          <p>
            💰 المبلغ المدفوع: <strong>{paymentData.amount} ل.س</strong>
          </p>
          <p>
            👤 العميل: <strong>{paymentData.client}</strong>
          </p>
          <p>
            🆔 رقم الطلب:{" "}
            <strong>{paymentData.order_id || "غير متوفر"}</strong>
          </p>
        </div>
      )}
    </div>
  );
}




function ReferralPage() {
  const [referralLink, setReferralLink] = useState("");
  const [stats, setStats] = useState({ visits: 0, downloads: 0, earnings: 0 });
  const [referrals, setReferrals] = useState([]); // 🆕 بيانات الجدول
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (!token) {
      setMessage("❌ لم يتم تسجيل الدخول");
      setMessageType("error");
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`https://syriacash.app/new/api.php?referralStats&token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setReferralLink(data.referralLink || "");
          setStats({
            visits: data.visits || 0,
            downloads: data.downloads || 0,
            earnings: data.earnings || 0,
            point: data.point || 0,
          });
          setReferrals(data.referrals || []); // 🆕 حفظ بيانات الجدول
          setMessage("");
        } else {
          setMessage("❌ فشل جلب الإحصائيات");
          setMessageType("error");
        }
      })
      .catch(() => {
        setMessage("❌ خطأ في الاتصال بالخادم");
        setMessageType("error");
      })
      .finally(() => setLoading(false));
  }, [token]);

  const handleCopy = () => {
    if (!referralLink) return;
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        setMessage("✅ تم نسخ رابط الإحالة");
        setMessageType("success");
      })
      .catch(() => {
        setMessage("❌ لم يتم النسخ");
        setMessageType("error");
      });
  };

  const handleShare = () => {
    if (!referralLink) return;
    const text = `بنصحك بتحميل تطبيق سوريا كاش، فيه عروض كتيرة ورخيصة 😍 رابط التحميل من متجر غوغل بلاي: ${referralLink}`;
    const encodedText = encodeURIComponent(text);
    window.location.href = `/sharing/${encodedText}`;
  };

  // 🧮 حساب الإجمالي
  const totalPurchases = referrals.reduce((sum, r) => sum + (r.totalPurchases || 0), 0);
  const totalEarnings = referrals.reduce((sum, r) => sum + (r.earnings || 0), 0);

  return (
    <div style={{ padding: "30px 15px", backgroundColor: "#f7f7f7", minHeight: "100vh", marginTop: "54px", direction: "rtl", textAlign: "right" }}>
      {message && (
        <div
          style={{
            marginBottom: 20,
            padding: 15,
            borderRadius: 6,
            color: messageType === "success" ? "green" : "red",
            backgroundColor: messageType === "success" ? "#e6ffe6" : "#ffe6e6",
            border: `1px solid ${messageType === "success" ? "green" : "red"}`,
            cursor: "pointer",
          }}
          onClick={() => setMessage("")}
        >
          {message} (اضغط هنا لإخفاء)
        </div>
      )}

      <div style={{ maxWidth: 800, margin: "auto", backgroundColor: "white", borderRadius: 12, padding: 25, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
        <h2 style={{ marginBottom: 20, color: "#1f2937" }}>رابط الإحالة الخاص بك</h2>

        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 15 }}>
          <input
            type="text"
            readOnly
            value={referralLink}
            style={{ flexGrow: 1, padding: 12, fontSize: 16, borderRadius: 6, border: "1px solid #ccc", direction: "ltr", userSelect: "all" }}
            onClick={(e) => e.target.select()}
          />
          <button onClick={handleCopy} style={{ padding: "10px 16px", backgroundColor: "#2563eb", color: "white", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}>
            📋 نسخ
          </button>
        </div>

        <div style={{ marginTop: 15, textAlign: "center" }}>
          <button
            onClick={handleShare}
            style={{
              padding: "12px 25px",
              backgroundColor: "#10b981",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: 16,
              boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#0f766e")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#10b981")}
          >
            📤 اضغط لمشاركة الرابط
          </button>
        </div>

  <p
  style={{
    backgroundColor: "#fffbe6",
    padding: "15px",
    borderRadius: "8px",
    color: "#92400e",
    fontSize: "15px",
    lineHeight: 1.5,
    marginTop: 20,
  }}
>
  💡 يمكنك مشاركة هذا الرابط مع أصدقائك، وعند تسجيلهم من خلالك وإتمامهم عملية شراء، ستحصل على مكافأة مالية تضاف إلى رصيدك تلقائيًا.
  
 
</p>
        <h3 style={{ marginTop: 30, marginBottom: 15 }}>إحصائيات الإحالة</h3>

        {loading ? (
          <p>⏳ جاري تحميل الإحصائيات...</p>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-around", gap: 20, textAlign: "center", flexWrap:  "wrap"  ,  fontSize: 18 }}>
              <div style={{ backgroundColor: "#dbeafe", borderRadius: 8, padding: 15, flex: 1 }}>
                <div style={{ fontWeight: "bold", fontSize: 30, color: "#2563eb" }}>{stats.visits}</div>
                <div>عدد عمليات التسجيل</div>
              </div>
              <div style={{ backgroundColor: "#dcfce7", borderRadius: 8, padding: 15, flex: 1 }}>
                <div style={{ fontWeight: "bold", fontSize: 30, color: "#22c55e" }}>{stats.downloads}</div>
                <div>عدد الإحالات الناجحة</div>
              </div>
          
                  <div style={{ backgroundColor: "#e4c4e1ff", borderRadius: 8, padding: 15, flex: 1 }}>
                <div style={{ fontWeight: "bold", fontSize: 30, color: "#000000ff" }}>{stats.earnings} ₺</div>
                <div>الأرباح الإجمالية</div>
              </div>
            </div>

            {/* 🧾 جدول الأرباح */}
            <h3 style={{ marginTop: 40, marginBottom: 15 }}>تفاصيل الأرباح من المستخدمين</h3>

            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", fontSize: 15 }}>
                <thead style={{ backgroundColor: "#f3f4f6" }}>
                  <tr>
                    <th style={{ border: "1px solid #ddd", padding: 10 }}>رقم الحساب</th>
                    <th style={{ border: "1px solid #ddd", padding: 10 }}>إجمالي عمليات الشراء</th>
                    <th style={{ border: "1px solid #ddd", padding: 10 }}>الأرباح</th>
                  </tr>
                </thead>
                <tbody>
                  {referrals.length > 0 ? (
                    referrals.map((r, i) => (
                      <tr key={i}>
                        <td style={{ border: "1px solid #eee", padding: 10 }}>{r.account}</td>
                        <td style={{ border: "1px solid #eee", padding: 10 }}>{r.totalPurchases.toLocaleString()} ل.س</td>
                        <td style={{ border: "1px solid #eee", padding: 10, color: "#16a34a", fontWeight: "bold" }}>
                          {r.earnings.toLocaleString()} ل.س
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ padding: 15, color: "#888" }}>
                        لا توجد بيانات بعد
                      </td>
                    </tr>
                  )}
                </tbody>
                {referrals.length > 0 && (
                  <tfoot style={{ backgroundColor: "#f9fafb", fontWeight: "bold" }}>
                    <tr>
                      <td style={{ border: "1px solid #ddd", padding: 10 }}>الإجمالي</td>
                      <td style={{ border: "1px solid #ddd", padding: 10 }}>{totalPurchases.toLocaleString()} ل.س</td>
                      <td style={{ border: "1px solid #ddd", padding: 10, color: "#dc2626" }}>
                        {totalEarnings.toLocaleString()} ل.س
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}








function ServPage() {
  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4 service-page-title">خدمات سريعة</h2>

      <div className="row gx-3 gy-3">
        {/* زر/بطاقة: حركة الحساب */}
        <div className="col-12 mb-3"> {/* زر على امتداد الصفحة */}
          <Link to="/tranmony" className="service-full-width-btn">
            <i className="fas fa-chart-line service-full-width-icon"></i>
            <span>حركة الحساب</span>
          </Link>
        </div>

        {/* أيقونة: تعبئة الرصيد (ServiceMtn) */}
        <div className="col-6">
          <Link to="/recharge-balance" className="service-card-item">
            <i className="fas fa-mobile-alt service-card-icon"></i>
            <span>تعبئة الرصيد</span>
          </Link>
        </div>

        {/* أيقونة: تحويل داخلي */}
        <div className="col-6">
          <Link to="/internal-transfer" className="service-card-item">
            <i className="fas fa-exchange-alt service-card-icon"></i>
            <span>تحويل داخلي</span>
          </Link>
        </div>

        {/* أيقونة: تحويل خارجي */}
        <div className="col-6">
          <Link to="/external-transfer" className="service-card-item">
            <i className="fas fa-globe service-card-icon"></i>
            <span>تحويل خارجي</span>
          </Link>
        </div>

        {/* أيقونة: تصريف العملات */}
        <div className="col-6">
          <Link to="/currency-exchange" className="service-card-item">
            <i className="fas fa-coins service-card-icon"></i>
            <span>تصريف العملات</span>
          </Link>
        </div>
      </div>
    </div>
  );
}


function Sguinup() {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false); // ✅ حالة النافذة
  const [pendingSubmit, setPendingSubmit] = useState(false); // لتخزين هل يريد التسجيل

  /* ---------------- التحقق من الحقول ---------------- */
  const validateForm = () => {
    if (!phoneNumber.trim()) return "يرجى إدخال رقم الهاتف";
if (!/^09\d{8}$/.test(phoneNumber))
  return "يرجى إدخال رقم الهاتف بالشكل الصحيح (مثال: 09xxxxxxxx)";
    if (!name.trim()) return "يرجى إدخال الاسم الكامل";
    if (!email.trim()) return "يرجى إدخال البريد الإلكتروني";
    if (!/\S+@\S+\.\S+/.test(email)) return "صيغة البريد الإلكتروني غير صالحة";
    if (!password.trim()) return "يرجى إدخال كلمة المرور";
    if (password.length < 6) return "يجب أن تكون كلمة المرور 6 أحرف على الأقل";
    if (password !== confirmPassword) return "كلمة المرور وتأكيدها غير متطابقين";
    return "";
  };

  /* ---------------- عند محاولة التسجيل ---------------- */
  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validateForm();
    if (err) {
      setError(err);
      return;
    }
    setError("");
    // فتح النافذة قبل الإرسال
    setPendingSubmit(true);
    setShowModal(true);
  };

  /* ---------------- عند الموافقة على الاتفاقية ---------------- */


const confirmAgreement = async () => {
  setShowModal(false);

  try {
    const res = await fetch("https://syriacash.app/new/api.php?register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phoneNumber, name, email, password }),
    });

    const data = await res.json();
    if (data.success) {
      // حفظ معلومات الدخول تلقائيًا
      localStorage.setItem("phoneNumber", phoneNumber);
      localStorage.setItem("password", password);
      localStorage.setItem("loggedIn", "true");
      localStorage.setItem("username", name); // أو أي حقل مناسب من الـ API
      localStorage.setItem("authToken", data.token || ""); // إذا أرسل السيرفر توكن
      localStorage.setItem("accountNumber", data.accountNumber || "");
      localStorage.setItem("accountname", name);
      localStorage.setItem("userAvatar", data.icon || "https://syriacash.app/images/user.png");

      // إعادة توجيه إلى الصفحة الرئيسية مباشرة بعد التسجيل
      navigate("/home");
    } else {
      setError(data.message || "فشل في إنشاء الحساب. يرجى المحاولة مرة أخرى.");
    }
  } catch (err) {
    setError("حدث خطأ في الاتصال بالخادم، يرجى التحقق من الإنترنت.");
    console.error(err);
  }
};







  return (
    <div className="signup-container">
      <div className="signup-card">
        <header className="signup-header">
          <h2 className="signup-title">إنشاء حساب جديد</h2>
        </header>

        <form onSubmit={handleSubmit} style={{ padding: "0 28px 32px" }}>
          {/* الهاتف */}
          <div className="form-group">
            <label htmlFor="phoneNumber" className="form-label">رقم الهاتف</label>
            <input
            inputMode="numeric"
  
              id="phoneNumber"
              className="form-input"
              type="tel"
              placeholder="09xxxxxxxx"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>

          {/* الاسم */}
          <div className="form-group">
            <label htmlFor="name" className="form-label">الاسم الكامل</label>
            <input
              id="name"
              className="form-input"
              type="text"
              placeholder="اسمك الكامل"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          {/* البريد */}
          <div className="form-group">
            <label htmlFor="email" className="form-label">البريد الإلكتروني</label>
            <input
              id="email"
              className="form-input"
              type="email"
              placeholder="example@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* كلمة المرور */}
          <div className="form-group">
            <label htmlFor="password" className="form-label">كلمة المرور</label>
            <input
              id="password"
              className="form-input"
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {/* تأكيد كلمة المرور */}
          <div className="form-group">
            <label htmlFor="confirmPassword" className="form-label">تأكيد كلمة المرور</label>
            <input
              id="confirmPassword"
              className="form-input"
              type="password"
              placeholder="********"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          {/* رسائل الحالة */}
          {error   && <p className="error-message">{error}</p>}
          {message && <p className="success-message">{message}</p>}

          {/* زر الإرسال */}
          <button className="submit-button" type="submit">إنشاء حساب</button>
        </form>
      </div>

      {/* ✅ النافذة المنبثقة */}
      {showModal && (

<div className="modal-overlay">
  <div className="modal-content">

    <h3>اتفاقية الاستخدام</h3>

    {/* صندوق النص مع التمرير */}
    <div
      style={{
        maxHeight: "300px",       // يمكنك رفعها أو خفضها حسب الحاجة
        overflowY: "auto",
        paddingRight: "10px"
      }}
    >
      <p>
        عزيزي المستخدم، نود إيضاح ما يلي:<br /><br />

        <strong>1. طبيعة عمل التطبيق:</strong><br />
        تطبيق <strong>سوريا كاش دلفري</strong> هو منصة لطلب وشراء المنتجات مع خدمة التوصيل، 
        ولا يعمل كتطبيق حوالات أو كمحفظة إلكترونية أو كجهة مالية.<br /><br />

        <strong>2. عدم الارتباط بالجهات المالية:</strong><br />
        لا تربطنا أي علاقة بتطبيقات الحوالات مثل شام كاش، 
        كما لا تربطنا أي علاقة بالبنوك السورية أو الرواتب أو أي خدمات مالية حكومية.<br /><br />

        <strong>3. مسؤولية المستخدم:</strong><br />
        المستخدم مسؤول بشكل كامل عن صحة بيانات حسابه ومعلومات الطلبات وطرق التواصل الخاصة به داخل التطبيق.<br /><br />

        <strong>4. حدود المسؤولية:</strong><br />
        يقتصر دورنا على توفير المنتجات وإيصالها فقط، ولا نتحمل أي مسؤولية عن أي عمليات مالية خارج التطبيق 
        أو أي التباس بين اسم التطبيق وأي خدمة أخرى.<br /><br />

        باستخدامك للتطبيق، فإنك توافق على جميع البنود المذكورة أعلاه.
      </p>
    </div>

    <div className="modal-actions">
      <button onClick={confirmAgreement} className="btn-accept">موافق</button>
      <button onClick={() => setShowModal(false)} className="btn-cancel">إلغاء</button>
    </div>

  </div>
</div>



      )}
    </div>
  );
}



function SignupSuccess() {
  return (
    <div className="success-container">
      <div className="success-box">
        <h1>🎉 تم إنشاء حسابك بنجاح</h1>
        <p>يمكنك الآن تسجيل الدخول إلى حسابك.</p>
        <Link to="/" className="login-linkx">
          اضغط هنا لتسجيل الدخول
        </Link>
      </div>
    </div>
  );

}








function LoginForm() {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const [showAgreement, setShowAgreement] = useState(false);
  const [loadingGuest, setLoadingGuest] = useState(false);
  const [loadingLogin, setLoadingLogin] = useState(false);

  // 🟢 تحميل بيانات المستخدم المحفوظة إذا وجدت
  useEffect(() => {
    const savedPhone = localStorage.getItem('phoneNumber') || sessionStorage.getItem('phoneNumber') || '';
    const savedPassword = localStorage.getItem('password') || sessionStorage.getItem('password') || '';
    const savedRemember = localStorage.getItem('phoneNumber') !== null;
    setPhoneNumber(savedPhone);
    setPassword(savedPassword);
    setRememberMe(savedRemember);
  }, []);

  // 🟢 تتبع رابط الإحالة
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("referralCode", ref);
      fetch(`https://syriacash.app/new/api.php?referralVisit&ref=${ref}`)
        .catch(() => {});
    }
  }, []);

  // 🟢 تسجيل الدخول العادي
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) return setError('يرجى إدخال رقم الهاتف');
    if (!password.trim()) return setError('يرجى إدخال كلمة المرور');
    setError('');
    setLoadingLogin(true);

    fetch('https://syriacash.app/new/apilogin.php?login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phoneNumber, password }),
    })
      .then(res => res.json())
      .then(data => {
        setLoadingLogin(false);

        if (data.success) {
          const storage = rememberMe ? localStorage : sessionStorage;
          localStorage.setItem('authToken', data.token);
          storage.setItem('username', data.username);
          localStorage.setItem('accountNumber', data.accountNumber);
          localStorage.setItem('accountname', data.name);
          storage.setItem('userAvatar', data.icon);
          localStorage.setItem('loggedIn', 'true');
          storage.removeItem('isGuest');
  
          if (rememberMe) {
            storage.setItem('phoneNumber', phoneNumber);
            storage.setItem('password', password);
          } else {
            storage.removeItem('phoneNumber');
            storage.removeItem('password');
          }

          navigate('/home');
        } else {
          setError(data.message || 'خطأ في تسجيل الدخول');
        }
      })
      .catch(() => {
        setLoadingLogin(false);
        setError('حدث خطأ في الاتصال بالخادم');
      });
  };

  // 🟢 تسجيل دخول الزائر
  const handleGuestLogin = () => {
    setShowAgreement(true);
  };

  const confirmGuestLogin = (auto = false) => {
    setLoadingGuest(true);

    fetch('https://syriacash.app/new/create_guest.php')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          localStorage.setItem("authToken", data.token);
          localStorage.setItem("username", data.name);
          localStorage.setItem("accountNumber", data.accountNumber);
          localStorage.setItem("accountname", data.name);
          localStorage.setItem("userAvatar", "https://syriacash.app/images/user.png");
          localStorage.setItem("loggedIn", "true");
          localStorage.setItem("isGuest", "true");

          setTimeout(() => {
            setLoadingGuest(false);
            if (!auto) setShowAgreement(false);
          
const redirectPath = localStorage.getItem("redirectAfterLogin");
if (redirectPath) {
  localStorage.removeItem("redirectAfterLogin"); // مسح الرابط بعد الاستخدام
  navigate(redirectPath, { replace: true }); // التوجيه للرابط المحفوظ
} else {
  navigate("/home", { replace: true });
}



          }, 1500);
        } else {
          alert("حدث خطأ أثناء إنشاء حساب الزائر");
          setLoadingGuest(false);
        }
      })
      .catch(() => {
        alert("فشل الاتصال بالخادم");
        setLoadingGuest(false);
      });
  };

  // 🟢 تسجيل دخول الزائر تلقائيًا إذا لم يكن هناك مستخدم مسجل
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const isLoggedIn = localStorage.getItem("loggedIn");
const out = localStorage.getItem("out");
    if ( !out) {
      // تسجيل دخول الزائر تلقائيًا بدون عرض الاتفاقية
      confirmGuestLogin(true);
    }
      

  }, []);

  return (
    <>
      <form onSubmit={handleSubmit} className="login-form-body">

        <div className="mb-3">
          <label className="form-label">رقم الهاتف</label>
          <div className="form-control-icon">
            <input
              type="tel"
              inputMode="numeric"
              className="form-control"
              placeholder="09XXXXXXXX"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <i className="fas fa-phone-alt input-icon"></i>
          </div>
        </div>

        <div className="mb-3" dir="rtl">
          <label className="form-label">كلمة المرور</label>
          <div className="position-relative">
            <i className="fas fa-lock"
              style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', color: '#999' }}></i>

            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control pe-5 ps-5"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              dir="rtl"
            />

            <i
              className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
              style={{
                position: 'absolute',
                top: '50%',
                left: '10px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#999'
              }}
              onClick={() => setShowPassword(!showPassword)}
            ></i>
          </div>
        </div>

        <div className="row align-items-center mb-4">
          <div className="col-auto">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              <label className="form-check-label">تذكرني</label>
            </div>
          </div>
          <div className="col-auto">
            <a href="/pass" className="forgot-password-link">نسيت كلمة المرور؟</a>
          </div>
        </div>

        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

        <button type="submit" className="btn btn-primary w-100 mb-2">
          تسجيل الدخول
        </button>

        <button
          type="button"
          onClick={handleGuestLogin}
          className="btn btn-outline-secondary w-100"
          style={{ color: "#003366", fontWeight: "bold", fontSize: "16px" }}
        >
          تسجيل الدخول كزائر
        </button>

        <div className="create-account-link mt-3">
          <p>
            إنشاء حساب جديد <a href="/sguinup">ليس لديك حساب؟</a>
          </p>
        </div>
      </form>

      {/* نافذة اتفاقية الزائر */}
      {showAgreement && (
        <div className="agreement-overlay">
          <div className="agreement-box animate__animated animate__fadeInDown">
            <h4>📜 اتفاقية استخدام الزائر</h4>
            <p>
              باستخدامك الدخول كزائر، فإنك توافق على الشروط التالية:
              <br />- لن يتم حفظ بياناتك بعد تسجيل الخروج.
              <br />- بعض الميزات ستكون محدودة.
              <br />- يمكن الترقية لحساب دائم لاحقًا.
            </p>

            <div className="mt-4 d-flex justify-content-between">
              <button
                className="btn btn-secondary"
                onClick={() => setShowAgreement(false)}
              >
                إلغاء
              </button>

              <button className="btn btn-success" onClick={() => confirmGuestLogin()}>
                {loadingGuest ? "جاري تسجيل الدخول..." : "موافق و متابعة"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* شاشة انتظار تسجيل الدخول */}
      {loadingLogin && (
        <div className="loading-overlay">
          <div className="loading-box">
            <div className="spinner"></div>
            <p>جاري التحقق من البيانات...</p>
          </div>
        </div>
      )}

      <style>{`
        .agreement-overlay, .loading-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex; align-items: center; justify-content: center;
          z-index: 9999;
        }

        .agreement-box, .loading-box {
          background: #fff;
          padding: 25px;
          border-radius: 15px;
          width: 90%;
          max-width: 350px;
          text-align: center;
          box-shadow: 0 5px 20px rgba(0,0,0,0.2);
          direction: rtl;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #ddd;
          border-top-color: #007bff;
          border-radius: 50%;
          margin: 0 auto 15px;
          animation: spin 0.7s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}


function Spourt() {
  const [supportPhone, setSupportPhone] = useState("");
  const [loading, setLoading] = useState(true);
  const [seconds, setSeconds] = useState(3);

  const token = localStorage.getItem("authToken");

  // جلب رقم واتساب من API
  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    fetch(`https://syriacash.app/new/api.php?schik&token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.support_phone) {
          setSupportPhone(data.support_phone);
        }
      })
      .catch(() => console.warn("فشل جلب رقم الدعم"))
      .finally(() => setLoading(false));
  }, [token]);

  const clientName =
    localStorage.getItem("accountname") || "مستخدم";

  const accountNumber =
    localStorage.getItem("accountNumber") || "غير محدد";

  const message = encodeURIComponent(
    `مرحباً 👋\nأنا ${clientName}\nرقم الحساب: ${accountNumber}\nأرغب بالتواصل مع الدعم الفني.`
  );

  const whatsappLink = supportPhone
    ? `https://wa.me/${supportPhone}?text=${message}`
    : "";

  // عدّ تنازلي + تحويل تلقائي
  useEffect(() => {
    if (loading || !supportPhone) return;

    if (seconds === 0) {
      window.location.href = whatsappLink;
      return;
    }

    const timer = setTimeout(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [seconds, loading, supportPhone, whatsappLink]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f3f6f4",
        direction: "rtl",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          textAlign: "center",
          maxWidth: "420px",
        }}
      >
        <h3>📱 التواصل عبر واتساب</h3>

        {loading ? (
          <p>⏳ جارٍ تجهيز التحويل...</p>
        ) : !supportPhone ? (
          <p style={{ color: "red" }}>
            ⚠️ رقم واتساب الدعم غير متوفر حالياً
          </p>
        ) : (
          <>
            <p style={{ fontSize: "16px", marginBottom: "10px" }}>
              سيتم تحويلك إلى واتساب للتواصل مع الدعم الفني
            </p>

            <p style={{ fontWeight: "bold", marginBottom: "15px" }}>
              التحويل خلال ⏱️ {seconds} ثوانٍ
            </p>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                background: "#25D366",
                color: "#fff",
                padding: "12px 25px",
                borderRadius: "8px",
                textDecoration: "none",
                fontSize: "16px",
              }}
            >
              فتح واتساب الآن
            </a>
          </>
        )}
      </div>
    </div>
  );
}



function PasswordResetForm() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [step, setStep] = useState(1); // 1: إدخال الرقم | 2: إدخال الرمز وكلمة السر
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmitPhone = (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      setError('يرجى إدخال رقم الهاتف');
      return;
    }

    setError('');
    setSuccessMessage('');

    // إرسال الطلب للتحقق من رقم الهاتف
    fetch('https://syriacash.app/new/api.php?reset_password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phoneNumber }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
  setSuccessMessage('✅ تم إرسال رمز التأكيد إلى بريدك الإلكتروني ورسالة نصية (واتساب) إلى رقم هاتفك المسجل.');

          setStep(2);
        } else {
          setError(data.message || '❌ تعذر استعادة كلمة المرور');
        }
      })
      .catch(() => setError('حدث خطأ في الاتصال بالخادم'));
  };

  const handleSubmitReset = (e) => {
    e.preventDefault();

    if (!verificationCode.trim() || !newPassword.trim() || !confirmPassword.trim()) {
      setError('يرجى تعبئة جميع الحقول');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('كلمتا المرور غير متطابقتين');
      return;
    }

    setError('');
    setSuccessMessage('');

    // إرسال البيانات لتحديث كلمة المرور
    fetch('https://syriacash.app/new/api.php?confirm_reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phoneNumber, verificationCode, newPassword }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
  setSuccessMessage(' تم تغيير كلمة المرور بنجاح توجه لصفحة تسجيل الدخول  ✅ ');
          setStep(1);
          setPhoneNumber('');
          setVerificationCode('');
          setNewPassword('');
          setConfirmPassword('');
        } else {
          setError(data.message || 'فشل في تحديث كلمة المرور');
        }
      })
      .catch(() => setError('حدث خطأ في الاتصال بالخادم'));
  };

  return (
    <div className="new">
      <div className="login-container">
        <div className="header-section">
          <div className="profile-icon">
            <img
              src="images/logo.png"
              alt="شعار التطبيق"
              style={{ width: '60px', height: '60px', borderRadius: '50%' }}
            />
          </div>
          <h2>استعادة كلمة المرور</h2>
          <p>{step === 1 ? 'أدخل رقم هاتفك لاستعادة كلمة المرور' : 'أدخل الرمز وكلمة المرور الجديدة'}</p>
        </div>

        <form onSubmit={step === 1 ? handleSubmitPhone : handleSubmitReset} className="login-form-body">
          {step === 1 && (
            <div className="mb-3">
              <label htmlFor="phoneNumber" className="form-label">
                رقم الهاتف
              </label>
              <div className="form-control-icon">
                <input
                  type="tel"
inputMode="numeric"
  

                  className="form-control"
                  id="phoneNumber"
                  placeholder="09XXXXXXXX"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <i className="fas fa-phone-alt input-icon"></i>
              </div>
            </div>
          )}

          {step === 2 && (
            <>
              <div className="mb-3">
                <label className="form-label">رمز التأكيد</label>
                <input
                  type="text"
                  className="form-control"
        placeholder=" أدخل الرمز المرسل إلى البريد او رسالة لهاتفك"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">كلمة السر الجديدة</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="أدخل كلمة السر الجديدة"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">تأكيد كلمة السر</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="أعد إدخال كلمة السر"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </>
          )}

          {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
          {successMessage && <p style={{ color: 'green', textAlign: 'center' }}>{successMessage}</p>}

          <button type="submit" className="btn btn-primary">
            {step === 1 ? 'استعادة كلمة المرور' : 'تأكيد التغيير'}
          </button>

          <div className="create-account-link mt-3">
            <p>
              العودة إلى <a href="/">تسجيل الدخول</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

function InternetStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setVisible(true);
      setTimeout(() => setVisible(false), 2500);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setVisible(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: isOnline ? "#28a745" : "#dc3545",
        color: "#fff",
        padding: "12px 30px",
        borderRadius: "30px",
        fontWeight: "bold",
        boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
        zIndex: 9999,
        fontSize: "15px",
        transition: "all 0.5s ease",
        textAlign: "center",
      }}
    >
      {isOnline ? "✅ تم استعادة الاتصال بالإنترنت" : "⚠️ لا يوجد اتصال بالإنترنت"}
    </div>
  );
}





function Whatsapp() {
  const { phone, text } = useParams(); // استلام البارامترات من الرابط

  useEffect(() => {
    if (!phone) return;

    const phoneNumber = phone; // يمكن استخدام parseInt(phone) إذا كان رقم فقط
    const messageText = decodeURIComponent(text || ""); // فك ترميز النص
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${messageText}`;

    // تحويل المستخدم مباشرة للواتساب
    window.location.href = whatsappURL;
  }, [phone, text]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <p>جاري تحويلك إلى واتساب...</p>
    </div>
  );
}









function App() {
  const location = useLocation();
   useOneSignalAuto();
  // حدد المسارات التي تريد عرض Navbar فيها
 const showNavbarPatterns = [
  '/home',
  '/oreder',
  '/services',
  '/mtn',
  '/transfer',
  '/exchange',
  '/servpage',
  '/tranmony',
  '/notifications',
  '/syriatel',
  '/recharge-balance',
  '/starlink',
  '/internal-transfer',
  '/currency-exchange',
  '/mtnf',
  '/syriatelf',
    '/passc',
     '/chatgpt',
'/carreport',
'/payment-trigger',

'/shop',
'/referra',
'/shampay',


'/store',
'/liststoreru/:id',

'/liststore',

'/spuort',

'/payment-callback',

'/missing-account-note',

'/product/:id',

'/products/:id',
'/productsopen/:id',

'/liststore/:id',


'/liststorer/:id',

'/belding',



'/meat-selection',

'/cart',


'/community',

'/openshop',
'/unvercity',

'/openshopmy',

'/fast',

'/outb',

'/editproduct/:id',

'/foodsearch',
"/ofers",
'/copon',

"/services-custom",

"/serviceprovider/:id",
"/myservice",

'/addpro',
'/appointments',

'/samanet',
  '/account/:id'  // هذا مسار ديناميكي
];



const showNavbar = showNavbarPatterns.some(pattern => match(pattern)(location.pathname));







  const guestBlockedPaths = [
    "/referra",
    "/addpro",
     "/starlink",
 "/mtn",
 "/syriatel",

 "/mtnf",
 "/syriatelf",
"/samanet",




    "/openshopmy",
    "/appointments",
    "/internal-transfer",
    "/currency-exchange",
    "/tranmony",
    "/shampay",
    "/payment-callback",
    "/spuort",
    "/passc",
    "/account/:id"
  ];


// تحقق إذا كانت الصفحة ممنوعة للزائر
const isGuestBlocked = (pathname) => {
  return guestBlockedPaths.some((path) => {
    // دعم المسارات الديناميكية :id
    if (path.includes(":")) {
      const pattern = new RegExp("^" + path.replace(/:\w+/g, "\\w+") + "$");
      return pattern.test(pathname);
    }
    return path === pathname;
  });
};






useEffect(() => {
  const loggedIn = localStorage.getItem("loggedIn");
  const isGuest = localStorage.getItem("isGuest");

  const allowedPaths = ["/", "/sguinup", "/signup-success"];

  // غير مسجل ولا زائر → تحويل لصفحة الدخول
  if (!loggedIn && !isGuest && !allowedPaths.includes(location.pathname)) {
    window.location.href = "/";
    return;
  }

  // الزائر يحاول دخول صفحة ممنوعة → تحويل إلى صفحة محددة
  if (isGuest ) {
    if (isGuestBlocked(location.pathname)) {
      window.location.href = "/outb"; // ← كل الصفحات الممنوعة تذهب هنا
    }
  }
}, [location.pathname]);


  return (
    <>
      {showNavbar && <Navbar />}

      <Routes>
        <Route
          path="/"
          element={
            <div className="new">
              <div className="login-container">
                <div className="header-section">
                  <div className="profile-icon">
                    <img
    src="images/logo.png"  // ← عدل المسار حسب مكان الشعار
    alt="شعار التطبيق"
    style={{ width: '60px', height: '60px', borderRadius: '50%' }} // ← تعديل الشكل حسب الحاجة
  />
                  </div>
                  <h2>تسجيل الدخول</h2>
                  <p>أدخل بياناتك للوصول إلى حسابك</p>
                </div>
                <LoginForm />
              </div>
            </div>
          }
        />
        <Route path="/home" element={<HomePage />} />
           <Route path="/oreder" element={<OrdersPage  />} />



                    <Route path="/services" element={<BankServices  />} />

      <Route path="/shop" element={<BankShop  />} />

  <Route path="/ofers" element={<OfersShop  />} />


 <Route path="/fast" element={<Storer  />} />

<Route path="/copon" element={<BankShopc  />} />

<Route path="/unvercity" element={<BankShopu  />} />

<Route path="/belding" element={<BankShopb  />} />

<Route path="/mystore" element={<MyStorePanel />} />


                     <Route path="/mtn" element={<ServiceMtn  />} />
                          <Route path="/internal-transfer" element={<InternalTransfer  />} />
<Route path="/currency-exchange" element={<CurrencyExchange  />} />
<Route path="/servpage" element={<ServPage  />} />
                    
<Route path="/tranmony" element={<FinancialActivityPage  />} />


<Route path="/notifications" element={<NotificationsPage />} />

<Route path="/sguinup" element={<Sguinup />} />
<Route path="/signup-success" element={<SignupSuccess />} />
   
   <Route path="/syriatel" element={<ServiceSriatel />} />
   

<Route path="/services-custom" element={<ServicesPage />} />
<Route path="/serviceprovider/:id" element={<ServiceProviderPage />} />
<Route path="/myservice" element={<MyServicePanel />} />






 <Route path="/pass" element={<PasswordResetForm />} />
<Route path="/starlink" element={<ServiceStarlink />} />

  <Route path="/account/:id" element={<AccountDetails />} />

  <Route path="recharge-balance" element={< PaymentMethods   />} />

  <Route path="/mtnf" element={<ServiceMtnf  />} />
<Route path="/syriatelf" element={<ServiceSriatelf  />} />

<Route path="/passc" element={<ChangePasswordForm  />} />
<Route path="/chatgpt" element={<Chatgpt  />} />

<Route path="/carreport" element={<CarReport  />} />

<Route path="/samanet" element={<SamaNet  />} />

<Route path="/meat-selection" element={<MeatSelection />} />

 <Route path="/products/:id" element={<ProductDetailss />} />

<Route path="/productsopen/:id" element={<ProductDetailsopen />} />


 <Route path="/referra" element={<ReferralPage />} />

<Route path="/shampay" element={<PaymentPage />} />

 <Route path="/payment-callback" element={<PaymentStatus />} />

 <Route path="/missing-account-note" element={<ShamPaymentCheck />} />


 <Route path="/spuort" element={<Spourt />} />


 <Route path="/store" element={<Store />} />
<Route path="/appointments" element={<BankShopd />} />

    <Route path="/community" element={<CommunityWall />} />

<Route path="/foodsearch" element={<FoodSearchPage />} />
    
     <Route path="/liststore/:id" element={<ListStore />} />

  <Route path="/liststorer/:id" element={<ListStorer />} />

  <Route path="/liststoreru/:id" element={<ListStoreru />} />

     <Route path="/cart" element={<CartAndProducts  />} />
 <Route path="/outb" element={<Outb  />} />

 

<Route path="/openshop" element={<OpenShop />} />
<Route path="/openshopmy" element={<OpenShopMy />} />



 <Route path="/addpro" element={<AddProductForm  />} />
 <Route path="/whatsapp/:phone/:text" element={<Whatsapp />} />

<Route path="/editproduct/:id" element={<EditProductForm />} />

<Route path="/myrestaurant" element={<MyRestaurantPanel />} />



  <Route path="*" element={<Navigate to="/home" replace />} />


      </Routes>

          <div style={{
          textAlign: 'center',
          padding: '10px',
          fontSize: '14px',
          color: '#888',
              height: '84px'
        }}>
         
        </div>
         <InternetStatus />
 {showNavbar && <BottomNavbar />}
 
      <InstallPrompt />
    </>
  );
}





export default App;

